var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBerisfordsHocusPocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "381px",
    height: "1961px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 381 1960",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\n    .str0 {stroke:black;stroke-width:8.85525}\n    .fil169 {fill:none}\n    .fil142 {fill:#171D1C}\n    .fil136 {fill:#1B201F}\n    .fil32 {fill:#1D2322}\n    .fil111 {fill:#212626}\n    .fil129 {fill:#232827}\n    .fil112 {fill:#252A2A}\n    .fil123 {fill:#272D2C}\n    .fil52 {fill:#2A2D2C}\n    .fil120 {fill:#2A2E2E}\n    .fil153 {fill:#2A302F}\n    .fil152 {fill:#2A3433}\n    .fil132 {fill:#2B3030}\n    .fil99 {fill:#2C3130}\n    .fil79 {fill:#2D302F}\n    .fil98 {fill:#2E3231}\n    .fil22 {fill:#2E3434}\n    .fil131 {fill:#2F3433}\n    .fil105 {fill:#313433}\n    .fil116 {fill:#323635}\n    .fil119 {fill:#333836}\n    .fil126 {fill:#343636}\n    .fil117 {fill:#353738}\n    .fil127 {fill:#353937}\n    .fil93 {fill:#363A39}\n    .fil67 {fill:#363B3B}\n    .fil41 {fill:#383B3A}\n    .fil33 {fill:#383D3A}\n    .fil97 {fill:#3A3C3C}\n    .fil95 {fill:#3A3E3D}\n    .fil89 {fill:#3B403E}\n    .fil135 {fill:#3C241A}\n    .fil90 {fill:#3C3F3C}\n    .fil37 {fill:#3E413E}\n    .fil14 {fill:#3E4241}\n    .fil154 {fill:#3E4343}\n    .fil137 {fill:#414646}\n    .fil58 {fill:#424542}\n    .fil86 {fill:#45291C}\n    .fil53 {fill:#464946}\n    .fil160 {fill:#464A4A}\n    .fil46 {fill:#472C22}\n    .fil101 {fill:#484A47}\n    .fil104 {fill:#4A4D4A}\n    .fil159 {fill:#4B4B55}\n    .fil62 {fill:#4B4D4B}\n    .fil139 {fill:#4C3326}\n    .fil144 {fill:#4D514B}\n    .fil155 {fill:#4D5353}\n    .fil3 {fill:#4E514D}\n    .fil19 {fill:#50534F}\n    .fil109 {fill:#535552}\n    .fil166 {fill:#54555C}\n    .fil60 {fill:#565954}\n    .fil29 {fill:#583825}\n    .fil91 {fill:#595C56}\n    .fil80 {fill:#5B5E59}\n    .fil158 {fill:#5C6366}\n    .fil25 {fill:#5E615B}\n    .fil31 {fill:#61635D}\n    .fil77 {fill:#653C25}\n    .fil167 {fill:#67647A}\n    .fil35 {fill:#694328}\n    .fil18 {fill:#754222}\n    .fil30 {fill:#774928}\n    .fil26 {fill:#775231}\n    .fil4 {fill:#7A684E}\n    .fil49 {fill:#7DBCC3}\n    .fil0 {fill:#8172B4}\n    .fil146 {fill:#86BEC3}\n    .fil9 {fill:#875A33}\n    .fil82 {fill:#88562C}\n    .fil70 {fill:#8AC4C8}\n    .fil163 {fill:#8CB0B2}\n    .fil83 {fill:#8CC5CA}\n    .fil150 {fill:#8F744B}\n    .fil108 {fill:#93C6CA}\n    .fil134 {fill:#93CACD}\n    .fil96 {fill:#946231}\n    .fil59 {fill:#94CDD1}\n    .fil15 {fill:#955B2A}\n    .fil28 {fill:#976634}\n    .fil157 {fill:#97B9BA}\n    .fil42 {fill:#97B9C3}\n    .fil141 {fill:#98C4C6}\n    .fil78 {fill:#9BCBCD}\n    .fil118 {fill:#9CCED1}\n    .fil165 {fill:#9F8B68}\n    .fil81 {fill:#A3CCCD}\n    .fil114 {fill:#A3CED1}\n    .fil145 {fill:#A4C2BD}\n    .fil45 {fill:#A4D2D4}\n    .fil72 {fill:#A8C6C4}\n    .fil69 {fill:#AACED1}\n    .fil13 {fill:#AB7B49}\n    .fil66 {fill:#ABCDCC}\n    .fil85 {fill:#ABD3D3}\n    .fil5 {fill:#AD7033}\n    .fil161 {fill:#AE5B28}\n    .fil57 {fill:#AED1CE}\n    .fil20 {fill:#B2874D}\n    .fil51 {fill:#B3D4D3}\n    .fil65 {fill:#B6D9D9}\n    .fil151 {fill:#B8DFDF}\n    .fil2 {fill:#B9692A}\n    .fil156 {fill:#B9833D}\n    .fil87 {fill:#C76A29}\n    .fil54 {fill:#C87A34}\n    .fil21 {fill:#CA742C}\n    .fil162 {fill:#CADEDA}\n    .fil1 {fill:#D1AF91}\n    .fil38 {fill:#D66C28}\n    .fil71 {fill:#D77C33}\n    .fil16 {fill:#D8762C}\n    .fil74 {fill:#D98637}\n    .fil164 {fill:#D99547}\n    .fil40 {fill:#DB8C34}\n    .fil7 {fill:#DECFA6}\n    .fil138 {fill:#E66C26}\n    .fil102 {fill:#E7782A}\n    .fil8 {fill:#E7822E}\n    .fil121 {fill:#E78C45}\n    .fil76 {fill:#E88735}\n    .fil143 {fill:#E99955}\n    .fil140 {fill:#EA9648}\n    .fil10 {fill:#EAA656}\n    .fil148 {fill:#EBAA4E}\n    .fil149 {fill:#EDD28B}\n    .fil168 {fill:#EEB46A}\n    .fil6 {fill:#F0C875}\n    .fil39 {fill:#F3792C}\n    .fil27 {fill:#F47C32}\n    .fil128 {fill:#F48434}\n    .fil34 {fill:#F4853A}\n    .fil147 {fill:#F4A649}\n    .fil11 {fill:#F5842D}\n    .fil106 {fill:#F58B34}\n    .fil88 {fill:#F58C3B}\n    .fil100 {fill:#F59C52}\n    .fil94 {fill:#F68C2C}\n    .fil115 {fill:#F6933B}\n    .fil63 {fill:#F69443}\n    .fil17 {fill:#F6A455}\n    .fil133 {fill:#F7922D}\n    .fil64 {fill:#F79233}\n    .fil125 {fill:#F7983B}\n    .fil12 {fill:#F7E88C}\n    .fil122 {fill:#F8962E}\n    .fil92 {fill:#F89632}\n    .fil130 {fill:#F89A31}\n    .fil124 {fill:#F89B34}\n    .fil110 {fill:#F89C43}\n    .fil23 {fill:#F8D876}\n    .fil48 {fill:#F99C3B}\n    .fil44 {fill:#F99D36}\n    .fil50 {fill:#F9A23C}\n    .fil73 {fill:#F9A444}\n    .fil113 {fill:#F9A44B}\n    .fil56 {fill:#F9AA45}\n    .fil47 {fill:#F9B956}\n    .fil55 {fill:#F9C866}\n    .fil75 {fill:#FAAB4C}\n    .fil68 {fill:#FAAC52}\n    .fil103 {fill:#FAB94B}\n    .fil61 {fill:#FBB34C}\n    .fil36 {fill:#FBB353}\n    .fil24 {fill:#FBC758}\n    .fil84 {fill:#FBD735}\n    .fil107 {fill:#FCCA39}\n    .fil43 {fill:#FCD45C}\n\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil0 str0",
    points: "9,12 372,12 372,1948 192,1771 9,1948 "
  }), /*#__PURE__*/React.createElement("g", {
    id: "_796412264"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M328 354l-2 -1c-2,2 -1,0 -1,3l4 3c-2,-3 -1,-1 -1,-5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "113,571 109,572 112,573 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M271 335c-3,2 -2,-1 -2,3 3,3 1,2 6,2 -2,-3 -2,-2 -4,-5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "208,425 205,425 206,427 209,428 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M280 492l-3 -5c-3,3 -1,4 -1,9 3,-4 0,-4 4,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M65 95c-3,4 -2,5 -6,4l1 4c5,0 4,-3 5,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M88 727c-2,7 0,5 -4,5 2,2 2,2 6,1 1,-3 0,-3 -2,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M129 686l-6 2c1,4 1,4 5,5l-2 -3 3 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "M303 446c-4,2 -4,3 -8,2l0 2 2 2c1,-1 3,-2 4,-2 4,-4 1,-1 2,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "M216 1015c-2,-3 -2,1 -7,1l0 2 2 2 5 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M314 431l0 -1c-4,1 -2,0 -3,0 -7,-2 4,-1 -2,-1l-2 2c2,4 1,0 4,5 2,-2 2,-3 3,-5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil5",
    points: "182,1024 178,1024 178,1027 180,1026 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil6",
    d: "M172 1032c4,-3 5,-1 6,-3 0,-1 -9,1 -11,1 -4,1 -10,1 -13,3l18 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil6",
    d: "M212 1078l-5 1c2,4 3,3 6,4 -2,-3 2,-1 -2,-2l1 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil6",
    d: "M110 480c-4,-2 -2,-3 -4,-8 0,6 -2,6 0,10l4 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil6",
    d: "M167 557c0,5 1,2 -1,6l3 2 0 -6 -2 -2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil6",
    points: "101,995 100,994 97,993 100,997 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil7",
    d: "M282 452l-24 1c3,5 6,2 11,2 5,-1 9,0 13,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil7",
    d: "M233 949l-4 -2 0 -4c-1,1 -2,2 -2,4 -2,7 -1,3 0,4l6 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil8",
    d: "M203 899c-4,-4 -5,-7 -10,-8l2 3c2,4 3,0 -1,4 6,4 4,3 11,5l-2 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil8",
    d: "M190 891c-3,0 -1,-1 -4,2 2,0 1,2 4,-1 0,0 0,-1 0,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil9",
    d: "M134 1007c-5,1 -5,1 -5,5l10 0c2,-3 2,2 1,-5l-6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil9",
    d: "M244 424l0 -3 -3 -2c-2,-1 -2,-1 -4,-2 -1,3 0,2 -3,2l2 5 0 2 3 -1 5 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil10",
    d: "M292 179l0 -5 -4 2c-1,1 -1,0 -2,2l-1 9 4 0 3 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil10",
    d: "M261 79c-1,0 -2,0 -2,1 0,0 0,0 0,1l1 2c5,1 3,0 7,2 -1,-6 -1,-6 -6,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil11",
    d: "M285 344l-2 0c-3,1 -2,-1 -3,2l4 0c-1,4 -1,1 0,4l7 1 6 0 -9 -7c-1,1 0,0 -3,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil11",
    d: "M184 904c4,-4 1,-2 1,-3 -4,-1 -2,-1 -5,0 -7,1 -3,0 -3,3 -1,4 0,1 -2,3l1 1 6 1 -1 -4 3 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil11",
    d: "M303 331l-1 -2c-5,0 -7,-1 -9,2l-3 4 7 2c0,-5 1,-6 7,-4l-1 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil12",
    d: "M261 1136l1 -13c-6,5 -4,19 -4,26 4,1 5,2 8,-1l-4 1c1,-4 -1,-3 -1,-3 0,0 -2,2 0,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil12",
    d: "M173 475l0 3c0,1 -2,2 -2,2l-7 6c1,5 -1,1 -4,8 13,-7 7,-6 15,-14 2,-1 1,0 2,-1 -3,-4 -1,-2 -4,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil13",
    d: "M183 711l-8 1c-2,-4 -4,-5 -4,-9l-2 -4c4,-5 7,-3 13,-4l-8 -1 -5 2c-2,5 -2,7 -1,12 2,2 7,5 10,7 1,0 3,-1 3,-1 3,-2 2,-1 2,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil13",
    d: "M212 196c-6,2 -7,2 -12,0l-3 -9 -1 0 -1 1 1 5c1,3 5,6 6,7 5,1 7,0 10,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil14",
    d: "M181 167c-6,-15 0,-7 3,-17 -2,-2 0,-1 -4,-1l0 0c-1,2 -12,13 -3,19l1 -2 3 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil14",
    d: "M240 669c-2,-3 -3,-7 -6,-7l-1 7c2,-2 1,0 3,-3l2 4 2 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil14",
    d: "M121 774c-2,-3 -1,-2 -5,-3l-3 5 6 4c-3,-6 -5,-7 2,-6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil14",
    points: "322,582 320,583 317,580 317,587 319,588 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil15",
    d: "M230 330l-3 0c-6,0 -10,-3 -15,-1l0 5 0 -1c2,6 -1,5 -3,12l2 -1c2,-2 1,-2 3,-5 6,-10 10,-5 16,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil15",
    d: "M107 924l-4 -2 -4 0 -1 5c2,2 1,0 1,2 3,3 0,4 -1,9l4 2c-2,-6 -1,-5 0,-10 3,-8 -1,-2 5,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil15",
    d: "M163 976l-2 -4 -4 -3 -1 0 -5 -2 1 3c2,4 2,7 6,6l1 -1 4 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil15",
    d: "M232 329c3,-3 3,-2 6,-3l4 -2c-9,1 -13,-4 -12,6l2 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil15",
    d: "M260 393c-4,-3 -3,-3 -7,-3l0 4 0 0c1,2 0,1 2,2 3,-1 3,-1 6,1l1 -1 -2 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil15",
    d: "M117 918l4 -4c0,0 0,0 0,0 1,-1 1,-1 1,-1 0,0 1,-1 1,-1l-7 1c-3,3 -2,2 -2,6l3 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil15",
    d: "M235 341l-4 2c-2,6 0,4 -8,7l0 2c4,0 5,0 7,-4 2,-2 4,-5 5,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil15",
    d: "M122 930l-2 1 0 5c-6,5 -5,3 -6,12 1,-3 0,-3 1,-5 2,-2 1,-1 4,-3 2,-3 3,-6 3,-10z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil15",
    points: "213,357 210,356 210,361 211,361 214,362 217,360 213,359 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil15",
    d: "M149 934c0,-3 2,-1 -2,-2 -1,2 0,0 0,3l2 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil15",
    d: "M177 904l-4 1 2 0 0 2c2,-2 1,1 2,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil15",
    d: "M260 351l-4 0c0,1 -3,4 4,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil16",
    d: "M212 368c-3,-2 -3,0 2,-3 5,-3 3,0 5,-4l0 -1 -2 0 -3 2 -3 -1 2 3c-4,1 -8,4 -11,6 -2,3 -3,3 -6,4l0 1c1,3 -1,2 3,2l3 -1c2,-2 9,-7 10,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil16",
    d: "M319 387l0 -3c-2,2 -1,1 -2,3 -4,5 -7,2 -12,9l5 0c4,-3 5,-5 9,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil17",
    d: "M171 703c0,4 2,5 4,9l8 -1c0,-6 -3,-5 -5,-5 -5,1 1,-1 -1,1l4 -5c-1,-1 -1,-1 -3,-2 -8,-1 -7,2 -7,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil17",
    d: "M251 801c3,-4 0,0 2,-5 -6,4 -4,3 -6,-1l-2 5 -3 5 3 1 6 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil17",
    d: "M283 1121c-4,5 -8,11 -9,17 5,-3 8,-10 9,-17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil17",
    d: "M256 77c-4,-2 -3,-2 -7,-1l2 3 6 2 -1 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil17",
    d: "M264 699l-2 0c1,4 1,4 5,5l0 -5 -3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil18",
    d: "M280 346c1,-3 0,-1 3,-2 -2,-2 1,-1 -3,-2 -3,-1 -2,-1 -3,0l-1 -9 6 0c-1,-2 -4,-5 -7,-6l-3 3c1,5 1,2 -1,5 2,3 2,2 4,5l0 5 0 2 5 -1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil18",
    points: "117,921 118,925 120,922 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil19",
    d: "M69 258l-4 -2 2 4c-10,0 1,2 -7,2l-8 0c1,-3 2,-7 2,-11l-3 -1 -2 10c3,3 1,2 6,4 3,1 6,2 8,2 1,0 4,0 5,0 0,0 0,0 1,0 0,0 0,0 0,0l2 -1c-2,-2 -6,-1 -8,-2l1 -1c3,-2 3,0 5,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil19",
    d: "M70 229l1 0 -6 1c-1,1 -1,3 -2,5 -1,3 -1,5 -2,8l4 -1c1,4 -1,2 6,1 -1,5 -2,3 0,6 4,2 7,3 10,-2 -1,0 -1,0 -1,-1 -1,-1 -3,-1 -3,-1 -2,0 1,3 -3,1 -2,-2 -5,-7 -3,-9 0,5 1,3 -1,6 -4,-1 -2,0 -3,-2l-1 -4c0,-4 1,1 -1,-5l5 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil19",
    d: "M76 354l0 0c1,0 5,3 6,3 6,1 3,-2 3,-3 -2,-2 1,-1 -1,-1l-2 0c-1,1 -2,-6 -7,-4 0,3 0,3 1,5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil20",
    d: "M179 776c2,-1 1,-2 1,-5l-1 -2c-7,-6 -18,-4 -20,5 -1,6 1,7 5,11 3,0 6,1 8,-1 -6,-2 -6,-2 -11,-5 1,-6 1,-11 8,-11 8,-1 9,2 10,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil20",
    d: "M191 112c-1,-2 1,0 -1,-2 -6,-1 -7,-1 -13,1 -3,3 -2,2 -4,5l-1 5 1 1 3 1 -2 -4c5,-8 9,-8 17,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil20",
    d: "M212 180c-4,-2 -5,-1 -9,-1 -5,5 -4,1 -7,8l1 0c5,-4 8,-8 15,-5 4,4 2,6 2,11l0 -1c3,-5 2,-9 -2,-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil21",
    d: "M331 347c0,-7 -2,-6 -5,-8l-2 -2c-3,-2 0,-2 -3,-2l0 0c-1,5 0,1 -2,2l-4 -3c1,5 0,0 2,5 2,3 2,2 2,6l-3 2 1 3c5,-2 2,-4 6,-9 1,11 6,6 8,6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil21",
    d: "M199 887l0 0 -5 1c0,0 1,1 1,1l5 3c2,2 1,1 2,2 0,0 0,1 1,1l1 0c2,2 1,1 2,2 6,3 3,0 7,2 0,-5 0,-4 -1,-8l-7 -1c5,-1 2,0 1,-3l-5 3 -2 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil21",
    d: "M319 321l-5 -1c-1,1 -1,-2 -1,2l5 1c2,6 2,7 7,10l4 4 2 -8c-5,-2 -1,-2 -8,-4 -1,0 -2,-1 -4,-1l0 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil21",
    d: "M329 410l-3 1 1 -4c-2,3 -4,7 -8,8l-1 2 0 3 10 -7 1 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil21",
    d: "M327 418l1 3c4,-1 4,-1 1,-5 -4,0 -1,-1 -2,2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil21",
    points: "236,978 233,976 231,978 233,981 236,981 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil21",
    d: "M116 1019c3,2 0,3 6,0 -2,-2 2,-1 -3,-1 -6,-2 0,-1 -3,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil22",
    d: "M211 129l0 -2c0,0 0,-1 0,-1l1 -2c2,-3 3,-2 7,-3 -1,5 3,5 -8,8zm9 0c2,-2 3,-3 4,-7l-1 -3c-4,0 -8,-1 -10,1 -5,2 -4,1 -6,5 0,4 0,4 4,4 2,4 5,1 9,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil22",
    d: "M190 171l-1 -3 -8 -1 -3 -1 -1 2c1,0 -1,0 2,2 1,1 1,1 3,1 3,1 5,1 8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil23",
    d: "M240 1133l-9 1 -2 -1c-2,2 0,1 -4,2 -1,2 -5,3 -8,4 -4,2 -6,3 -10,4 8,-1 9,1 19,-2 6,-2 10,-3 14,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil23",
    d: "M294 1040l-4 0 -1 1c-2,4 -6,2 -13,4 -6,1 -7,0 -13,-2l-1 -4 -10 -1c2,3 3,4 8,6 10,5 28,3 34,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil23",
    d: "M272 1143l-6 -3 -1 -3 -4 -1c-2,12 0,10 0,10 0,0 2,-1 1,3l4 -1c4,-1 4,-2 6,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil23",
    d: "M171 480c0,0 2,-1 2,-2l0 -3c-3,-3 -7,-3 -10,-1l1 5 0 0 1 3c5,-1 5,-3 6,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil23",
    d: "M102 551l2 4 -2 3c2,4 4,6 7,9 0,-4 -1,-6 -2,-9 0,-1 -1,-3 -1,-4 -3,-4 -2,-2 -4,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil23",
    d: "M310 1100l0 0 -2 0 0 3c3,1 1,0 5,2 -1,-3 0,-3 -3,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil24",
    d: "M289 1041c-3,1 -5,2 -8,1 -3,-1 -1,0 -3,-5 -6,0 -13,3 -16,2l1 4c6,2 7,3 13,2 7,-2 11,0 13,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil24",
    d: "M207 514c-5,0 -9,-1 -13,-4 3,6 3,4 0,8l12 2 9 0c-2,-3 -1,-2 -4,-4 -3,-1 -2,-1 -4,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil24",
    d: "M268 1124l-3 0 -1 -5c-2,2 -1,1 -2,4l-1 13 4 1c1,-6 3,-6 3,-13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil24",
    d: "M160 494c3,-7 5,-3 4,-8l0 -3 -5 3c1,2 2,0 0,3 -2,2 -2,2 -3,2l0 -3 -3 1c2,5 2,2 1,7l6 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil25",
    d: "M121 1108c-3,-6 -3,-4 -7,-7 -1,-2 -4,-5 -5,-8 -7,3 -5,6 -2,11 1,0 0,0 1,0 1,0 2,-1 2,-1 1,1 1,2 1,3 2,3 2,0 4,2l-3 3c9,-1 0,-3 10,0l-1 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil25",
    d: "M172 251l-4 2c-1,4 1,4 3,5l1 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil26",
    d: "M145 1010l1 0c1,-8 -2,0 -1,-4 1,-2 2,-2 3,-3l-4 -2c0,4 0,2 -1,3l-1 -5 -4 1c-1,0 -5,-1 -5,-1 -5,0 -2,0 -3,4l4 4 6 0c1,7 1,2 -1,5l1 2 5 -4c0,1 0,0 0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil26",
    d: "M199 992l0 0c1,13 2,5 6,11l1 -6c-4,-3 -3,-4 -7,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil27",
    d: "M170 515c-5,-3 -2,-3 -4,-7 0,0 8,0 11,-1 -7,-5 -11,0 -19,0 2,3 3,1 4,1 0,3 0,2 -2,1 -3,3 -2,-1 -1,4 1,1 5,3 8,4 4,2 2,1 5,4 3,2 0,1 4,2 4,0 1,1 3,-1l-1 -2c-1,0 -1,0 -1,0 -3,-4 -4,0 -7,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil27",
    d: "M311 1087l1 -5c-3,0 -4,0 -4,2 -2,4 1,-2 0,5 -5,3 -3,-2 -6,3l0 2c1,3 1,3 3,5 0,-2 0,-1 0,-3 1,-4 0,2 1,-2 0,0 0,-1 0,-1 0,0 0,0 0,-1 2,4 1,3 4,8l0 0c3,-2 2,3 2,-6 0,-2 -1,-5 -1,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil27",
    d: "M325 1136c0,-2 0,0 0,-2 -2,-2 -2,-1 -2,-2l-5 0c1,-3 1,0 0,1 -2,2 4,1 -3,2 7,-3 1,4 1,4 -7,2 -3,1 -6,-5 -3,3 -2,2 -1,7l2 0c6,-1 6,2 9,-4l4 2 1 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil28",
    d: "M219 1011l1 -6c0,-1 0,-1 1,-1 1,-1 1,-1 2,-1l1 -4c-4,-2 -1,-2 -1,-5 1,-5 0,-3 0,-7l-5 5c-2,4 -2,4 -2,10 -5,-5 -4,-3 -6,1 4,2 4,3 7,0 -1,5 0,5 -1,10 2,-1 1,0 3,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil28",
    d: "M307 442c-1,-5 1,-5 1,-7l3 1c-3,-5 -2,-1 -4,-5l2 -2c6,0 -5,-1 2,1 1,0 -1,1 3,0 3,-1 1,-3 2,-8 0,1 -2,1 -3,1 -6,2 1,1 -6,4 -1,1 -2,2 -4,2l1 1c0,1 0,1 0,1 0,0 2,1 -1,1 -2,0 1,-1 -4,-3 1,8 -1,3 0,7 2,2 3,2 5,5l2 1c-1,3 -1,2 -3,4l2 0 2 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil28",
    d: "M318 417l1 -2 1 -10 -3 1c2,1 2,1 1,5l-9 2 -1 2 -1 4 -2 1c2,2 -3,2 4,2 4,-3 3,-1 6,-3 4,-2 3,-5 3,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil28",
    d: "M223 978c0,-4 0,-6 -2,-9l1 5c-4,4 -2,4 -8,5 -2,5 -2,2 -2,8 5,-1 3,-2 5,-3 4,-2 2,-1 4,0 0,-5 -1,-4 2,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil28",
    d: "M146 1012l-1 -2c0,0 0,1 0,0l-5 4 1 1 1 1 3 2 1 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil28",
    d: "M234 432l1 -7 -3 3 -3 -1 0 2c2,0 1,-2 1,2l2 1c0,0 2,0 2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil28",
    d: "M191 970c0,-4 1,-4 -2,-6l1 1 0 3c-4,0 -2,0 -5,2l0 1 2 0c4,0 1,0 4,-1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil28",
    points: "109,921 104,921 104,920 103,922 107,924 109,924 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil28",
    d: "M103 949l0 2c2,2 0,1 2,3 4,0 2,0 3,-1l-5 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil29",
    d: "M265 394c1,-4 -1,0 2,-2 3,-3 0,3 3,-3 -3,-2 -1,-2 -5,-3l-1 2c-8,-1 -4,-3 -4,-10 -4,0 -6,2 -7,2l1 -3c-4,1 -2,0 -4,2 0,7 2,1 2,6 6,3 1,0 5,4 2,3 1,0 3,4l2 3 3 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil29",
    d: "M242 334l0 -1 1 -4c-2,-3 -2,-2 -5,-3 -3,1 -3,0 -6,3 1,4 -1,2 3,4l-1 3c4,0 4,0 8,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil29",
    d: "M168 921c1,-4 -1,1 4,-3l0 -6 -2 0 2 5c-5,-2 -2,1 -8,-1l-2 -4 -1 5 0 2 2 4 3 0 2 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil29",
    d: "M128 921l0 0 0 -7 -7 0 5 3c-4,1 -5,-1 -9,1 2,4 2,0 5,5l0 1c5,-2 2,0 6,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil29",
    d: "M164 964l0 2 -2 0c-3,2 -2,1 -5,3l4 3 0 -1c4,1 1,1 5,-1 3,-2 2,0 4,-3l-6 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil30",
    d: "M112 952c0,-2 -3,0 2,-2l0 -2c-5,-3 -4,1 -8,-1 -4,-2 -1,-5 0,-8 0,0 0,0 0,0 -1,0 -1,0 -1,0l-2 -1c3,-3 2,-2 1,-5 0,0 0,0 0,-1l-1 -2c7,1 9,5 10,3l-6 -1c2,-7 -1,-2 5,-6 -2,0 -2,-1 -2,-3l7 -2 0 -3 -3 1 -1 2 -4 0 0 3 -2 0c-6,4 -2,-2 -5,6 -1,5 -2,4 0,10l1 9 5 4 4 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil30",
    d: "M162 912c-2,-1 -2,2 -1,-3l4 0c5,-1 2,0 4,-2 -7,1 -6,-2 -12,-2l0 6 -2 5 2 -1 4 2 1 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil30",
    d: "M222 356c-2,-1 -4,-1 -7,-1l-2 2 0 2 4 1 2 0 3 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil30",
    d: "M128 914l-1 -3 -2 -1 -2 2c0,0 -1,1 -1,1 0,0 0,0 -1,1 0,0 0,0 0,0l7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil30",
    d: "M252 385l1 5c4,0 3,0 7,3 -2,-4 -1,-1 -3,-4 -4,-4 1,-1 -5,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil30",
    d: "M244 325l-2 -1 -4 2c3,1 3,0 5,3l1 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil30",
    d: "M190 965l-4 1 -1 4c3,-2 1,-2 5,-2l0 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil31",
    d: "M106 208c1,-6 -2,-9 1,-12l0 -2c-1,3 0,1 -2,3 -1,-4 0,-6 -2,-9 -4,4 -1,8 -3,13l-2 3c0,0 -1,0 -1,0 0,0 0,0 0,0l-2 1c0,0 0,0 0,0 0,0 -1,1 -1,1 0,1 0,1 -1,1 3,3 5,3 7,2 2,5 -2,-1 1,5 5,0 5,-4 5,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil31",
    d: "M121 1081c-1,-3 -1,-3 -2,-4 -1,-2 -1,-3 -3,-4 -6,-2 -1,-9 -9,-8 1,3 1,2 2,4 5,7 4,15 5,16 0,0 0,-3 -3,0l-1 1c5,2 7,0 9,-3 -1,4 -1,2 0,6l1 -1c3,-2 2,-5 1,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil31",
    d: "M333 649c1,2 2,4 3,6 2,4 2,1 3,6l3 3c1,0 1,0 1,1 1,0 1,0 1,1 0,-8 -2,-7 -2,-12 -1,-4 0,-2 2,-5 0,0 1,0 1,0 0,-1 0,-1 0,-1 0,0 0,-1 0,-1 -10,2 -6,2 -10,-3 -1,2 -1,1 -1,3 -1,2 -1,1 -1,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil32",
    d: "M251 706l2 -10c0,0 0,0 -1,0 -7,1 -5,1 -6,-2 -3,-5 0,0 1,-7 -6,4 -2,1 -5,8 -1,3 -4,7 -3,10 0,3 0,4 2,6 5,0 0,1 4,-4 5,-5 1,-3 8,-7l-2 6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil32",
    d: "M268 215c-1,1 -2,2 -2,2 -2,3 -1,2 -2,3 -2,5 0,1 1,2l6 -5c-2,-2 0,-1 -3,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil33",
    d: "M319 803c-4,-2 0,1 -3,-3 -2,-1 -1,-1 -4,-2l2 -1 0 -4c-4,1 -2,2 -5,-1 1,-5 1,-3 0,-4l-1 5 -2 4 4 -2c-2,5 -2,2 -5,6 -2,3 0,2 1,6l-6 0c6,3 15,2 19,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil33",
    d: "M355 154c-1,-1 -3,-2 -5,-2l-5 0c-5,1 -2,6 -2,7l2 -2c0,0 0,1 0,1l0 2c0,1 0,2 -1,4 7,-2 9,-3 11,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil34",
    d: "M167 557l-6 -10 -4 -1c0,4 1,0 4,7l2 5c-3,-1 -5,-2 -7,-3 -4,-3 -1,-1 -6,-4 -4,-3 -6,-6 -9,-9 -4,0 -2,-1 -3,2l1 1c4,2 2,1 5,4 3,4 17,12 22,14 2,-4 1,-1 1,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil34",
    d: "M11 524l0 4 5 0c2,-2 2,0 2,-3 -4,-2 -2,-2 -7,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil35",
    d: "M218 349l1 -1c-4,-4 0,0 -2,-4 -1,-2 -1,-2 -2,-4 0,-1 1,0 1,-1l4 -5c4,4 0,1 5,2 5,1 7,1 9,0l1 -3c-4,-2 -2,0 -3,-4l-2 1c-6,4 -10,-1 -16,9 -2,3 -1,3 -3,5 2,6 -1,7 -1,12l3 1 2 -1c0,-8 -2,-1 -1,-9l4 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil35",
    d: "M190 1021l-3 -3c0,0 -2,-3 -2,-3 -2,-3 0,-1 -3,-2l-3 1c-3,-2 -3,-3 -7,-2 -1,4 -3,1 3,3 2,2 2,1 3,3l5 -1 4 6c-4,-1 -6,-2 -9,1l4 0 6 1 2 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil35",
    d: "M275 448l-1 -3 -1 0 0 -2c-2,-5 -1,-4 -4,-5 -6,-1 -2,-3 -10,-4 0,3 1,3 4,5 4,3 -1,2 7,2l2 6c-1,1 -2,-1 -4,1l5 2 2 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil35",
    d: "M238 412l-1 -3c-7,0 -4,-1 -7,4l-3 0c-2,0 -2,0 -3,0 4,4 5,1 10,0 -1,5 -1,3 0,6 3,0 2,1 3,-2l1 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil35",
    d: "M214 979c-4,-4 -1,-3 -4,-4 -2,1 -1,-2 -2,2 3,3 2,3 1,7 4,-1 2,-1 5,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil35",
    d: "M235 425l1 1 0 -2c-5,-1 -2,0 -5,-3 0,6 1,3 -2,6l0 0 3 1 3 -3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil35",
    points: "308,415 309,413 306,409 304,417 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil36",
    d: "M193 388c-3,0 0,1 -2,-1l1 -7c-1,-7 -3,-4 0,-7 1,-6 3,-4 0,-8 0,0 1,0 1,0 1,0 0,0 1,-1 -2,-3 -2,-1 -1,-4l-4 3 0 -5c-3,3 -3,7 -3,12 1,5 3,7 3,10 2,6 -1,15 6,21 2,-7 1,-8 -2,-13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil36",
    d: "M82 957c0,8 2,18 9,22 -1,-8 0,-2 -3,-7 2,-2 -1,1 1,0 5,-3 -3,2 1,-1 -1,-8 -1,-5 1,-10 -4,0 -2,1 -4,-3l-3 2 -2 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil36",
    d: "M99 929c0,-2 1,0 -1,-2l-3 -6 -4 13c-1,-2 -1,-1 -2,-4 0,0 0,-3 0,-4 -3,2 -2,-1 -3,5 2,7 1,1 2,4 1,2 1,0 1,3 4,-3 7,-6 10,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil36",
    d: "M156 532c-4,6 0,-2 -4,3 2,4 1,5 5,11l4 1 -5 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil36",
    d: "M97 986l-3 0 -1 0 0 -3 -2 0c1,4 2,9 6,10l3 1c0,-7 -1,-4 -3,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil37",
    d: "M61 330l8 -7 1 -6c-5,0 -2,-1 -6,-10 -4,2 -4,3 -7,5l-2 2 7 -1c4,5 4,9 0,11 -5,-5 -1,-6 -6,-9 -2,4 -1,1 -3,1 2,5 4,4 5,8 1,3 0,5 0,8 1,-1 2,-2 2,-1 0,0 1,-1 1,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil37",
    d: "M115 1171c2,6 1,1 4,5 4,7 -8,-3 -5,8 1,2 2,3 4,5 6,-2 2,-2 4,-7 2,-3 4,-5 5,-9 -6,-7 -5,-5 -12,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil37",
    d: "M312 117l-2 -2c-4,5 5,0 -1,1 -2,0 -2,-2 -4,2 11,4 3,3 8,4 6,2 5,-2 6,-7l-7 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil37",
    d: "M118 317c-4,1 -3,0 -6,3 2,4 6,4 10,5l0 -2c5,0 4,1 6,-2 -2,-1 -3,-1 -5,-1 -2,-1 -1,-2 -4,1l-1 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil38",
    d: "M212 911c5,0 2,1 4,-1 0,-3 0,-4 -3,-6 -1,-1 -2,0 -4,0 -3,-5 0,-2 -6,-5l2 4c-7,-2 -5,-1 -11,-5 -3,-1 -17,-1 -17,-2l-3 3c5,1 3,-3 11,0 5,2 3,0 9,1 0,0 0,0 3,0 1,2 2,4 2,4 3,4 0,1 3,2 5,4 2,4 2,10 5,-1 3,2 4,-5 0,0 -1,-4 -1,-5 3,4 2,4 5,5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil38",
    d: "M303 341l4 -2c-1,6 -1,1 1,6l1 -1c2,0 0,-2 1,1 2,2 -3,2 3,1l1 -1c0,-4 -2,-4 -6,-6 -3,-2 -5,-4 -8,-6 1,3 2,6 3,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil39",
    d: "M315 334l0 -1c-7,1 -4,0 -6,-1 -1,0 -4,-1 -6,-1l1 2c-6,-2 -7,-1 -7,4l-7 -2 -2 3c2,3 2,1 7,2 2,0 5,1 8,1 -1,-2 -2,-5 -3,-8 3,2 5,4 8,6 4,2 6,2 6,6 1,-2 1,-3 2,-3l0 5 3 -2c0,-4 0,-3 -2,-6 -2,-5 -1,0 -2,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil39",
    d: "M345 1118l-5 0 -3 2 0 8 1 1c2,-3 -3,0 6,-4 0,0 1,0 1,0 0,0 1,0 1,-1 0,-4 -1,-3 -1,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil39",
    d: "M184 904l-3 1 1 4 -6 -1c-3,2 -2,0 -3,4 2,2 -2,1 3,2 4,-3 3,-2 8,-2 0,0 3,0 3,0 -1,-2 -1,-2 -2,-4 -2,-3 -2,-1 -1,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil39",
    d: "M102 442c-4,-1 -4,-2 -6,-3 -4,0 -4,1 -4,4l2 4 4 0c0,0 0,0 1,-1l1 -1c1,-1 1,-2 2,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil39",
    d: "M150 908l5 0c1,2 2,0 0,2l-4 -5c-1,1 1,-2 -1,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil40",
    d: "M325 356c0,-3 -1,-1 1,-3l2 1c4,-1 3,0 4,-4 1,-2 3,-5 3,-8 1,-5 0,-12 -3,-15 0,4 1,6 0,11 0,1 0,3 0,4l-1 5c-2,0 -7,5 -8,-6 -4,5 -1,7 -6,9 -2,4 -2,6 -8,7 0,0 2,1 2,1 2,1 1,-2 2,1 0,0 1,0 1,0 1,-4 1,-5 5,-7l6 4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil40",
    d: "M214 892c1,15 4,2 3,17 0,1 -1,1 -1,1 -2,2 1,1 -4,1 1,4 0,7 5,6 5,-3 4,-20 -3,-25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil41",
    d: "M331 166c-5,-4 0,0 -3,0 -4,-1 3,2 -3,0 0,-3 1,-4 3,-7l1 3c1,-5 2,-4 2,-8l1 -4c-4,1 -9,7 -12,10 -4,4 -9,6 -10,10 4,2 19,-2 21,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil41",
    d: "M343 233l-3 -2 0 -16c-7,0 -5,0 -8,6 -1,3 -2,6 -3,10 3,-1 2,-2 3,3 5,0 5,1 11,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil41",
    d: "M272 1195c-1,-6 0,-8 -2,-14 -5,0 -1,-1 -4,1 -3,2 -4,9 -5,14 6,1 -2,2 6,4l5 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil41",
    d: "M326 879c0,1 0,1 0,1 -2,2 -4,2 -4,6 4,2 3,1 5,4 6,-2 10,-1 14,-5 -1,-6 -9,-5 -15,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil41",
    d: "M74 697l0 -9 -4 3 -3 0 -3 13 2 1 0 -3c1,4 0,3 3,4 6,-1 3,-3 4,-9l1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil41",
    d: "M155 343c0,-4 -2,-10 -5,-12 -4,2 3,1 -2,0 -2,0 0,0 -2,0 0,0 -1,0 -1,0 -3,2 -2,1 -3,2 4,6 5,4 2,5 1,3 2,3 4,6 2,2 0,2 3,2 2,-2 -1,-2 4,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil41",
    d: "M322 866l-1 -4c-1,3 0,1 -2,4l-4 -1 -4 10c3,1 2,0 3,3 0,0 0,1 0,1 1,0 1,2 1,2l1 0c5,-1 2,1 4,-3l1 -11c0,0 0,-1 1,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil41",
    d: "M284 1203c2,-2 4,-3 6,-5 -1,-4 0,0 -3,-4 -4,1 -4,0 -6,3 0,2 -3,-1 -3,7 5,-1 6,-4 6,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil41",
    d: "M308 774c-2,-2 0,-1 -3,-3 -1,0 -2,0 -5,-1l-3 6 10 1 1 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil42",
    d: "M229 694c-4,3 -4,1 -4,5l-2 7 0 1c1,3 -2,14 -3,18 4,2 0,-1 3,5 1,4 0,3 3,5l3 -41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil42",
    d: "M192 695c3,-2 4,-2 5,-5 -5,1 -8,1 -13,1 -5,0 -6,1 -10,3l8 1c6,0 1,-1 6,2 2,-3 1,-2 4,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil42",
    d: "M190 110l0 -3 6 -3 1 -4c-5,1 -7,3 -11,5 -5,1 -6,3 -9,6 6,-2 7,-2 13,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil42",
    d: "M165 178l-2 -3 -3 1c5,6 11,14 18,18 -3,-8 -8,-4 -13,-16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil43",
    d: "M306 1145l-1 0 -3 -2c-2,4 1,3 -3,3 5,13 11,21 25,23 -7,-8 -13,-14 -18,-24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil43",
    d: "M133 421l7 0c0,6 1,9 0,15 -1,6 -1,8 -2,14l0 0 2 4 2 -3 1 4c3,-7 5,-15 3,-23 -2,-13 -5,-9 -13,-11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil43",
    d: "M102 551c-3,-9 -18,-14 -27,-16 3,4 9,4 15,9l-1 6c4,3 10,5 13,8l2 -3 -2 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil43",
    d: "M326 1148c-3,5 -5,2 -8,-1l-2 2 -1 2c0,0 0,1 -1,2 1,0 8,13 8,13 4,-2 9,-13 4,-18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil43",
    d: "M128 434c3,3 2,1 2,6l5 0c2,-2 4,-13 4,-17 -4,1 -9,2 -12,5 0,1 -2,3 -3,4l2 1c0,0 2,1 2,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil43",
    d: "M159 486l-3 2 0 3c1,0 1,0 3,-2 2,-3 1,-1 0,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil44",
    d: "M124 942c-2,-2 -2,-2 -1,-7 3,-2 7,0 15,-2l-3 -9 7 2 -4 -3c-5,2 -3,2 -7,3 -5,1 -2,0 -6,3l-3 1c0,4 -1,7 -3,10 -3,2 -2,1 -4,3 -1,2 0,2 -1,5l0 2c2,1 -1,1 2,0 0,0 4,-2 4,-2 3,-2 3,-2 4,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil44",
    d: "M232 355l0 -9c5,1 8,3 11,3 7,0 5,-3 4,-9l-11 1 -1 0c-1,2 -3,5 -5,7 -2,4 -3,4 -7,4l-1 4 -3 4 0 1c5,-3 10,-2 13,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil44",
    d: "M199 982l3 -4c-2,-1 1,-2 -4,0 -4,1 0,-1 -7,4l-3 3c-1,-2 -1,-1 -3,-1l-1 0c0,5 -1,3 -5,5 6,1 9,4 13,1 1,-2 3,-3 4,-4 3,-2 2,1 3,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil44",
    d: "M147 943l0 -4c-4,-1 -2,-1 -6,0 -3,1 -8,2 -8,4 -3,5 -1,1 -2,6 3,2 2,3 6,0 1,-1 3,-6 10,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil45",
    d: "M234 183c-4,2 -1,1 -3,3l-3 1c2,3 2,6 3,8 4,-2 1,1 3,-3 3,3 -1,-1 2,2 2,1 2,1 4,1 1,0 1,0 1,0 0,0 3,0 3,0l3 -2c0,0 0,0 0,0l-2 -8c-1,-3 0,-1 -2,-3 0,0 -3,-3 -3,-3 -7,3 0,1 -6,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil45",
    d: "M196 789c5,-3 2,-2 4,-4 3,-3 0,-2 7,0 -2,-2 -2,-3 -1,-6 -6,2 0,0 -4,0l-10 -2c1,3 2,2 3,5 -6,5 3,-5 -5,1l0 7 6 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil46",
    d: "M282 398l1 -2 1 -8 3 4 3 0 -1 -1c-1,-4 -7,-7 -11,-8 2,3 2,1 0,4 -8,2 -9,-2 -11,-4l-2 3c4,1 2,1 5,3 -3,6 0,0 -3,3 -3,2 -1,-2 -2,2l4 0c4,8 3,5 13,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil46",
    d: "M285 344c1,0 1,-3 1,-4 1,-2 0,0 2,-2l2 -3 3 -4c-5,-1 -6,0 -11,2l-6 0 1 9c1,-1 0,-1 3,0 4,1 1,0 3,2l2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil46",
    d: "M162 966c-2,-2 -1,0 -3,-5 3,-3 1,2 4,-4l-5 3c-7,-11 -7,1 -6,-10 0,0 0,0 0,-1 0,0 1,1 1,1 0,0 0,0 0,0 2,1 1,1 4,1l-3 -5c-2,3 -1,3 -5,2 1,5 3,9 1,12l3 3c2,-3 0,-3 3,-4 2,3 1,7 0,10l1 0c3,-2 2,-1 5,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil46",
    d: "M176 908l-1 -1 0 -2 -2 0 -4 2c-2,2 1,1 -4,2l3 1c-1,3 0,1 -2,2l4 0 2 0 1 0c1,-4 0,-2 3,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil46",
    d: "M223 350l1 -4c-5,0 -3,1 -5,2l-1 1 2 1c3,2 -1,1 3,2l0 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil47",
    d: "M282 452l13 -2 0 -2 -1 -1 -7 -1c4,-3 4,-1 5,-4 -5,1 -4,2 -8,-2 0,1 0,1 0,1 0,0 1,5 -6,6 -3,0 -1,-1 -3,1l-2 2 -5 -2 -1 1c-4,5 0,2 -11,1 -4,0 -10,-1 -13,0 3,3 10,4 15,3l24 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil47",
    d: "M133 421c-9,4 -14,11 -16,21l6 -5c1,-3 0,-3 5,-3 0,0 -2,-1 -2,-1l-2 -1c1,-1 3,-3 3,-4 3,-3 8,-4 12,-5 0,4 -2,15 -4,17l2 4 -2 2c1,3 0,2 3,4 1,-6 1,-8 2,-14 1,-6 0,-9 0,-15l-7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil47",
    d: "M326 1139l0 9c5,5 0,16 -4,18 0,0 -7,-13 -8,-13 1,-1 1,-2 1,-2l1 -2 -4 1 -2 -3 -1 -2 -3 0c5,10 11,16 18,24 3,-6 7,-6 7,-14 0,-5 -1,-14 -5,-16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil47",
    d: "M225 1135c-7,1 -5,-1 -7,-5 -4,3 -2,3 -8,5 -2,2 -1,1 -3,3 -2,2 -3,3 -4,5l4 0c4,-1 6,-2 10,-4 3,-1 7,-2 8,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil47",
    d: "M197 1024l7 -4 -4 -4c-2,1 -3,2 -5,3 -4,2 -2,0 -5,2l-2 4 -6 -1 -2 2 0 3c5,-2 12,-5 17,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil47",
    d: "M89 938c0,-3 0,-1 -1,-3 -1,-3 0,3 -2,-4 1,-6 0,-3 3,-5 1,-3 -1,-1 2,-5 -4,0 -3,1 -3,-1 -3,0 -1,0 -1,-2 -6,11 -5,13 -1,24 3,-2 3,-1 3,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil47",
    d: "M202 340c-3,-6 -4,-5 0,-11 2,-2 1,-1 3,-5l-3 2c-4,-1 0,1 -2,-2 -5,6 -5,12 -4,20 3,-1 5,-2 6,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil47",
    d: "M248 1075l12 8c2,1 2,0 3,2 6,1 2,1 7,3 -5,-8 -13,-11 -22,-13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil47",
    d: "M126 515c2,9 1,17 9,23 -2,-8 -6,-15 -7,-22l-2 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil47",
    d: "M249 1122c-3,4 -3,3 -8,6 -1,1 -3,3 -4,3 -4,2 -3,0 -6,3l9 -1c4,-3 8,-7 9,-11z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil47",
    points: "143,455 142,451 140,454 138,450 137,456 139,458 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil47",
    d: "M305 1145l-2 -5 -4 1 0 5c4,0 1,1 3,-3l3 2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil47",
    points: "274,1139 266,1140 272,1143 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil48",
    d: "M202 370c-1,-2 -2,-1 1,-5 -1,0 -2,-1 -2,-1 5,-5 6,0 3,-4l5 -4c-1,8 -1,3 1,5l0 -5c0,-5 3,-6 1,-12l-2 1c-3,0 -5,1 -7,2 -2,1 -2,1 -4,2 -3,2 1,1 -3,2l3 3c0,0 3,-3 7,0 -2,3 -1,2 -4,4 -7,8 -5,13 -5,16 3,-1 4,-1 6,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil48",
    d: "M263 1085l-3 1 -1 -2c-8,-1 -2,-1 -4,2 -1,2 1,1 1,5 0,0 -1,3 -1,5 4,-1 10,-1 13,-4 -1,-5 -2,-2 -5,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil48",
    d: "M103 951l0 -2 -1 -9 -4 -2c-2,3 -3,2 -5,5 3,2 0,0 2,2 5,4 -2,0 2,1 2,1 -1,-2 4,1l-2 1c-4,4 -2,3 -4,8 11,-2 1,-4 8,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil49",
    d: "M169 739c2,-7 2,-1 1,-10 3,-1 3,-1 5,-3 4,-4 3,-4 2,-7 -5,2 -2,1 -5,5 -1,-1 0,0 -3,-1 1,4 0,3 -4,5l1 4c-7,3 -12,2 -9,12 3,6 5,1 6,7l1 -3c0,0 0,0 0,-1 3,-9 0,-6 5,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil49",
    d: "M189 145c5,-8 2,-9 1,-11l-1 2c-1,2 -1,1 -1,3 -3,7 -4,8 -7,8l-1 2c4,0 2,-1 4,1 -3,10 -9,2 -3,17l8 1c0,-9 0,-4 -1,-6 -3,-3 -2,1 -2,-5 1,4 1,2 2,2 3,-4 3,-4 -1,-6 3,-2 7,0 3,-4 -2,-2 -1,0 -2,-2l1 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil50",
    d: "M105 966c-2,4 0,1 -2,4 -3,3 -2,2 -6,3 -2,6 -3,5 -3,13l3 0 7 -1c-2,-3 1,1 -2,-1 0,0 0,-1 -1,-1 0,0 0,0 0,0 -3,-2 -1,2 -3,-2 2,-5 4,-5 8,-5 1,1 4,-2 1,4l2 -1c2,6 -1,2 1,7 10,-9 8,-4 8,-10 -5,-2 -3,-3 -8,1 2,-10 -1,-4 -1,-8 0,0 1,-2 1,-3l-5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil50",
    d: "M255 349l5 -1 0 -4c-10,0 -4,-3 -13,-4 1,6 3,9 -4,9 -3,0 -6,-2 -11,-3l0 9c4,-1 7,-2 11,-3 4,-1 8,-2 12,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil50",
    d: "M146 931l3 -3c-5,-3 -1,-1 -7,-2l-7 -2 3 9c-8,2 -12,0 -15,2 -1,5 -1,5 1,7 3,0 15,-8 22,-11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil50",
    d: "M97 560c0,0 0,3 0,3l1 5 7 1c-1,-8 -1,-8 -8,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil51",
    d: "M203 715c3,-6 4,-4 9,-6 11,-4 1,0 11,-2l0 -1 -2 -1c0,0 -1,-1 -1,-1 -3,-2 -2,3 -2,-3l-10 3c-3,2 2,1 -4,2 2,-4 1,-1 5,-5 0,0 -1,0 -1,0l-1 -1c0,0 -1,0 -1,0l-1 -1c-5,-2 -7,5 -8,6 -4,6 -1,-2 -3,5l0 1 3 5 6 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil51",
    d: "M233 123l-1 0c-3,-1 -1,2 -3,-3 -1,2 -2,1 -2,1 1,5 1,4 0,7 -1,0 -1,0 -1,-1l-1 -2c-1,-3 2,1 -1,-3 -1,4 -2,5 -4,7 1,4 3,4 7,5l4 -3c3,5 3,2 3,9 3,2 -3,2 4,1 0,-9 -4,-8 -5,-18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil51",
    d: "M212 724l-6 2c1,4 3,8 8,8l-2 -6c0,-5 3,-3 0,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil52",
    d: "M325 581c3,-1 3,-1 4,-2l-6 -2c1,-3 0,-6 -2,-9 1,0 4,1 5,1l3 1c0,1 1,1 1,1 0,-4 -1,-4 -3,-5l2 -3c0,-4 2,-1 -2,-3 -3,2 -2,0 -3,3l-10 -4c-3,2 -1,-1 -1,2l6 4 -10 2c2,5 2,3 4,6 3,3 3,5 4,7l3 3 2 -1c4,-4 2,-2 3,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil52",
    d: "M238 585c-2,-2 -5,-6 -7,-6 -3,0 -2,-3 2,5l2 4c0,0 0,0 0,1 1,3 2,-1 0,4 -2,-2 -1,-1 -4,0 5,-6 5,-4 -1,-6 -2,3 -1,4 -3,8 -1,3 0,-3 -1,3 8,2 14,0 17,0 -2,-4 -3,-1 -3,-5 0,-4 0,-5 -2,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil52",
    d: "M316 881l-1 0 -6 1c-4,9 -7,1 -4,7l-1 2 0 0c2,2 2,-2 2,3 4,-3 1,-2 4,-6l4 3 -5 2c8,4 5,1 8,0l4 -1c-1,-4 1,-1 -7,-7 3,-8 -2,4 2,-3 1,-2 1,3 0,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil52",
    d: "M150 327l-2 -6c0,0 -1,-1 -1,-1l-8 2c0,0 2,-3 2,-3 0,0 -1,0 -1,0 -2,-6 3,0 -2,-2 -5,4 1,1 -3,7 -2,3 0,-3 -2,2 3,2 4,1 6,-2 0,5 -2,3 4,4 7,2 2,0 7,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil53",
    d: "M79 331l3 -11c2,-5 2,1 5,-11 -6,2 -6,0 -9,5l-3 7c-1,0 -2,4 -2,4 -3,5 -1,2 -5,5l1 -7 -8 7 7 1c2,3 3,8 7,9l3 -7c2,-3 -1,1 1,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil53",
    d: "M141 1181c0,-5 -1,-4 0,-9l-4 -2c-4,4 -7,6 -9,13l2 2c3,-4 1,-3 5,-6 -1,6 -4,8 4,12 2,-5 -3,0 1,-6l1 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil53",
    d: "M176 257l-2 -1c4,-5 11,-6 19,-10l3 -1c1,-1 2,-1 2,-1l11 -4c4,-2 3,-1 6,-4 -7,2 -15,6 -22,8 -5,1 -16,4 -21,7l-1 7c2,1 3,0 5,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil53",
    d: "M156 1204c-9,-4 -1,1 -5,-6 -1,0 -1,1 -1,1 0,-1 0,0 0,0 -2,2 -1,1 -2,6 -3,-1 -4,-3 -5,-4l-3 9 7 -3c2,4 7,6 10,6l0 -7c-1,-2 2,-1 -1,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil53",
    d: "M326 540c1,2 -1,1 2,2 3,-3 3,-1 2,-6 0,0 0,-1 0,-1l-2 -3c-2,-3 -6,-4 -6,-4 -1,-1 -1,0 -1,-1 -1,4 -2,5 -3,9 6,1 6,3 8,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil53",
    d: "M149 1178c-3,-5 -1,-3 -5,-4l1 5c2,1 -2,3 3,1 3,-2 2,-1 1,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil53",
    d: "M95 1156l-3 1c2,3 0,1 4,3 0,-5 1,-2 -1,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil53",
    d: "M47 261l-3 0c1,3 -1,1 2,3 2,-1 2,3 1,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil54",
    d: "M226 982c3,-8 5,-4 7,-14 1,-5 0,-2 3,-5l3 -3c1,1 1,0 1,0l4 7 -1 -9c-2,-4 -7,-7 -10,-9l-6 2 -1 1c-3,3 -1,1 -2,3 3,4 9,8 4,14 1,4 -1,7 -5,9l0 7 3 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil54",
    d: "M338 401l-2 -6 3 -1 -2 -3c-3,1 -2,1 -6,-2l-2 0 -3 2c1,6 4,9 2,15 3,1 3,-2 2,2 6,-3 0,0 4,1 3,-4 -1,0 3,-6 1,-1 -1,3 1,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil54",
    d: "M240 989l-2 -1 -2 5c4,-1 3,-1 4,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil55",
    d: "M86 447c0,-6 -3,-18 7,-18 2,1 -1,3 4,5l2 1c2,1 3,3 3,7 3,2 4,6 4,10 4,-15 -17,-35 -17,-35 -7,-1 -8,10 -8,15 1,4 3,12 5,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil55",
    d: "M347 1114c3,4 15,11 7,17 -4,0 -1,-2 -7,-1 -4,1 -3,2 -9,-1l-1 -1 -7 -3c5,8 16,10 25,11 4,0 7,2 9,2 5,-4 1,-11 -2,-15 -4,-4 -10,-7 -15,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil55",
    d: "M153 504c6,3 14,0 20,0 9,1 11,2 18,6 4,1 2,1 3,0 4,3 8,4 13,4 -4,-6 -14,-11 -23,-12 -7,-1 -9,0 -15,1 -4,1 -12,1 -16,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil55",
    d: "M205 324c2,-1 3,-5 8,-7 4,-2 7,-4 11,-5 1,-2 0,0 1,-1 4,-4 0,1 3,-3 -12,2 -19,8 -28,16 2,3 -2,1 2,2l3 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil55",
    d: "M108 899c-10,3 -16,12 -21,19 0,2 -2,2 1,2 0,2 -1,1 3,1 1,-6 4,-8 8,-12 2,-3 6,-6 9,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil55",
    d: "M336 429l-3 1 -3 2c-5,5 -7,2 -11,8 6,-2 13,-5 17,-11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil55",
    d: "M171 480c-1,-1 -1,1 -6,2l-1 -3 0 4 0 3 7 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil56",
    d: "M306 393c-5,-3 -14,0 -13,-4 5,-1 4,2 9,-1l-1 -5c4,0 4,1 6,-1 -2,0 -11,1 -12,1 -4,0 -6,-3 -10,-3l-1 -3c-4,-1 -4,-2 -8,0 2,4 1,-3 3,4l-2 1 1 1c4,1 10,4 11,8 3,2 1,5 0,8 4,0 9,-1 12,-4 3,-1 2,0 5,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil56",
    d: "M205 961c-2,-2 -1,-1 -6,-1l-1 0c-4,1 -1,2 -6,1 2,-4 0,-1 5,-3l-3 -1c0,0 2,-1 2,-1 2,-1 2,0 3,-1 -3,-2 -2,0 -2,-3 -4,1 -7,2 -12,1 -7,-1 -1,0 -5,-1 -3,-2 -4,-2 -7,0l4 4c-2,2 -1,1 -3,2 0,0 -1,0 -2,0l6 0c4,1 10,1 11,6 3,2 2,2 2,6 3,2 -1,2 4,0 4,-3 7,-5 10,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil56",
    d: "M177 994c-5,1 -3,1 -9,4 -2,1 -2,1 -4,2l3 -2c0,0 0,0 0,0l0 -2c-3,1 0,1 -5,-1 -1,6 1,3 -4,6 -1,2 -1,0 3,6 0,0 -1,1 5,3l1 -2c5,-5 9,-2 6,-13 3,1 4,2 4,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil56",
    d: "M153 988l-5 -1c2,-3 0,-1 2,-2 3,-3 1,1 3,-3 -6,0 -1,0 -6,2l-14 3c0,0 -1,-1 -2,-1 -1,3 1,2 -2,6l6 0c6,0 14,-1 18,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil56",
    d: "M249 400c-3,-2 -3,1 -10,0 -7,-2 0,1 -12,-2 -2,6 2,2 -4,6 11,2 15,2 26,3l0 -1 -5 0c1,-4 1,-3 3,-4 0,0 1,-1 2,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil56",
    d: "M178 509l-7 -1c1,3 2,1 -1,3l0 4c3,1 5,3 9,3 2,-1 2,-1 3,-1l-1 -4c-4,-2 -3,-1 -3,-1 0,0 -4,1 -4,0l4 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil57",
    d: "M202 104l0 11 -6 2c2,-5 -1,-4 -1,-8 0,-5 4,-4 7,-5zm11 16l-1 -2c-3,-1 -2,0 -3,-2 -3,4 0,3 -5,4 0,-3 -1,-5 3,-8 1,-1 0,0 3,-1 -1,-5 -2,0 2,-6 -6,-3 6,0 -2,0l-2 0c0,-3 1,0 -1,-1 -7,2 -2,0 -3,-1 1,-1 1,-2 3,-3 5,-3 1,1 3,-2 1,-3 -3,-1 -6,-2 -3,1 -6,2 -7,4l-1 4 -6 3 0 3c2,2 0,0 1,2l3 1c0,1 0,1 0,1 1,2 1,2 0,6l8 -1c3,5 -1,2 5,6 2,-4 1,-3 6,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil57",
    d: "M226 103l0 -2c0,-4 0,-3 -2,-5 -2,-1 -2,-1 -3,-2l-1 -3 -3 1c-4,-1 -3,-1 -6,1 -2,4 -1,1 0,4l3 -1c1,0 3,4 6,1 0,2 -1,0 0,2 0,1 1,2 2,2 -4,1 -1,1 -4,-2l-2 4c1,0 3,1 4,1 1,0 0,0 2,0 1,0 3,-1 4,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil57",
    d: "M225 699l-3 -8 -11 1c3,6 0,-1 3,3 2,3 1,2 1,5l4 -2c0,0 0,2 0,2l-1 1c0,6 -1,1 2,3 0,0 1,1 1,1l2 1 2 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M331 551l0 -4 -4 4c-3,2 0,1 -3,2 3,-5 6,-3 -2,-12l-4 1 -1 13c-4,-2 2,-2 0,-1l-1 2c0,0 0,0 0,1 0,0 -1,0 -1,0l-3 -6 -6 4c-4,-2 -2,0 -6,-4 2,4 8,9 13,10 0,-3 -2,0 1,-2l10 4c1,-4 1,-2 4,-6 3,-3 2,-2 3,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M356 618c-4,-1 -1,1 -5,-2l-18 -15c-3,-3 0,-2 -4,-3l-3 3c1,4 2,6 6,9 2,1 2,0 4,1 13,7 9,14 18,12 3,-2 0,1 2,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M92 257c-2,-12 -3,-8 -8,-16 -6,-10 -2,-13 -8,-16l-2 0 -3 4 -1 0c4,1 2,0 5,5 1,2 1,3 3,6 2,4 3,9 5,13 3,2 2,1 3,6 6,-1 1,-1 6,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M131 1129c-2,-4 -9,-7 -14,-9 -5,-3 -2,-1 -7,-6 -3,-3 -2,-3 -7,-4l-2 2 0 4 8 4c1,1 13,10 15,11 6,3 0,4 6,4 2,-5 2,-2 1,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M75 308l2 -6 0 -4 3 -1 -2 -3c-2,-2 -2,-1 -6,-1l-9 7 -1 4 8 -3c-2,3 -4,-1 -4,5 0,1 0,4 1,5 1,4 1,2 2,4 4,-2 6,-5 1,-6 1,0 2,1 5,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M312 536c0,-2 0,-3 1,-8 5,2 -1,-1 3,3l5 -9 -5 1c0,1 -1,0 -1,0 -2,-6 1,0 -5,-4 0,0 0,0 -1,0l-5 -4c0,5 -1,5 -1,9 0,5 1,6 1,7 1,1 1,1 1,1 2,2 0,0 2,2l2 3c3,3 1,0 3,4l0 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M173 1203l-6 -10c-14,-22 -4,16 -7,25 10,-2 5,2 9,0 -2,-3 -2,0 -6,-3 -1,-2 -1,-1 0,-4 0,-2 0,-1 1,-2 5,3 -1,2 4,4 0,-3 -1,-3 -4,-5 -2,-2 0,0 -2,-2 1,-5 2,-5 5,-8 1,2 4,4 2,5l4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M121 1102l-12 -16c-3,2 -1,-1 -3,4l-1 2 4 1c1,3 4,6 5,8 4,3 4,1 7,7 4,3 3,8 8,8 1,-6 -4,-11 -8,-14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M309 136c0,4 2,2 0,5 -5,1 -2,-2 -4,-4 0,4 -3,2 -6,1 3,10 -5,3 -1,11 4,6 4,-2 8,3 0,0 1,0 1,0 7,-8 5,-3 6,-8l-1 -4c0,0 0,-1 0,-1 -1,-2 1,-1 -3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M349 641c-5,-3 -4,-6 -9,-10 -5,-5 -3,-2 -7,-9 -2,-3 -2,-4 -5,-5 -2,4 2,9 3,13 3,0 3,0 4,3 3,1 9,12 13,15 0,-2 1,-5 1,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M97 226l-6 -20 -3 3 0 4c2,7 5,15 5,22l2 7c6,-3 3,-10 2,-16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M285 775c-1,-3 1,0 -3,-2l-6 -4 -7 4c0,9 3,3 6,9 0,0 0,1 1,1 9,-7 7,0 9,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M295 507c-1,-2 1,-1 -2,-2l1 -1 -1 -2c-1,1 -3,2 -5,1 -2,0 -1,0 -3,-1 -5,-3 1,-3 -7,-5 1,11 5,4 2,15 4,1 0,0 4,2l1 -1c0,-4 0,0 -1,-2 -1,-5 -2,3 -1,-5l12 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M248 1198l0 0c-2,-3 -2,-2 -6,-2 0,6 1,6 6,9 1,0 1,-1 1,-1 0,0 0,0 0,0 1,-2 1,-1 0,-2l-1 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M309 226l-6 0c1,5 0,1 2,4l3 0 1 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil59",
    d: "M157 729c2,-9 -3,-5 -3,-11 2,5 1,3 6,4 0,-8 -2,-3 -3,-9 3,0 2,-1 4,4 4,-3 2,0 2,-5 -1,-4 -1,-2 -2,-4 0,-4 1,2 1,-4 -11,9 -6,7 -11,10 -3,2 -1,-1 -3,3 -3,3 0,2 -2,6 -2,2 -7,5 -4,9l0 1 3 3c3,-1 5,-5 7,-8l5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil59",
    d: "M169 159l1 -3c-2,-3 -3,-5 -5,-7 1,2 7,3 9,3 1,-5 0,-4 -4,-7l-5 -4c-7,5 -1,3 -3,12 -2,4 -2,11 0,13l1 -3c3,-1 0,-1 4,0 2,-2 2,3 2,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil60",
    d: "M83 253c-2,-4 -3,-9 -5,-13 -2,-3 -2,-4 -3,-6 -3,-5 -1,-4 -5,-5l-5 3c2,6 1,1 1,5l1 4c1,2 -1,1 3,2 2,-3 1,-1 1,-6 -2,2 1,7 3,9 4,2 1,-1 3,-1 0,0 2,0 3,1 0,1 0,1 1,1 -3,5 -6,4 -10,2 -2,-3 -1,-1 0,-6 -7,1 -5,3 -6,-1l-4 1 -1 2c2,2 5,4 7,6 3,3 5,2 6,5 3,-2 5,-2 9,0l1 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil60",
    d: "M109 1120l-8 -4 -6 4 4 16 14 2 -2 -4c-2,1 -2,1 -4,-3 2,-2 4,-2 3,-7 -1,-6 -1,2 -1,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil60",
    d: "M359 598l-5 -1 -5 1c0,4 1,5 1,6 -1,5 -6,2 0,10l1 1c0,0 0,1 0,1 4,3 1,1 5,2l6 -4 -3 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil60",
    d: "M101 1155l4 -3c0,0 3,-2 3,-2l5 -6c-3,-1 -4,-2 -7,-3 -6,-2 -6,1 -7,-3l-7 7c3,5 3,5 3,11l6 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil60",
    d: "M363 582c-4,-4 -3,-2 -9,-2 -2,6 -1,-1 -6,6l-1 1c-2,3 1,-1 -2,3 5,1 7,3 14,5 5,-2 3,-1 6,-5l-2 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil60",
    d: "M335 633c-1,-3 -1,-3 -4,-3l-2 0c-3,-5 0,-5 -6,-7 0,6 1,12 5,15l4 -2c0,-8 0,0 -3,-5 7,0 -1,-1 6,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil61",
    d: "M176 982c4,-5 6,-3 11,-11l-2 0c-2,1 -8,3 -9,4 -5,0 -2,-2 -7,-4 -5,2 -3,2 -6,5l-4 -1 -1 1 -5 5c0,1 0,1 0,1 -2,4 0,0 -3,3 -2,1 0,-1 -2,2l5 1c8,0 15,-6 23,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil61",
    d: "M197 952c0,3 -1,1 2,3 -1,1 -1,0 -3,1 0,0 -2,1 -2,1l3 1c4,-2 10,-5 13,-9 -2,-1 -4,-4 -7,-3l0 5 -6 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil61",
    d: "M212 333l0 1c-2,-1 -5,1 -1,-8 -7,6 -5,4 -7,10 -5,-5 0,0 -2,-7 -4,6 -3,5 0,11 4,-2 8,-3 10,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil61",
    d: "M238 1090c-2,-2 -3,-4 -6,-4 -6,-1 -2,1 -10,0 0,0 15,9 16,9 1,-4 -1,0 3,-4l-3 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil61",
    d: "M309 378l-3 1 1 3c-2,2 -2,1 -6,1l1 5 10 -3c-1,-6 0,-4 -3,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil61",
    d: "M226 1115l0 0 -5 -1c3,4 1,1 0,2 -3,-1 -1,0 -2,-3l-5 1c1,4 0,1 3,4l2 4c5,-1 2,0 3,-2 1,-3 0,-3 4,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil61",
    d: "M189 525c-1,-2 -2,-2 -5,-2 0,3 -1,2 -4,4l1 2c1,-2 -3,-3 2,-1 2,3 1,1 0,2 3,3 1,2 5,3l-1 -7 2 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil62",
    d: "M326 601l3 -3c4,1 1,0 4,3 2,-2 1,-2 4,-2l-1 -4c0,0 0,-1 0,-1l5 0c-2,0 -6,-1 -8,-2 -4,-2 -3,0 -2,-4 3,-2 10,1 14,2 3,-4 0,0 2,-3l1 -1c5,-7 4,0 6,-6l-27 2c-1,10 -2,12 -4,22l3 -3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil62",
    points: "74,688 72,686 68,687 67,691 70,691 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil62",
    d: "M287 1194c3,4 2,0 3,4 3,-2 2,-1 2,-5 -4,0 -3,-1 -5,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil63",
    d: "M122 1019c-6,3 -3,2 -6,0 3,-2 -3,-3 3,-1 5,0 1,-1 3,1zm46 5l-1 -3 5 -3 -2 -2c-5,1 -11,4 -16,5 -4,1 -14,2 -19,-1 2,-3 4,-2 7,-4l-1 -1c-22,3 -18,0 -23,0l-3 0c0,0 0,1 0,1l2 5c1,3 11,7 15,7l5 0c2,-4 0,5 -1,-1l0 -1c0,-1 -2,-1 2,-2 1,-1 7,0 8,0 7,-1 12,-3 19,-4 0,1 0,1 0,1l3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil63",
    d: "M231 978l2 -2 3 2 3 2c2,-3 4,-5 4,-7 -2,-1 0,-3 -4,0 -6,3 3,-2 -2,1l-1 1c-1,1 -1,1 -1,1 1,-2 3,-2 -2,-8 -2,10 -4,6 -7,14l5 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil64",
    d: "M60 539c4,8 5,12 12,14 10,3 3,1 9,4 1,-4 -1,-2 3,-3 6,-1 -3,2 2,0 -2,-9 -5,-9 -6,-10 -2,-2 0,-2 -2,-4 -6,-5 -5,0 -7,1l-6 -6c-1,0 -1,0 -1,0 -2,0 -3,0 -4,0l0 4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil64",
    d: "M216 918l1 -1c-5,1 -4,-2 -5,-6 -3,-1 -2,-1 -5,-5 0,1 1,5 1,5 -1,7 1,4 -4,5 -2,-4 0,-4 -3,-8 -1,3 3,1 -2,5 1,9 -1,6 -7,7 0,0 0,0 0,0 0,0 0,2 0,2l2 2 10 2c0,-5 0,-4 2,-8 6,0 3,1 7,1 4,1 -1,0 3,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil64",
    d: "M122 476l3 -1c-3,-3 -2,-1 -3,-6l-5 2c0,6 2,1 -1,6 5,1 1,1 6,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil64",
    d: "M308 1115l-5 -5c-3,5 -1,8 3,10l2 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil65",
    d: "M196 789l-6 1 0 -7c8,-6 -1,4 5,-1 -1,-3 -2,-2 -3,-5l-2 -2c-3,-3 -1,0 -2,-4 -1,-3 0,-1 -1,-4 -2,0 -4,-2 -5,-2 -3,1 -3,3 -3,4l1 2c2,3 2,4 -1,8 -2,3 -2,3 -3,7 4,0 4,0 7,-1 3,0 1,-3 4,0 2,2 1,0 1,4 0,7 1,-1 0,2 -1,1 1,1 -2,-1l-4 0c-1,3 7,5 12,6 3,1 2,0 6,1 2,-1 3,-5 3,-7 -1,1 -2,2 -3,2l-2 1c-1,0 -2,1 -3,1 -1,-3 -1,-2 1,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil65",
    d: "M222 181c3,8 1,1 4,5l-1 -1c0,0 0,0 -1,-1 0,8 1,1 -3,6 0,0 0,0 0,0 -2,2 0,2 -4,5 2,-13 -2,-3 3,-15 0,6 0,-1 2,1zm22 17l0 -3c0,0 -3,0 -3,0 0,0 0,0 -1,0 -2,0 -2,0 -4,-1 -3,-3 1,1 -2,-2 -2,4 1,1 -3,3 -1,-2 -1,-5 -3,-8l3 -1c2,-2 -1,-1 3,-3 -5,2 -5,2 -8,-1l-1 -1 -3 0c0,-2 0,-5 -3,-5 -2,-1 -5,1 -8,1l1 3c4,3 5,7 2,12 2,2 4,4 7,3 3,-1 2,-2 4,-4l3 1 -1 4c-3,1 -2,-2 -4,2 3,4 -1,0 1,1 3,1 17,-1 20,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil65",
    d: "M212 118c0,-4 -1,-1 1,-4 0,-1 6,-4 8,-4l-2 -2c0,0 0,-1 0,-1 3,0 2,0 4,-1l3 -3c-1,0 -3,1 -4,1 -2,0 -1,0 -2,0 -1,0 -3,-1 -4,-1l1 4c-2,-1 -1,-2 -3,0 -3,3 1,3 -4,4 -3,1 -2,0 -3,1 -4,3 -3,5 -3,8 5,-1 2,0 5,-4 1,2 0,1 3,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil65",
    d: "M192 695c-3,0 -2,-1 -4,2 2,1 0,-1 1,2l2 3c2,-5 -1,-4 4,-7l-3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil66",
    d: "M180 771c0,3 1,4 -1,5 -1,4 -3,7 -7,8 -2,2 -5,1 -8,1 -4,-4 -6,-5 -5,-11l-4 2 -2 -7c-3,1 -3,1 -6,3 1,2 2,3 4,4l12 11c2,1 1,-1 3,4l34 8 0 -2c-4,-1 -3,0 -6,-1 -5,-1 -13,-3 -12,-6l4 0c3,2 1,2 2,1 1,-3 0,5 0,-2 0,-4 1,-2 -1,-4 -3,-3 -1,0 -4,0 -3,1 -3,1 -7,1 1,-4 1,-4 3,-7 3,-4 3,-5 1,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil66",
    d: "M216 103l2 -4c3,3 0,3 4,2 -1,0 -2,-1 -2,-2 -1,-2 0,0 0,-2 -3,3 -5,-1 -6,-1l0 4c-6,-1 -1,-1 -4,1 -2,0 -3,1 -3,3 2,1 1,-2 1,1l2 0c8,0 -4,-3 2,0 -4,6 -3,1 -2,6 5,-1 1,-1 4,-4 2,-2 1,-1 3,0l-1 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil67",
    d: "M163 109l-2 -1c2,-7 2,0 3,-7 -7,3 -34,21 -36,29 7,3 12,-3 18,-8 4,-2 16,-10 17,-13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil67",
    d: "M231 156c6,-1 6,0 7,-5l-3 1 -8 1 -6 1c-3,3 -14,9 -19,9 0,-4 3,-14 1,-17l-3 3 1 1 -1 2c-1,7 -3,9 0,15 6,0 11,-3 16,-5 6,-3 9,-4 15,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil68",
    d: "M267 449l-3 0c-4,-5 1,-2 -5,-3 -3,0 -1,1 -6,-1l0 -3c-2,-2 0,-2 -6,-2 -8,-1 -6,1 -16,-2 -7,-2 -6,0 -7,1 5,3 4,-1 6,5l-7 -1c4,4 15,8 20,7 3,-1 9,0 13,0 11,1 7,4 11,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil68",
    d: "M245 961c0,1 0,2 0,3l1 3c2,4 3,3 1,9 -1,3 -5,11 -7,13 -1,3 0,3 -4,4l2 -5 2 -4 -2 -1c-5,2 -2,1 -5,6l-2 -2c0,0 0,0 0,0 -2,-1 -1,-1 -2,0 -1,3 1,-1 -1,3 0,1 -1,2 -2,3 4,0 4,-2 7,0 -3,2 -7,5 -9,6l-1 4c-1,0 -1,0 -2,1 -1,0 -1,0 -1,1l-1 6c4,-2 20,-14 23,-18 5,-8 12,-26 3,-32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil68",
    d: "M164 479l-1 -5c-8,1 -18,4 -24,9l19 -7c3,2 3,2 6,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil69",
    d: "M220 725c1,-4 4,-15 3,-18 -10,2 0,-2 -11,2 -5,2 -6,0 -9,6 7,0 11,2 9,9 3,1 0,-1 0,4l2 6c1,1 0,-2 1,2 2,4 -1,3 1,7 2,3 -3,0 3,1 3,-6 1,-4 1,-11 0,0 0,-1 0,-1 0,-3 1,-4 0,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil69",
    d: "M162 166c-2,-2 -2,-9 0,-13 2,-9 -4,-7 3,-12 3,-5 0,2 5,-1l-4 -4c1,-5 4,-6 2,-10 -4,-1 0,0 -3,-3 -12,22 -10,30 -5,53l3 -1c1,-5 0,-5 -1,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil69",
    d: "M232 123c-2,-4 -2,-6 -3,-11 0,-6 -3,-7 -3,-11l0 2 -3 3c-2,1 -1,1 -4,1 0,0 0,1 0,1l2 2c-2,0 -8,3 -8,4 -2,3 -1,0 -1,4l1 2c2,-2 6,-1 10,-1l1 3c3,4 0,0 1,3l1 2c0,1 0,1 1,1 1,-3 1,-2 0,-7 0,0 1,1 2,-1 2,5 0,2 3,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil70",
    d: "M163 752c-3,0 -4,0 -6,-2 -1,0 -2,-2 -3,-2 -1,-2 0,0 -1,-2 -4,-2 -1,-8 0,-11 3,-5 6,-4 10,-7l-2 -2c-1,-4 0,-1 0,-1 -3,5 -1,4 -4,4l-5 -1c-2,3 -4,7 -7,8l-3 -3 -1 4c3,1 5,2 6,6 -3,3 -2,1 -4,0 -4,6 -3,7 -2,9l1 0c7,9 4,-5 6,5 2,-2 1,-1 5,-3 0,1 -1,1 1,4 4,3 2,-1 4,3 3,-3 0,0 2,-3 0,-1 1,-2 1,-2 1,-2 1,-2 2,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil70",
    d: "M190 171c-3,1 -5,1 -8,0 -2,0 -2,0 -3,-1 -3,-2 -1,-2 -2,-2 -9,-6 2,-17 3,-19l-3 -4c-3,3 0,5 -3,7 -2,0 -8,-1 -9,-3 2,2 3,4 5,7l-1 3 4 3c-3,2 2,3 -7,2 0,0 1,0 1,0 5,2 2,2 6,6 -3,1 -3,4 -5,8 1,4 0,-1 4,2 7,0 3,-3 10,-2 2,1 7,2 9,3 -1,-5 -3,-6 -1,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil70",
    d: "M227 153c-2,-4 -1,-1 -2,-5 3,-2 2,-2 6,-1l-1 -1c-2,-2 0,0 -1,-2l0 -1c0,1 -1,1 -1,1 0,0 -1,0 -1,0 -3,1 -1,1 -4,2 -3,-4 -2,-7 -10,-11 -1,0 0,-2 -4,-1 -3,1 -1,1 -3,5l-4 -4c2,7 -1,4 -1,4l4 3c9,14 10,8 16,12l6 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil70",
    d: "M189 145l3 0c1,-4 5,-1 3,-7 -1,-5 0,-6 3,-10l-3 0c-11,1 2,5 -4,0l0 1c-1,5 1,2 -3,5 -7,4 -3,4 -5,8 -2,4 -2,-2 -2,5 3,0 4,-1 7,-8 0,-2 0,-1 1,-3l1 -2c1,2 4,3 -1,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil70",
    d: "M182 726l0 -1 -1 -4c0,-4 2,-1 -1,-4l-10 1 -1 5c3,1 2,0 3,1 3,-4 0,-3 5,-5 1,3 2,3 -2,7 2,2 2,-2 2,3l5 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil71",
    d: "M138 1000l0 -5 6 -1 0 3c3,0 13,-3 15,-4 1,-3 2,-3 5,-4l13 -5c3,-2 2,-1 3,-3l-4 1c-8,0 -15,6 -23,6 -4,3 -12,4 -18,4l-21 2 -4 1c1,2 -1,2 7,2l2 1c5,1 4,1 9,-1 1,2 1,-1 0,3l0 3 2 0c1,-4 -2,-4 3,-4 0,0 4,1 5,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil71",
    d: "M332 327c-1,-5 -18,-18 -24,-17 -8,0 -17,-4 -22,-2 4,3 17,5 18,5 1,0 2,-1 3,-1 5,6 9,1 12,9l0 3c2,0 3,1 4,1 7,2 3,2 8,4l-2 8 -4 -4c-5,-3 -5,-4 -7,-10l-5 -1c1,2 3,4 4,6 2,4 1,4 4,7l0 0c3,0 0,0 3,2l2 2c3,2 5,1 5,8l1 -5c0,-1 0,-3 0,-4 1,-5 0,-7 0,-11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil71",
    d: "M254 412c8,-5 18,2 22,-7l-27 2c-11,-1 -15,-1 -26,-3l-12 -2 4 5c4,2 3,-1 9,2l-2 2 4 0 1 2 3 0c3,-5 0,-4 7,-4l1 3c4,-1 5,-1 8,-1 4,1 3,2 8,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil71",
    d: "M214 892c0,-5 -13,-10 -18,-11 -2,1 -6,0 -8,1 2,2 0,0 3,1 8,3 6,0 8,4l2 3 5 -3c1,3 4,2 -1,3l7 1c1,4 1,3 1,8 -4,-2 -1,1 -7,-2 -1,-1 0,0 -2,-2l-1 0c-1,0 -1,-1 -1,-1 -1,-1 0,0 -2,-2l-5 -3c0,0 -1,-1 -1,-1l5 -1c-5,1 -6,0 -9,-2 -5,4 -1,1 -2,4 4,0 3,-1 5,2 5,1 6,4 10,8 6,3 3,0 6,5 2,0 3,-1 4,0 3,2 3,3 3,6 0,0 1,0 1,-1 1,-15 -2,-2 -3,-17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil71",
    d: "M97 973c4,-2 8,-8 9,-11 -2,-1 -1,0 2,-4 0,0 2,-2 2,-2 2,-3 1,0 2,-4l-4 1c-1,1 1,1 -3,1 2,3 0,0 2,4 -4,2 -6,4 -8,8l-4 5c-3,5 -3,4 -2,12l0 3 1 0c0,-8 1,-7 3,-13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil71",
    d: "M107 997c0,0 0,0 0,0l-6 -2 -1 2 1 2 6 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil72",
    d: "M246 198l-2 0c-3,0 -17,2 -20,1 -2,-1 2,3 -1,-1 2,-4 1,-1 4,-2l1 -4 -3 -1c-2,2 -1,3 -4,4 -3,1 -5,-1 -7,-3l0 1 -2 3c-3,4 -5,5 -10,4 -3,3 -12,-2 -16,-3 -2,-2 -4,-2 -7,-3 2,6 18,11 25,12 7,0 24,-3 32,-5 2,0 4,-1 6,-1 0,0 2,-1 2,-1 3,-1 1,0 2,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil72",
    d: "M160 702l1 -1 0 -2 -2 0c-7,5 -17,14 -19,23 1,-2 2,-4 4,-5 1,-1 1,-1 2,-2 5,-4 7,-7 10,-13l4 0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil72",
    points: "173,116 168,119 169,121 172,121 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil73",
    d: "M95 971c-2,-3 -1,-1 -2,-3 0,0 -2,-2 -2,-2 2,-4 2,-7 4,-10 2,2 2,-2 0,5 6,-2 2,0 3,0l1 5c2,-4 4,-6 8,-8 -2,-4 0,-1 -2,-4 -2,-2 0,-1 -2,-3 -7,1 3,3 -8,5 2,-5 0,-4 4,-8l2 -1c-5,-3 -2,0 -4,-1 -4,-1 3,3 -2,-1 -2,-2 1,0 -2,-2 -5,6 -2,5 -6,6 0,-1 1,-2 1,-3 0,-3 0,-2 -1,-3 -5,4 -4,8 -5,14l2 3 3 -2c2,4 0,3 4,3 -2,5 -2,2 -1,10 -4,3 4,-2 -1,1 -2,1 1,-2 -1,0 3,5 2,-1 3,7l0 4 2 0c-1,-8 -1,-7 2,-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil73",
    d: "M242 324l2 1 7 -1c3,-3 0,-2 6,-2l-1 -4c2,1 5,-1 7,-2 -3,-4 0,0 -2,-1 -7,-4 -4,-3 -9,-3 2,4 3,3 1,8 -6,1 -4,0 -9,1 -10,4 -7,1 -8,0 6,-4 10,1 13,-6l-8 -1 12 -4c-4,0 -4,-2 -10,1 -6,2 -3,1 -6,4l-1 -1c-3,-2 -3,-2 -7,-1 1,1 4,1 4,1 -4,4 -5,-2 -6,6 2,-1 2,-2 3,-2 2,0 5,-1 6,-1 0,0 -1,0 -1,0l-5 4c0,1 0,1 0,1 -3,2 -3,0 -7,3 3,3 5,0 4,5l3 0c-1,-10 3,-5 12,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil73",
    d: "M199 982l4 0 0 2c3,-2 2,-1 5,-3l0 -4c1,-4 0,-1 2,-2l0 -1 7 -1 2 -4c-3,0 -1,0 -3,0 -3,-1 -2,-1 -4,-2 2,-11 3,-9 13,-6l-1 -2c-1,-4 -3,-5 -8,-5 -3,5 -9,13 -14,17 -4,3 -4,2 -8,6 -3,4 -5,4 -9,7 2,0 2,-1 3,1l3 -3c7,-5 3,-3 7,-4 5,-2 2,-1 4,0l-3 4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil73",
    d: "M158 1001c5,-3 3,0 4,-6 5,2 2,2 5,1l0 2c0,0 0,0 0,0l-3 2c2,-1 2,-1 4,-2 6,-3 4,-3 9,-4l2 -5c4,-2 5,0 5,-5 -4,1 -7,3 -11,4 -3,1 -4,2 -6,3 -3,1 -6,1 -8,2 -2,1 -12,4 -15,4l0 4 4 2 10 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil73",
    d: "M196 375l0 -1c0,-3 -2,-8 5,-16 3,-2 2,-1 4,-4 -4,-3 -7,0 -7,0l-3 -3c3,-4 2,-2 1,-6 -4,3 -7,7 -7,13l0 5 4 -3c-1,3 -1,1 1,4 -1,1 0,1 -1,1 0,0 -1,0 -1,0 3,4 1,2 0,8 -3,3 -1,0 0,7 2,-4 1,-3 4,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil73",
    d: "M253 394l0 0c-4,-2 -6,-2 -9,-5 -5,-4 2,-3 -7,-4 -1,15 6,0 4,9l-2 0c-7,0 0,-2 -11,-6 -7,1 -3,3 -9,0 2,6 4,3 11,4 2,5 -1,4 3,6 2,0 10,2 11,0 0,-2 0,-1 3,-2 1,-1 5,-1 6,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil73",
    d: "M238 983c0,0 -2,-1 -3,-1 -2,-1 0,0 -2,-1l-2 -3 -5 4 -3 3 0 2c0,4 1,2 0,7 0,3 -3,3 1,5 2,-1 6,-4 9,-6 -3,-2 -3,0 -7,0 1,-1 2,-2 2,-3 2,-4 0,0 1,-3 1,-1 0,-1 2,0 0,0 0,0 0,0l2 2c3,-5 0,-4 5,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil73",
    d: "M136 908c1,-1 2,-3 2,-4 1,-1 1,-1 2,-3l6 -4c1,-6 1,-2 -1,-3 -4,1 -2,0 -4,2 0,0 -1,1 -1,1 -5,-3 -4,-3 -8,0 0,3 -3,-3 1,1 1,1 1,1 1,2 3,4 -1,4 -1,4 -1,5 2,0 -4,2 -5,2 -3,1 -4,4l2 1c7,-1 4,-2 9,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil73",
    d: "M113 903l2 0 -3 5 7 -3c-3,3 -1,2 -6,4l2 2 4 -2c8,-6 10,-3 10,-9 0,0 -2,1 -3,1l-4 0c4,-2 3,-1 7,-4l3 -3c-13,4 -9,5 -15,8 -3,1 -2,-2 -4,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil73",
    d: "M232 1117c-2,7 -1,-1 -4,6l5 4c4,-1 2,1 8,-2 1,-4 0,-5 0,-7l-9 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil73",
    d: "M206 1012c-1,-5 0,-2 -2,-5 -1,-2 -1,-2 -2,-3 -4,-1 -10,2 -12,5 8,-1 9,6 12,1l4 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil73",
    d: "M211 361l-1 0c-2,-2 -2,3 -1,-5l-5 4c3,4 2,-1 -3,4 0,0 1,1 2,1 -3,4 -2,3 -1,5 3,-2 7,-5 11,-6l-2 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil73",
    d: "M262 1031c-4,0 -4,-1 -7,2 0,1 -2,2 3,3 4,2 2,0 4,0l0 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil74",
    d: "M170 1016l0 -4 2 0c4,-1 4,0 7,2l3 -1 3 -5 4 1 1 0c2,-3 8,-6 12,-5 -4,-5 -4,-1 -5,-7 -5,4 -29,15 -35,16l-15 5 0 -6 -1 0 -1 6 -3 -2c-3,2 -5,1 -7,4 5,3 15,2 19,1 5,-1 11,-4 16,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil74",
    d: "M277 437c4,-4 8,-4 14,-4 -3,-5 -2,-2 -2,-7 -4,2 -24,6 -28,5 -4,3 -7,2 -13,2 -5,0 -9,1 -14,-1 0,0 -2,0 -2,0l-2 -1 -7 1c2,3 -1,0 3,3 2,0 3,1 4,1 17,5 22,-1 28,2 0,-2 -1,-4 1,-4 8,1 4,3 10,4 4,-4 2,-4 7,-4l1 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil74",
    d: "M333 430c2,-5 1,-2 5,-6 7,-9 4,-9 5,-18 0,0 -1,-1 0,1 1,2 0,0 0,0l1 -4c-1,-4 -2,-6 -5,-9l-3 1 2 6c1,5 4,12 0,17 -3,5 4,-2 -1,1 -2,0 -1,0 -2,2 -2,5 1,4 -4,7 -3,1 -1,-1 -4,3 2,2 -3,3 3,1l3 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil74",
    d: "M199 377c-4,0 -2,1 -3,-2 -3,2 -2,1 -4,5l-1 7c2,2 -1,1 2,1 0,-5 2,-9 6,-11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil75",
    d: "M178 1029l2 0 0 -3 -2 1 0 -3c-6,-1 -6,2 -10,0l-3 -3c0,0 0,0 0,-1 -7,1 -12,3 -19,4 -1,0 -7,-1 -8,0 -4,1 -2,1 -2,2l0 1c1,6 3,-3 1,1l-5 0c5,5 15,4 22,5 3,-2 9,-2 13,-3 2,0 11,-2 11,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil75",
    d: "M212 334l0 -5c5,-2 9,1 15,1 1,-5 -1,-2 -4,-5 4,-3 4,-1 7,-3 0,0 0,0 0,-1l5 -4c0,0 1,0 1,0 -1,0 -4,1 -6,1 -1,0 -1,1 -3,2 1,-8 2,-2 6,-6 0,0 -3,0 -4,-1 -5,1 -7,3 -11,5 4,-6 2,-2 6,-6 -4,1 -7,3 -11,5 -5,2 -6,6 -8,7 -2,4 -1,3 -3,5 2,7 -3,2 2,7 2,-6 0,-4 7,-10 -4,9 -1,7 1,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil75",
    d: "M141 1015l-1 -1 -1 -2 -10 0c-1,-1 2,-1 -2,-1 -6,1 -1,0 -3,2 0,0 0,-1 -1,-1l-1 -2c-8,-7 -1,2 -4,-3 2,-2 -3,-1 10,-3l0 -1 0 -3 -19 -2c-7,0 -2,0 -4,2 10,9 1,-2 13,6 -2,4 -3,3 -4,6l-3 -5c-3,5 -3,3 -4,0 1,7 0,0 -2,3 3,1 4,8 12,11l-2 -5c0,0 0,-1 0,-1l3 0c5,0 1,3 23,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil75",
    d: "M286 399l-4 -1c-10,1 -9,4 -13,-4l-4 0 -3 2 -1 1c-3,-2 -3,-2 -6,-1l-5 4c0,0 0,0 -1,0 -1,1 -2,2 -2,2 -2,1 -2,0 -3,4l5 0c7,-1 13,-1 20,-1 13,-1 9,-3 17,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil75",
    d: "M327 407l0 -1 -1 -9c-3,0 1,-1 -1,0 -5,3 2,0 -2,1 -1,-3 0,1 0,-2l0 -3c-8,2 -11,0 -12,9l6 4 3 -1 -1 10c4,-1 6,-5 8,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil75",
    d: "M262 419c-1,-1 -3,-2 -4,-2 -6,-1 -1,0 -5,1 -3,1 -8,0 -12,1l3 2 0 3 4 -1c1,0 1,1 1,1 3,4 3,5 6,6l3 -1c6,-3 7,-1 7,-7 -6,-2 -5,1 -8,-1 3,3 4,0 5,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil75",
    d: "M228 969l1 -6 -5 -4 1 2c-10,-3 -11,-5 -13,6 2,1 1,1 4,2 2,0 0,0 3,0l2 0c2,3 2,5 2,9 4,-2 6,-5 5,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil75",
    d: "M209 1018l0 -2c-2,-2 -2,-3 -3,-4l-4 -2c-3,5 -4,-2 -12,-1l-1 0 -2 9 3 3c3,-2 1,0 5,-2 2,-1 3,-2 5,-3l4 4c4,-1 3,0 5,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil75",
    d: "M140 969c-3,1 -2,2 -3,5 6,3 8,-2 6,6 -2,0 -4,0 -6,0 -5,1 -3,1 -4,3 4,2 10,0 14,-2 0,0 0,-1 0,-1 0,0 0,-1 0,-1l6 -4c-11,-1 -8,-2 -13,-2l0 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil75",
    d: "M104 920l0 1c0,-4 1,-4 5,-5 0,0 -1,0 -1,-1l-4 -5c-3,2 -2,2 -5,5 -3,4 -3,1 -2,6l7 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil76",
    d: "M184 984l1 0c4,-3 6,-3 9,-7 4,-4 4,-3 8,-6 5,-4 11,-12 14,-17l1 -7 -12 14c-3,4 -6,6 -10,9 -5,2 -1,2 -4,0 -3,1 0,1 -4,1 -5,8 -7,6 -11,11l4 -1c-1,2 0,1 -3,3l-13 5c-3,1 -4,1 -5,4 2,-1 5,-1 8,-2 2,-1 3,-2 6,-3 4,-1 7,-3 11,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil76",
    d: "M199 887l0 0c-2,-4 0,-1 -8,-4 -3,-1 -1,1 -3,-1 2,-1 6,0 8,-1 -4,-3 -33,-4 -38,0 -2,3 -3,2 -7,4 2,2 1,4 9,3 6,-1 24,-2 28,1 1,-3 -3,0 2,-4 3,2 4,3 9,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil76",
    d: "M321 335c-3,-3 -2,-3 -4,-7 -1,-2 -3,-4 -4,-6 0,-4 0,-1 1,-2l5 1c-3,-8 -7,-3 -12,-9 -1,0 -2,1 -3,1 -1,0 -14,-2 -18,-5 5,-2 14,2 22,2 -3,-3 -9,-4 -14,-4 -9,3 -12,-2 -19,0l-2 1c2,3 3,3 3,3 0,0 1,0 1,0 6,3 20,3 32,10 0,0 0,0 0,0l-3 3c3,2 2,1 3,1 4,2 7,6 5,5l1 4 0 1 4 3c2,-1 1,3 2,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil76",
    d: "M245 961l-2 -3 1 9 -4 -7c0,0 0,1 -1,0l-3 3c-3,3 -2,0 -3,5 5,6 3,6 2,8 0,0 0,0 1,-1l1 -1c5,-3 -4,2 2,-1 4,-3 2,-1 4,0 0,2 -2,4 -4,7l-3 -2 0 3 -3 0c2,1 0,0 2,1 1,0 3,1 3,1l2 1 -2 4 2 1c2,-2 6,-10 7,-13 2,-6 1,-5 -1,-9l-1 -3c0,-1 0,-2 0,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil76",
    d: "M93 943c2,-3 3,-2 5,-5 1,-5 4,-6 1,-9 -3,3 -6,6 -10,9 0,3 0,2 -3,4l1 1c1,1 1,0 1,3 0,1 -1,2 -1,3 4,-1 1,0 6,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil76",
    d: "M222 411l2 -2c-6,-3 -5,0 -9,-2l-4 -5c-3,-1 -4,-1 -7,-1 -1,-1 -3,-2 -4,-2l-4 0 0 2c3,4 2,1 8,3 13,5 14,5 19,10l-1 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil77",
    d: "M117 921l3 1 -2 3 -1 -4zm5 9l3 -1 3 -8c-4,3 -1,1 -6,3l0 -1c-3,-5 -3,-1 -5,-5 4,-2 5,0 9,-1l-5 -3 -4 4 0 3 -7 2c0,2 0,3 2,3 -6,4 -3,-1 -5,6l6 1c-1,2 -3,-2 -10,-3l1 2c0,1 0,1 0,1 1,3 2,2 -1,5l2 1c0,0 0,0 1,0 0,0 0,0 0,0 -1,3 -4,6 0,8 4,2 3,-2 8,1 1,-9 0,-7 6,-12l0 -5 2 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil77",
    d: "M235 341l1 0c3,-3 4,-3 6,-7 -4,2 -4,2 -8,2 -2,1 -4,1 -9,0 -5,-1 -1,2 -5,-2l-4 5c0,1 -1,0 -1,1 1,2 1,2 2,4 2,4 -2,0 2,4 2,-1 0,-2 5,-2l-1 4c8,-3 6,-1 8,-7l4 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil77",
    d: "M150 960l-2 2c1,4 1,2 3,5l5 2c1,-3 2,-7 0,-10 -3,1 -1,1 -3,4l-3 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil77",
    d: "M222 356l1 -4c-4,-1 0,0 -3,-2l-2 -1 -4 -2c-1,8 1,1 1,9l-2 1 2 -2c3,0 5,0 7,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil77",
    d: "M144 1001l0 -4 0 -3 -6 1 0 5 4 -1 1 5c1,-1 1,1 1,-3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil77",
    points: "290,392 287,392 284,388 283,396 289,395 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil78",
    d: "M229 143c-2,-1 -1,-1 -3,-1 -2,-1 -1,-1 -2,-1l-3 -7c5,2 4,2 8,2l-2 -2c-4,-1 -6,-1 -7,-5 -4,1 -7,4 -9,0 -4,0 -4,0 -4,-4 -6,-4 -2,-1 -5,-6l-8 1c1,-4 1,-4 0,-6 0,0 0,0 0,-1 0,6 0,7 -1,12l-2 3c6,5 -7,1 4,0l3 0c-3,4 -4,5 -3,10 10,0 4,0 7,-3l4 4c2,-4 0,-4 3,-5 4,-1 3,1 4,1 8,4 7,7 10,11 3,-1 1,-1 4,-2 0,0 1,0 1,0 0,0 1,0 1,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil78",
    d: "M202 104c-3,1 -7,0 -7,5 0,4 3,3 1,8l6 -2 0 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil78",
    d: "M214 96l-3 1c-1,-3 -2,0 0,-4 -3,1 -5,1 -7,3 3,1 7,-1 6,2 -2,3 2,-1 -3,2 -2,1 -2,2 -3,3 1,1 -4,3 3,1 0,-2 1,-3 3,-3 3,-2 -2,-2 4,-1l0 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil79",
    d: "M71 84c-4,-3 -4,-3 -3,-8 4,-1 4,0 6,-2l-1 -3c-3,-2 1,-1 -1,1 0,0 1,3 -3,0 -7,-6 2,-6 -3,-8l-3 -2c-3,2 -3,7 -9,4 0,1 1,0 0,2 0,0 -1,1 -1,1l-2 3 -6 6c1,3 -1,5 5,0l3 2c3,1 2,-1 3,2 -2,2 0,0 -4,0l1 3c4,1 2,0 3,2 2,-2 3,-3 6,-2 5,1 1,0 2,2 2,3 -2,1 2,2l1 -5 4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil79",
    d: "M355 563c-1,-2 -1,-2 1,-4l-8 1c-10,2 -1,5 -13,5l-3 -6c4,-6 6,-7 7,-14l5 1c2,3 1,2 4,4 0,0 2,2 2,2 3,1 1,1 3,0 -8,-9 -8,-7 -12,-19l-6 0c-3,6 1,5 2,10l-6 8c-1,4 0,3 -3,6 -3,4 -3,2 -4,6 1,-3 0,-1 3,-3 4,2 2,-1 2,3l2 -1c1,2 0,2 4,4l-1 4c2,1 5,1 7,1 5,-1 5,-6 14,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil79",
    d: "M63 300l9 -7 0 -3c-3,0 -2,0 -4,-2 0,0 0,1 0,1 0,0 -1,0 -1,1 -3,7 -3,3 -9,7 -5,5 5,5 -6,4 -2,0 -3,-2 -1,0l-1 -7c-3,-2 0,-4 -3,-1 0,7 2,8 0,18l4 3c4,-2 4,-2 4,-6 -4,-1 4,2 -2,0 -2,0 0,2 -1,-1 -1,-3 2,-2 11,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil79",
    d: "M43 278c-5,-1 -2,0 -4,0 1,4 -1,2 3,4 8,-1 7,1 11,3 5,1 2,0 8,-1 5,0 5,3 9,-2 -2,-3 -1,-2 -6,-3 3,-2 3,-1 2,-2 -6,0 -15,5 -23,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil80",
    d: "M348 648c-4,-3 -10,-14 -13,-15 -7,-3 1,-2 -6,-2 3,5 3,-3 3,5l-4 2c1,5 1,3 2,6 1,1 1,2 2,3 1,2 0,1 1,2 0,-1 0,0 1,-2 0,-2 0,-1 1,-3 4,5 0,5 10,3 0,0 0,1 0,1 0,0 0,0 0,1 0,0 -1,0 -1,0 -2,3 -3,1 -2,5 0,5 2,4 2,12 0,-1 0,-1 -1,-1 0,-1 0,-1 -1,-1l-3 -3 -2 0c3,5 10,17 17,16 0,-4 -3,-9 -5,-13 -2,-9 -2,-8 -1,-16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil80",
    d: "M333 622c4,7 2,4 7,9 5,4 4,7 9,10 8,-7 -2,-12 -3,-13 0,0 -1,0 -1,-1l1 -2c0,0 0,0 0,0l-1 -4c-2,1 -1,1 -3,1 -6,2 -2,0 -9,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil80",
    d: "M88 213c-5,-1 -6,3 -6,8 2,1 -1,0 2,0 1,1 2,1 2,1 -4,11 3,0 0,9 9,0 -2,1 7,4 0,-7 -3,-15 -5,-22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil81",
    d: "M225 753c-1,-6 1,-11 1,-18 -3,-2 -2,-1 -3,-5 -3,-6 1,-3 -3,-5 1,3 0,4 0,7 0,0 0,1 0,1 0,7 2,5 -1,11 -6,-1 -1,2 -3,-1 -2,-4 1,-3 -1,-7 -1,-4 0,-1 -1,-2 -5,0 -7,-4 -8,-8l-5 1 -2 2c2,4 0,-2 4,5 0,0 0,0 0,0l2 2c0,1 0,0 0,2l-2 2c0,0 0,0 -1,1 4,5 4,2 6,1l1 5c-3,-2 -3,-2 -7,-1l2 5 10 3c-3,-6 -2,-2 -4,-10 3,1 7,2 8,5l4 -3c0,4 0,12 2,15 0,-3 -1,-6 1,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil81",
    d: "M218 701l1 -1c0,0 0,-2 0,-2l-4 2c0,-3 1,-2 -1,-5 -3,-4 0,3 -3,-3l11 -1 3 8c0,-4 0,-2 4,-5l2 -2 -1 0 0 -3c-5,5 -3,2 -9,2l-24 -1c-1,3 -2,3 -5,5l3 0c-5,3 -2,2 -4,7l-2 -3c-1,-3 1,-1 -1,-2l0 2c1,5 0,5 -1,9 4,3 1,1 7,2 2,-7 -1,1 3,-5 1,-1 3,-8 8,-6l1 1c0,0 1,0 1,0l1 1c0,0 1,0 1,0 -4,4 -3,1 -5,5 6,-1 1,0 4,-2l10 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil81",
    d: "M246 145l-5 -15c-4,-2 -2,-1 -4,-3 -2,-1 -2,-1 -4,-4 1,10 5,9 5,18l-2 1c0,0 0,0 0,0l-3 0c1,2 -1,1 2,2 0,0 1,0 1,0 0,0 0,0 0,0 1,0 4,-2 4,2l2 -5c3,3 2,5 4,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil81",
    d: "M197 716l-3 -5c-2,3 -1,1 -4,3 -3,1 -2,0 -2,2 3,3 0,1 8,3l1 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil81",
    d: "M223 90l-5 -1c-1,1 -1,1 -1,3l3 -1 1 3c1,1 1,1 3,2 0,-6 -1,-1 2,-6l-3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil82",
    d: "M304 441c-2,-3 -3,-3 -5,-5 -1,-4 1,1 0,-7 5,2 2,3 4,3 3,0 1,-1 1,-1 0,0 0,0 0,-1l-1 -1c2,0 3,-1 4,-2 7,-3 0,-2 6,-4 1,0 3,0 3,-1l1 0 1 -2 0 -3c0,-3 1,0 -3,2 -3,2 -2,0 -6,3 -5,2 -5,6 -13,5l-2 -5c7,-4 -2,4 13,-3l1 -4 -4 2 2 -8 3 4 9 -2c1,-4 1,-4 -1,-5 -7,4 -4,0 -11,1 -5,7 3,3 -7,9l0 3c-6,0 -11,0 -10,7 0,5 -1,2 2,7 1,0 2,6 3,8l2 4c2,-3 1,-2 2,-6 3,3 1,2 6,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil82",
    d: "M268 448c2,-2 3,0 4,-1l-2 -6c-8,0 -3,1 -7,-2 -3,-2 -4,-2 -4,-5 -2,0 -1,2 -1,4l1 2c-3,1 -4,1 -6,2l0 3c5,2 3,1 6,1 6,1 1,-2 5,3l3 0 1 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil82",
    d: "M178 1024c3,-3 5,-2 9,-1l-4 -6 -5 1c-1,-2 -1,-1 -3,-3 -6,-2 -4,1 -3,-3l-2 0 0 4 2 2 -5 3 1 3c4,2 4,-1 10,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil82",
    d: "M236 424l-2 -5c-1,-3 -1,-1 0,-6 -5,1 -6,4 -10,0 1,0 1,0 3,0l-1 -2 -4 0 1 3 3 5 -4 0 0 2 5 0c-5,3 1,0 -2,4 2,1 2,1 4,2 3,-3 2,0 2,-6 3,3 0,2 5,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil82",
    d: "M221 969l-2 0 -2 4 -7 1 0 1c3,1 0,0 4,4 6,-1 4,-1 8,-5l-1 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil82",
    d: "M277 437l-1 -3c-5,0 -3,0 -7,4 3,1 2,0 4,5l0 2c1,-5 1,-4 4,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil82",
    d: "M189 1009l-4 -1 -3 5c3,1 1,-1 3,2 0,0 2,3 2,3l2 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil83",
    d: "M202 741l-3 1c1,-4 2,-6 0,-9l-2 -4c-2,-1 2,-1 -4,-1l1 -2c0,0 -2,3 -4,5 0,0 0,0 0,-1 -1,-2 -2,-5 -4,-6 1,6 1,1 -1,3l-3 -1 -5 3c0,-5 0,-1 -2,-3 -2,2 -2,2 -5,3 1,9 1,3 -1,10 1,-1 1,-2 2,-2 0,1 1,0 1,-1 -2,7 -1,2 1,4 0,-1 2,-3 2,-3 2,-5 -1,-3 2,-7 5,1 5,1 6,6l2 -1c4,2 1,0 2,2 1,0 1,1 1,2l6 8c1,1 3,2 4,3l6 1 -2 -5c4,-1 4,-1 7,1l-1 -5c-2,1 -2,4 -6,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil83",
    d: "M169 159c0,7 0,2 -2,4 -4,-1 -1,-1 -4,0l-1 3c1,4 2,4 1,9l2 3 3 0c2,-4 2,-7 5,-8 -4,-4 -1,-4 -6,-6 0,0 -1,0 -1,0 9,1 4,0 7,-2l-4 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil83",
    d: "M169 723c-2,0 -2,2 -4,-1 -2,-2 -1,0 -1,-4l-3 -1c-2,-5 -1,-4 -4,-4 1,6 3,1 3,9 -5,-1 -4,1 -6,-4 0,6 5,2 3,11 3,0 1,1 4,-4 0,0 -1,-3 0,1l2 2 2 0c4,-2 5,-1 4,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil84",
    d: "M360 371c-8,-5 -1,-2 -10,-5 0,-1 -1,-1 -1,-1l-3 0c0,0 0,0 0,0 -1,0 -1,0 -1,0 0,0 -1,0 -1,0l-13 3c-6,1 -1,3 -6,1 2,-4 2,0 8,-3 -1,-1 2,-3 -9,-5 2,13 1,8 6,12 3,3 -4,3 9,4 0,0 0,0 1,0 4,1 2,-1 4,1 7,4 16,3 16,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil84",
    d: "M249 934c4,-1 4,-7 1,-10 -3,-1 -6,-3 -11,-1 -4,2 -4,4 -1,8 -2,-2 -2,-2 -4,-2 4,-7 0,-5 -1,-5 -12,10 -6,3 -12,6 1,5 0,1 1,3 6,6 7,4 12,1 3,-2 -2,0 1,-1 4,0 7,2 14,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil85",
    d: "M258 181c0,-6 -4,-14 -5,-21l-7 -15c-2,1 -1,-1 -4,-4l-2 5c0,-4 -3,-2 -4,-2 0,0 0,0 0,0 0,0 -1,0 -1,0 -3,-1 -1,0 -2,-2l-4 2c1,2 -1,0 1,2 4,0 6,2 5,6l3 -1c0,3 2,-3 0,6 6,4 7,-3 9,10l1 3c-1,1 -2,-1 -3,3l5 4c1,0 0,-4 1,0 0,1 1,0 1,1 1,5 0,7 5,8 1,-2 1,-1 1,-3 1,0 0,-2 0,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil85",
    d: "M224 761c-2,-3 -2,-11 -2,-15l-4 3c-1,-3 -5,-4 -8,-5 2,8 1,4 4,10l0 2c-2,2 -3,3 -1,5l4 2 -1 12c-1,0 -1,2 -2,4l2 0c0,0 0,0 0,0 2,0 0,-1 1,0 0,0 -2,8 -2,8 0,13 4,1 5,8l4 -34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil85",
    d: "M142 732c-3,-4 2,-7 4,-9 2,-4 -1,-3 2,-6 2,-4 0,-1 3,-3 5,-3 0,-1 11,-10l-2 -2 -4 0c-3,6 -5,9 -10,13 -1,1 -1,1 -2,2 -2,1 -3,3 -4,5 -4,5 -6,17 -6,23 11,-4 -1,-9 8,-13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil85",
    d: "M196 193l-5 1c1,-4 2,-3 0,-5l4 -1 1 -1c3,-7 2,-3 7,-8l-7 0c-3,3 -1,1 -2,4 -3,4 1,1 -3,3 0,0 0,0 0,0l-2 -5 -1 4 -4 0c5,3 -1,2 6,5 0,0 -1,1 -1,0 0,0 -6,1 -3,7 4,1 13,6 16,3 -1,-1 -5,-4 -6,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil85",
    d: "M263 196l-2 -10c-1,1 -4,2 -4,2 -2,1 -2,0 -4,2 -3,1 -2,5 -3,8l13 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil85",
    d: "M220 795l-4 1 -2 -3c-3,2 -3,3 -6,3l-1 5 10 2c3,-1 2,-4 3,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil85",
    d: "M186 724l-3 -2c0,0 -1,1 -1,0 -1,-2 0,3 0,3l0 1 3 1c2,-2 2,3 1,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil86",
    d: "M265 386l2 -3c2,2 3,6 11,4 2,-3 2,-1 0,-4l-1 -1 -5 0c-1,-6 -3,-5 -4,-10 -1,-8 -2,-6 -4,-11 -6,-3 -4,-8 -10,-2l0 0c-1,7 1,11 0,18l-1 3c1,0 3,-2 7,-2 0,7 -4,9 4,10l1 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil86",
    d: "M170 912l-4 0c2,-1 1,1 2,-2l-3 -1 -4 0c-1,5 -1,2 1,3l2 4c6,2 3,-1 8,1l-2 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil87",
    d: "M133 943c0,-2 5,-3 8,-4 2,-3 2,-2 6,-4 0,-3 -1,-1 0,-3 4,1 2,-1 2,2 10,-2 16,-5 27,-6 23,-3 25,4 29,-2l-1 0 -10 -2 -18 0 -4 0c-3,-2 -1,-1 -1,-2 -1,0 0,0 -1,0 -1,-1 2,2 -2,-1l-2 2 -3 0 2 3c-5,3 -5,2 -10,1l-6 3 -3 1c-7,3 -19,11 -22,11 -1,4 -1,4 -4,6 0,0 -4,2 -4,2 -3,1 0,1 -2,0 -5,2 -2,0 -2,2 -1,4 0,1 -2,4 0,0 -2,2 -2,2 -3,4 -4,3 -2,4 5,-2 9,-7 12,-10 4,-4 3,-2 7,-4 5,-2 3,-3 8,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil87",
    d: "M260 351c-7,4 -4,1 -4,0l4 0zm-25 9c7,-8 40,-7 52,-7l6 1c-2,-3 0,-1 -2,-3l-7 -1c-1,-3 -1,0 0,-4l-4 0 -5 1 0 3c-4,0 -3,1 -6,-2l-14 1c-4,1 -8,2 -12,3 -4,1 -7,2 -11,3 -3,4 -8,3 -13,6 -2,4 0,1 -5,4 -5,3 -5,1 -2,3 4,-2 7,-3 11,-5 5,-3 5,-3 12,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil87",
    d: "M314 359c0,0 -1,0 -1,0 -1,-3 0,0 -2,-1 0,0 -2,-1 -2,-1l-5 -2c-4,-2 -7,-3 -11,-1l6 3c4,1 7,1 8,4l1 0c4,0 5,2 6,-1l0 -1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil87",
    points: "161,917 157,915 155,916 156,919 161,919 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil88",
    d: "M259 1084l1 2 3 -1c-1,-2 -1,-1 -3,-2l-12 -8c-9,-4 -27,0 -36,3l-1 3c4,1 0,-1 2,2l9 3c8,1 4,-1 10,0 3,0 4,2 6,4 1,-3 -3,0 2,-4 4,2 3,2 8,1 -1,-3 -2,-2 -3,-6 -2,-8 12,2 14,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil88",
    d: "M302 1092c3,-5 1,0 6,-3 1,-7 -2,-1 0,-5 0,-2 1,-2 4,-2l8 -24c-4,3 -1,2 -3,3 -1,1 -2,2 -3,3l-4 -1c-1,4 -5,15 -7,18 -5,7 -8,10 -16,9 0,4 -2,1 1,4l-1 3c4,4 -4,1 2,5 4,-3 8,-10 13,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil88",
    d: "M283 1121l1 0 -4 1 0 -5c-1,4 -1,4 -6,6l-1 -3c-4,-4 2,1 -2,-1 1,5 -1,1 1,6l-4 -1c0,7 -2,7 -3,13l1 3 8 -1 0 -1c1,-6 5,-12 9,-17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil88",
    d: "M338 401c-2,5 0,1 -1,2 -4,6 0,2 -3,6 -4,-1 2,-4 -4,-1l-1 2 -1 3 -10 7 -1 2c3,-3 4,-2 7,-6 1,1 2,0 3,2 1,-3 -2,-2 2,-2 3,4 3,4 -1,5l5 3c-1,4 1,2 -2,4 5,-3 2,-2 4,-7 1,-2 0,-2 2,-2 5,-3 -2,4 1,-1 4,-5 1,-12 0,-17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil88",
    d: "M353 1010c2,-1 1,-2 3,-4 4,-4 3,0 4,-7l-8 -1c-2,5 -2,5 -8,11 -8,7 -4,3 -9,9l5 2c0,-4 2,-3 5,-7 0,-1 1,-1 1,-1l7 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil88",
    d: "M96 500c-3,1 -1,0 -2,-1 3,-6 0,0 -1,-5 -4,1 -18,8 -20,11 0,0 1,0 1,0l4 0 2 4c5,-1 13,-5 16,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil88",
    d: "M81 557c-6,-3 1,-1 -9,-4 -7,-2 -8,-6 -12,-14l-2 -2c-1,2 -1,-1 0,3 1,7 10,18 16,20 3,-2 1,0 4,-2 3,-1 1,1 3,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil88",
    d: "M184 523c1,-1 1,-3 0,-5l2 -2c-4,-3 1,-2 -4,-5l-4 -2 -4 3c0,1 4,0 4,0 0,0 -1,-1 3,1l1 4c-1,0 -1,0 -3,1 -4,0 -6,-2 -9,-3 3,5 4,1 7,5 0,0 0,0 1,0l1 2c-2,2 1,1 -3,1l4 4c3,-2 4,-1 4,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil88",
    d: "M265 1116c-1,-5 -1,-4 0,-9 -5,1 -13,2 -16,5l3 2c1,1 0,0 3,1 -5,4 -3,2 -4,5 6,-2 4,-5 10,-6l4 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil88",
    d: "M233 1127l-5 -4c3,-7 2,1 4,-6l-3 2c0,1 0,1 -1,1 -2,-3 -2,-5 -2,-5 -4,2 -3,2 -4,5 2,1 1,0 5,4l4 5c3,-1 2,4 2,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil89",
    d: "M174 58c-5,-5 -60,-13 -58,0 4,3 10,1 15,1 6,-1 12,-1 17,0 11,1 19,4 29,8l0 -5c-5,0 -3,2 -6,-2 1,-2 -1,0 3,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil89",
    d: "M180 1212c-3,6 -1,2 -4,3 2,6 -1,2 2,6 0,0 0,1 0,1l1 2c1,7 -2,-3 1,4 -4,0 -4,-1 -5,-1 -3,-1 -2,2 -8,-2 0,5 0,2 -2,3 -3,-1 0,-1 -2,-1 -4,1 -1,0 -4,1 5,0 5,0 9,2 1,0 6,2 7,3 4,2 7,6 8,10l3 0c0,-8 0,-24 -6,-31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil89",
    d: "M157 744c-3,-10 2,-9 9,-12l-1 -4 -2 0c-4,3 -7,2 -10,7 -1,3 -4,9 0,11l1 -3 3 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil89",
    d: "M356 235l-6 0c-1,1 -1,1 -1,1 0,0 0,1 0,1 -3,5 -1,-1 -4,5l-1 2c5,-1 12,-2 16,-6 -2,-2 0,-1 -4,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil89",
    d: "M211 589c-5,1 -3,0 -6,3 1,4 6,4 10,5l0 -2c4,0 4,1 6,-3 -1,0 -1,-1 -4,-1 -4,0 -4,1 -4,1 -2,-1 -1,0 -2,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil89",
    d: "M322 109c3,-3 -1,2 3,-1 0,-5 1,1 -3,-5 -1,-1 0,-1 -1,-2 -3,-2 -1,-1 -4,0 0,4 0,2 3,5 0,0 -2,-1 -2,0 -4,1 -1,-2 -3,2 4,2 2,1 7,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil89",
    d: "M311 749c0,-4 2,2 -1,-2l-1 -1c0,0 0,-1 0,-1 0,0 1,-2 -1,-5 -4,2 -4,2 -1,6 -3,-1 -3,-2 -6,0 3,4 8,4 10,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M138 1205c-4,-1 -1,0 -3,-2 -7,-4 -4,-5 -3,-7 3,-1 10,1 6,9zm18 -1c2,-4 5,-6 -1,-10l0 7 -7 -7c0,-6 -1,-12 5,-13l-4 -3c1,1 2,0 -1,2 -5,2 -1,0 -3,-1 2,11 4,9 1,21 -3,-2 -2,1 -3,-5 -2,-5 0,-9 -2,-14l-1 4c-4,6 1,1 -1,6 -8,-4 -5,-6 -4,-12 -4,3 -2,2 -5,6l-2 -2c-3,2 -3,6 -7,8l5 4 -1 5c2,5 6,2 11,8 0,0 2,-6 4,2l3 -9c1,1 2,3 5,4 1,-5 0,-4 2,-6 0,0 0,-1 0,0 0,0 0,-1 1,-1 4,7 -4,2 5,6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M72 290l2 -1c-3,-5 -1,-2 -1,-6 0,0 -1,-3 -1,-3l-13 -8c-4,4 -10,5 -16,6 8,4 17,-1 23,-1 1,1 1,0 -2,2 5,1 4,0 6,3 -4,5 -4,2 -9,2 -6,1 -3,2 -8,1l-3 0c1,7 1,3 0,9l1 7c-2,-2 -1,0 1,0 11,1 1,1 6,-4 6,-4 6,0 9,-7 0,-1 1,-1 1,-1 0,0 0,-1 0,-1 2,2 1,2 4,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M328 542c-3,-1 -1,0 -2,-2 -2,-1 -2,-3 -8,-4 1,-4 2,-5 3,-9 0,1 0,0 1,1 0,0 4,1 6,4l2 3c0,0 0,1 0,1 1,5 1,3 -2,6zm3 9l6 -8c-1,-5 -5,-4 -2,-10 -2,-4 -2,-2 -6,-4 -4,-2 -3,-3 -6,-6 -2,2 0,2 -2,0 -4,-1 -3,-1 -3,-2 0,3 0,0 -3,2 0,0 1,1 1,0l5 -1 -5 9c-4,-4 2,-1 -3,-3 -1,5 -1,6 -1,8l5 -1 1 7 4 -1c8,9 5,7 2,12 3,-1 0,0 3,-2l4 -4 0 4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M348 560c0,-1 0,-1 0,-1l2 -2c-1,0 -1,0 -1,-1 -1,-1 -2,0 -3,-4 -1,-5 1,-1 -2,-6l-5 -1c-1,7 -3,8 -7,14l3 6c12,0 3,-3 13,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M115 1139l-2 -1 -14 -2 0 2c1,4 1,1 7,3 3,1 4,2 7,3 4,1 11,3 14,1 2,-7 -7,-4 -12,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M359 595c-7,-2 -9,-4 -14,-5 -4,-1 -11,-4 -14,-2 -1,4 -2,2 2,4 2,1 6,2 8,2l13 3 5 1 0 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M349 573c0,-3 -1,0 1,-3l1 -2c4,-3 2,1 4,-5 -9,2 -9,7 -14,8 -2,0 -5,0 -7,-1l1 -4c-4,-2 -3,-2 -4,-4l-2 1 -2 3c2,1 3,1 3,5 4,1 1,0 4,4 5,-1 9,-1 15,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M128 1162c-1,1 0,1 -1,-1l-2 -3c-4,1 -9,2 -13,2 -1,2 0,0 -2,2 0,0 0,0 0,0l-7 8 4 -1c7,0 9,-9 18,-5l-1 3c0,0 0,1 0,1 1,0 4,2 4,3 0,1 0,1 0,1l3 -6c-4,-1 -1,0 -3,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M73 256c-1,-3 -3,-2 -6,-5 -2,-2 -5,-4 -7,-6l-2 3c3,3 7,4 7,8l4 2 5 5c1,1 3,2 3,3 1,1 0,0 3,1 4,-6 -4,-7 -7,-11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M289 748l-1 2c2,3 1,2 3,5 3,7 8,1 9,7l1 1c1,-2 -2,-1 2,-2 -3,-2 -2,-1 -3,-4l4 -5c-8,-4 -4,0 -9,1 -3,-2 0,-1 -6,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M132 341l0 -7c-2,-2 0,-1 -3,-1 -4,5 -8,7 -6,12l7 0 2 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M79 80l-2 1c-5,3 -3,-2 -6,3 1,2 0,1 6,4 3,2 3,2 7,2 1,-6 0,-7 -5,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M279 751l-2 1 0 3c-1,3 -1,1 -1,4 6,3 1,-3 5,3l4 -1c1,-2 -1,0 2,-5 -4,0 -3,0 -4,-1 3,-4 2,-1 3,-5l-5 4c1,-6 1,-1 -2,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M92 705c-5,-1 -6,-1 -9,3l-2 3 3 2c5,-1 8,-2 11,-6 -2,-2 1,-2 -3,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M225 604l-4 2c-4,4 -6,3 -5,11l5 0c1,-4 3,-5 3,-7 1,-2 0,1 0,-2 0,-1 0,-2 1,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M75 340c-4,-1 -5,-6 -7,-9l-7 -1 2 3 2 -2c0,6 0,3 1,5l5 8c0,1 0,1 0,2 3,-1 2,-2 4,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M333 907c-1,-4 -2,-6 -5,-7 -1,0 -3,-2 -6,-2 1,4 2,6 6,7l-1 2c1,1 -1,0 2,2 2,1 1,1 3,1l-1 -2c1,-2 -2,-2 2,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M85 276l5 1c2,-2 2,-1 2,-4 -3,-1 -5,1 -7,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil91",
    d: "M106 208c0,2 0,6 -5,6 -3,-6 1,0 -1,-5 -2,1 -4,1 -7,-2 1,0 1,0 1,-1 0,0 1,-1 1,-1 0,0 0,0 0,0l2 -1c0,0 0,0 0,0 0,0 1,0 1,0l2 -3c2,-5 -1,-9 3,-13 2,3 1,5 2,9 2,-2 1,0 2,-3 -2,-6 -3,-14 -7,-17 -5,6 -1,20 -9,28l-4 -4 1 8 3 -3 6 20c3,7 2,0 5,11l2 -1c3,-4 3,-23 2,-28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil91",
    d: "M133 1105c-2,-6 -8,-20 -12,-24 1,2 2,5 -1,7l-1 1c-1,-4 -1,-2 0,-6 -2,3 -4,5 -9,3l1 -1c3,-3 3,0 3,0 -1,-1 0,-9 -5,-16 -1,-2 -1,-1 -2,-4 8,-1 3,6 9,8l2 -1c-3,-5 -11,-14 -17,-15 0,6 9,18 7,27l-6 1 4 5c2,-5 0,-2 3,-4l12 16c10,2 5,2 11,7 2,-2 4,4 1,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil91",
    d: "M65 256c0,-4 -4,-5 -7,-8l-7 2 3 1c0,4 -1,8 -2,11l8 0c8,0 -3,-2 7,-2l-2 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil92",
    d: "M190 891c0,0 0,1 0,1 -3,3 -2,1 -4,1 3,-3 1,-2 4,-2zm-13 5c0,1 14,1 17,2 4,-4 3,0 1,-4l-2 -3c-2,-3 -1,-2 -5,-2 -4,-3 -22,-2 -28,-1 -7,7 -4,3 -7,8 0,0 0,0 0,0l-2 2c-3,3 -4,-1 -5,-1l-6 4c-1,2 -1,2 -2,3 0,1 -1,3 -2,4 5,-1 6,-3 10,-5 3,-1 6,-1 9,-2 8,-3 14,-4 22,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil92",
    d: "M198 384c1,5 0,1 2,3l2 1c1,0 0,1 7,1l-2 -7c-3,-1 -6,0 -9,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil93",
    d: "M186 685l-10 -1 3 -4c2,0 5,0 6,0 6,0 4,1 7,-2 -17,0 -48,1 -63,8l-3 4 2 3c9,-1 19,-4 28,-5 7,-1 26,-1 30,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil93",
    d: "M183 76c-3,-4 -7,-4 -12,-2l0 -4c-2,6 0,2 -3,4 -4,-2 -2,1 -4,-4l-1 3 -9 0 3 -4c8,1 0,1 4,2l1 -4c-10,0 -20,3 -30,4 -5,1 -23,3 -20,11 4,1 29,-4 34,-5 13,-2 24,-2 37,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil93",
    d: "M225 753c-2,2 -1,5 -1,8l-4 34c-1,4 0,7 -3,8l4 2c6,-6 2,-1 7,-8 6,-11 0,-3 3,-10l-3 1c1,-7 3,-5 2,-10 1,4 0,2 -2,3l1 -6c-3,5 0,2 -5,4 1,-8 3,-18 1,-26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil93",
    d: "M65 95l1 -6c-4,-1 0,1 -2,-2 -1,-2 3,-1 -2,-2 -3,-1 -4,0 -6,2l3 12c4,1 3,0 6,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil93",
    d: "M327 128c-1,-1 -2,-2 -3,-3l0 6 0 6c4,0 7,-1 10,-3l-3 -5c0,-2 3,-1 0,-3l-4 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil93",
    d: "M261 1205l0 0 0 -4c-4,0 -6,-4 -13,-3l1 4c1,1 1,0 0,2 0,0 0,0 0,0 0,0 0,1 -1,1l3 1 2 -1c0,0 1,0 1,-1l1 4 6 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil94",
    d: "M210 929l-5 -3c-4,6 -6,-1 -29,2 -11,1 -17,4 -27,6l-2 1c-4,2 -4,1 -6,4 4,-1 2,-1 6,0 4,-2 2,-2 7,0 0,-4 10,2 18,-1 2,2 0,5 8,4 4,0 2,-1 5,-1 3,-1 -1,-1 3,1l3 -6c-6,-3 -1,-1 -7,0 -2,0 -5,0 -5,-4 1,-8 27,-2 29,0 2,3 0,3 3,6l5 5c0,1 1,1 1,1 -1,-8 -2,-9 -7,-15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil94",
    d: "M269 348c2,-3 0,1 0,-2 0,-5 -2,3 0,-1l6 0 0 -5c-5,0 -3,1 -6,-2 0,-4 -1,-1 2,-3 2,-3 2,0 1,-5 -2,-3 -4,-1 -8,-1 -6,0 -4,-2 -8,2l8 0c2,4 0,5 0,5 1,2 2,0 3,7 -5,2 -3,4 -7,5l-5 1 14 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil94",
    d: "M155 927c3,-1 -4,-1 4,-1 -4,-2 -2,0 -2,-2l4 -1 0 -4 -5 0 -1 -3 2 -5 -2 -1c2,-2 1,0 0,-2l-5 0c-6,4 -8,0 -10,7 4,-4 3,-3 9,-4 1,2 5,6 0,6 0,0 5,-1 4,5 -1,6 -3,1 -2,6 -8,0 1,-1 -2,2l6 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil94",
    d: "M317 350l-1 -3 0 -5c-1,0 -1,1 -2,3l-1 1c-1,3 0,5 -3,6 0,0 -1,0 -1,0l-5 -2c-1,3 -1,2 0,5l5 2c6,-1 6,-3 8,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil94",
    d: "M172 924l4 0c3,-1 7,-1 11,-1 -4,-1 -9,-6 -13,-4 -3,2 -2,-1 -2,5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil95",
    d: "M194 644c-3,-4 -18,-14 -24,-17 -7,-4 -23,-15 -29,-7 2,6 13,5 27,13 11,6 15,11 23,18l-1 2c1,0 -1,5 5,0l-1 3 9 3 -9 -10c-2,-3 -3,-2 -3,-5l3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil95",
    d: "M203 212c-4,-1 -2,-1 -3,-2 2,-3 -1,-1 3,-3 -10,0 -17,0 -27,0 -9,0 -24,-4 -22,7l6 1 -1 -6 10 0c3,1 3,1 3,1 -3,5 0,-2 -6,4 7,0 34,1 37,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil95",
    d: "M167 665c-5,-3 -15,-4 -22,-5 -6,0 -18,-4 -20,2 4,5 13,3 20,4 7,1 15,3 22,4 0,-1 -1,-1 -1,-1 -5,-3 -3,-1 -3,-3 1,-2 -1,-1 4,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil95",
    d: "M214 754l-10 -3 -6 -1 -21 1c1,-3 2,-5 4,-8 2,-4 3,-3 4,-8l-2 1c-3,2 -4,4 -7,8 -3,3 -3,4 -2,9 7,3 19,1 28,1 5,1 7,3 12,2l0 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil95",
    d: "M229 64c-2,-3 -7,-6 -11,-6 1,4 2,12 5,15l1 -8 5 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil95",
    d: "M164 227l-12 1c0,3 0,2 1,5 1,3 1,1 2,2 4,0 2,0 5,-1 -4,-2 -3,0 -3,-6l6 1 1 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil95",
    d: "M136 1150l5 1c0,0 0,-3 0,-3 -1,-5 0,-1 -1,-3 -3,2 -2,1 -4,5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil96",
    d: "M216 1015l0 -2c1,-5 0,-5 1,-10 -3,3 -3,2 -7,0 2,-4 1,-6 6,-1 0,-6 0,-6 2,-10l5 -5 0 -2 0 -7c-3,2 -2,1 -2,6 -2,-1 0,-2 -4,0 -2,1 0,2 -5,3 0,-6 0,-3 2,-8 -3,4 -1,4 -5,5 1,-4 2,-4 -1,-7l0 4c-3,2 -2,1 -5,3l2 3c-5,3 -4,0 -6,5 4,1 3,2 7,5l-1 6c-4,-6 -5,2 -6,-11l-3 2 1 3c1,6 1,2 5,7 1,1 1,1 2,3 2,3 1,0 2,5 1,1 1,2 3,4 5,0 5,-4 7,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil96",
    d: "M303 446c2,-2 2,-1 3,-4l-2 -1c-5,0 -3,1 -6,-2 -1,4 0,3 -2,6l-2 -4 0 6 1 1c4,1 4,0 8,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil96",
    d: "M309 422c-7,0 -2,0 -4,-2l2 -1c-15,7 -6,-1 -13,3l2 5c8,1 8,-3 13,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil96",
    d: "M148 1003c-1,1 -2,1 -3,3 -1,4 2,-4 1,4 4,-1 7,-1 7,-5 -2,-3 -1,-2 -5,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil96",
    d: "M289 391l1 1 -1 3 -6 1 -1 2 4 1 3 0c1,-3 3,-6 0,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil96",
    d: "M222 419c-4,1 -3,0 -3,4 3,2 2,1 6,2 3,-4 -3,-1 2,-4l-5 0 0 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil97",
    d: "M92 367c6,-9 7,-48 -2,-57l0 5c-3,-1 -2,1 -3,-5 -3,-15 -4,-7 -7,-13l-3 1 0 4 3 2 -2 10c3,-5 3,-3 9,-5 -3,12 -3,6 -5,11l-3 11c6,0 2,-1 4,3l1 -4c1,-1 1,-1 1,-3 -1,1 0,-1 -1,2 0,7 0,2 1,4 5,-7 0,-6 4,-13 5,6 2,1 3,9 1,11 0,22 -3,31l0 4c0,2 0,4 0,6 2,-4 0,-1 3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil97",
    d: "M185 232l0 -6 7 -1c-1,6 0,2 -5,7 6,-1 14,-1 19,-5l16 -9c0,0 0,0 0,-1 6,-1 2,-1 4,1 -1,1 0,1 -1,4 5,-1 2,1 4,-2 -4,-1 -4,-3 1,-5 1,0 2,-1 3,-1 1,0 1,0 2,0 -1,2 0,1 -1,3l-3 3c7,-1 15,-5 20,-9 -6,1 -10,5 -16,6l2 -6c-11,2 -23,7 -34,9 -10,3 -24,3 -33,6 1,2 2,2 0,5 -2,2 0,0 -2,1 -2,1 0,-1 -2,2l19 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil97",
    d: "M156 94l-1 -3 1 -3c-8,1 -37,7 -39,15 5,4 13,-1 19,-3 6,-2 15,-4 20,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil97",
    d: "M75 321c-3,1 0,0 -5,1 2,-9 4,-6 5,-14 -3,2 -4,1 -5,1 5,1 3,4 -1,6 -1,-2 -1,0 -2,-4 -1,-1 -1,-4 -1,-5 0,-6 2,-2 4,-5l-8 3 1 -4c-9,5 -12,4 -11,7 1,3 -1,1 1,1 6,2 -2,-1 2,0 0,4 0,4 -4,6l2 2c2,0 1,3 3,-1l-1 -1 2 -2c3,-2 3,-3 7,-5 4,9 1,10 6,10l-1 6 -1 7c4,-3 2,0 5,-5 0,0 1,-4 2,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil97",
    d: "M298 790c-5,2 -9,3 -14,5 -5,2 -8,2 -13,4 3,5 15,6 21,7 -1,-2 -4,-3 -5,-5 1,-2 9,-4 11,-11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil97",
    d: "M73 71c4,-2 9,-8 10,-12l-2 -3c-4,1 -12,5 -15,8 5,2 -4,2 3,8 4,3 3,0 3,0 2,-2 -2,-3 1,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil97",
    d: "M88 727l-1 -1 -2 0c0,-1 0,-1 0,-1l-1 -1c-4,-2 -2,-1 -6,-2 2,9 4,7 6,7l-1 1c0,2 -1,2 1,2 4,0 2,2 4,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil98",
    d: "M90 310c0,-6 -5,-8 -6,-14l-3 -2c0,0 -2,-3 4,0l6 1 -1 -15 -3 4c-1,3 0,1 -2,3 -2,-1 -3,-1 -3,-3 0,-2 1,-3 1,-4l-1 -3 0 -2c-3,-1 -6,-3 -9,-4 -4,-2 -5,-2 -10,-5 -2,0 -5,-1 -8,-2 -5,-2 -3,-1 -6,-4l-2 1c1,6 1,2 -1,3l0 1c4,1 9,5 13,7l13 8c0,0 1,3 1,3 0,4 -2,1 1,6 5,-1 2,-2 6,1l-2 4 2 3c3,6 4,-2 7,13 1,6 0,4 3,5l0 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil98",
    d: "M283 1213l-3 -6 4 -4c0,-3 -1,0 -6,1 0,-8 3,-5 3,-7 -6,-1 -7,4 -9,-2l-5 5c-8,-2 0,-3 -6,-4 -6,5 -5,1 -13,2l0 0c7,-1 9,3 13,3l0 4c1,-1 0,2 1,-1 -2,6 0,2 1,3 3,-2 1,-2 4,-1 4,5 1,2 -1,9l5 1c-5,2 -2,1 -4,3 5,0 15,4 18,2l-2 -1c0,0 0,0 -1,0 -1,-1 -1,0 -2,-2 1,-4 1,-3 3,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil98",
    d: "M313 905l4 -5c4,2 1,1 4,4 3,2 3,2 6,3l1 -2c-4,-1 -5,-3 -6,-7 3,0 5,2 6,2 0,-4 -1,-5 -3,-8 1,-2 1,-1 2,-2 -2,-3 -1,-2 -5,-4 0,-4 2,-4 4,-6 0,0 0,0 0,-1l-4 -1 0 -12c-1,0 -1,1 -1,1l-1 11c-2,4 1,2 -4,3 1,4 1,-1 0,1 -4,7 1,-5 -2,3 8,6 6,3 7,7l-4 1c-3,1 0,4 -8,0l5 -2 -4 -3c-3,4 0,3 -4,6 0,-5 0,-1 -2,-3 0,3 -2,16 1,17l1 -5 5 -1c1,4 1,2 2,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil98",
    d: "M294 129c3,-3 1,-2 0,-7 7,-1 3,1 6,-6 2,-3 2,-2 4,-2l3 -5 -1 -3c-2,1 -4,2 -5,2 0,0 0,0 0,0l-1 -3c-5,-3 4,0 -2,0 -2,0 0,-1 -2,-4 -3,2 -2,-1 -3,4 0,0 0,0 0,0 0,-1 1,-1 1,0 3,1 3,-2 2,7 -3,-1 -3,-1 -5,-3 1,6 1,4 0,10 -1,5 1,4 0,11l3 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil99",
    d: "M336 254c4,-6 0,-2 5,-6 3,2 0,-1 3,4 2,0 1,0 2,-2l-2 -6 1 -2c-3,0 -6,0 -6,-5 1,-3 1,-1 2,-2 3,-3 0,4 2,-2l0 0c-6,2 -6,1 -11,1 -1,-5 0,-4 -3,-3l-2 1c-3,3 0,0 -2,4 -2,6 2,4 -5,4l3 0c-1,4 0,1 -2,4 3,5 -1,21 4,26 5,-3 4,-14 11,-16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil99",
    d: "M308 793l-3 1c-4,1 1,0 -3,0 -6,1 -6,7 -6,7l6 3 -1 3 -1 0 6 0c-1,-4 -3,-3 -1,-6 3,-4 3,-1 5,-6l-4 2 2 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil99",
    d: "M293 160c0,3 0,3 2,6l2 0 4 -6 3 1c0,-3 1,-1 -1,-4 -1,-4 -1,-3 -2,0 1,-3 1,-3 0,-6 -3,2 -1,0 -3,3 -1,0 -2,3 -2,4 -1,-5 -1,-3 -2,-3l-1 5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil99",
    d: "M194 676c-1,1 3,1 -2,2 -3,3 -1,2 -7,2 -1,0 -4,0 -6,0l-3 4 10 1 11 0c-5,-3 -4,0 -7,-6 3,0 3,1 7,0 1,-8 1,-1 -3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil100",
    d: "M256 795l-3 -1c5,-7 6,-18 7,-28 0,-5 0,-28 2,-31 0,0 -1,-1 -2,-1l0 1c0,0 0,0 0,0l-2 0c-4,1 3,-2 -1,0l-2 19c-3,-1 -2,-1 -4,-2l-1 18 -5 30 2 -5c2,4 0,5 6,1 -2,5 1,1 -2,5l5 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil100",
    d: "M273 135c-1,6 4,11 4,18 5,4 3,10 6,14 5,1 2,2 4,-1 0,4 -2,3 0,9 4,-4 3,-1 2,-7 0,-4 1,-6 1,-8 -1,-11 -15,-40 -15,-45 -3,3 -4,2 -3,6l4 13c-6,3 0,-1 -3,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil100",
    d: "M193 125c1,-5 1,-6 1,-12l-3 -1c-8,-1 -12,-1 -17,7l2 4c10,6 2,7 17,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil100",
    d: "M214 193c0,-5 2,-7 -2,-11 -7,-3 -10,1 -15,5l3 9c5,2 6,2 12,0l2 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil100",
    d: "M179 776c-1,-6 -2,-9 -10,-8 -7,0 -7,5 -8,11 5,3 5,3 11,5 4,-1 6,-4 7,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil100",
    d: "M267 707l0 -3c-4,-1 -4,-1 -5,-5l2 0 -8 -8c0,7 2,8 0,15l5 -4c-1,9 -3,3 -4,10l-1 9c5,-2 2,4 5,-5 1,-2 3,-6 3,-8 0,0 1,-1 1,-1l2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil100",
    d: "M267 85l0 0c-4,-2 -2,-1 -7,-2 1,5 0,7 1,11 0,1 0,1 0,1l1 3c1,2 -1,1 3,4 2,-4 1,-6 1,-11 -1,-2 -1,-1 -1,-3 1,-2 0,-1 2,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil101",
    d: "M107 196c-3,3 0,6 -1,12 1,5 1,24 -2,28 -1,7 -8,19 -12,21 -5,1 0,1 -6,2 -1,-5 0,-4 -3,-6l-1 3c-4,-2 -6,-2 -9,0 3,4 11,5 7,11 -3,-1 -2,0 -3,-1 0,-1 -2,-2 -3,-3l-5 -5c-2,4 -2,2 -5,4l-1 1c2,1 6,0 8,2l-2 1c0,0 0,0 0,0 -1,0 -1,0 -1,0 -1,0 -4,0 -5,0 5,3 6,3 10,5 3,1 6,3 9,4 4,-3 10,-14 12,-15 3,-4 3,-2 7,-8 12,-19 9,-32 6,-56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil101",
    d: "M89 370c0,-2 0,-4 0,-6l0 -4c3,-9 4,-20 3,-31 -1,-8 2,-3 -3,-9 -4,7 1,6 -4,13 -1,-2 -1,3 -1,-4 1,-3 0,-1 1,-2 0,2 0,2 -1,3l-1 4c0,5 -9,11 -10,19l3 1c-1,-2 -1,-2 -1,-5 5,-2 6,5 7,4l2 0c2,0 -1,-1 1,1 0,1 3,4 -3,3 -1,0 -5,-3 -6,-3 2,6 3,2 8,11 3,5 -1,2 4,7l1 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil101",
    d: "M298 508c2,2 2,2 2,4 0,0 0,1 -1,1l-12 0c0,2 1,1 -1,4l-2 -3c1,6 1,10 4,15l5 9c3,4 2,5 6,7 0,-4 0,-4 0,-7 -1,-5 -1,-4 -3,-6l3 -1c0,-5 0,-9 1,-13 0,-4 3,-9 -2,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil101",
    d: "M55 314l1 1c5,3 1,4 6,9 4,-2 4,-6 0,-11l-7 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil101",
    d: "M132 1196c-1,2 -4,3 3,7 2,2 -1,1 3,2 4,-8 -3,-10 -6,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil102",
    d: "M140 915c2,-7 4,-3 10,-7 2,-5 0,-2 1,-3l4 5 2 1 0 -6c6,0 5,3 12,2l4 -2 4 -1c0,-3 -4,-2 3,-3 3,-1 1,-1 5,0 0,1 3,-1 -1,3 4,1 5,2 8,4 5,2 8,0 7,5 5,-4 1,-2 2,-5 3,4 1,4 3,8 0,-6 3,-6 -2,-10 -3,-1 0,2 -3,-2 0,0 -1,-2 -2,-4 -3,0 -3,0 -3,0 -6,-1 -4,1 -9,-1 -8,-3 -6,1 -11,0l3 -3c-8,1 -14,2 -22,5 -3,1 -6,1 -9,2 -4,2 -5,4 -10,5 -5,1 -2,2 -9,3l1 3 0 7c4,-5 4,-6 12,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil102",
    d: "M314 329c-11,-3 -17,-6 -29,-7 -12,0 -22,1 -34,2l-7 1 -1 4 -1 4 14 -2c4,-4 2,-2 8,-2 4,0 6,-2 8,1l3 -3c3,1 6,4 7,6 5,-2 6,-3 11,-2 2,-3 4,-2 9,-2l1 2c2,0 5,1 6,1 2,1 -1,2 6,1l-1 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil102",
    d: "M304 355c-1,-3 -1,-2 0,-5l5 2c0,0 1,0 1,0 3,-1 2,-3 3,-6 -6,1 -1,1 -3,-1 -1,-3 1,-1 -1,-1l-1 1c-2,-5 -2,0 -1,-6l-4 2c-3,0 -6,-1 -8,-1 -5,-1 -5,1 -7,-2 -2,2 -1,0 -2,2 0,1 0,4 -1,4 3,0 2,1 3,0l9 7 -6 0c2,2 0,0 2,3l-6 -1c2,3 8,4 12,4l-6 -3c4,-2 7,-1 11,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil102",
    d: "M163 923l-2 -4 0 4 -4 1c0,2 -2,0 2,2 -8,0 -1,0 -4,1 5,1 5,2 10,-1l-2 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil102",
    d: "M275 347l0 -2 -6 0c-2,4 0,-4 0,1 0,3 2,-1 0,2 3,3 2,2 6,2l0 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil103",
    d: "M197 997l-1 -3 3 -2 0 0c2,-5 1,-2 6,-5l-2 -3 0 -2 -4 0c-1,5 0,2 -3,4 -1,1 -3,2 -4,4 -4,3 -7,0 -13,-1l-2 5c0,3 -1,2 -4,1 3,11 -1,8 -6,13l-1 2c-6,-2 -5,-3 -5,-3 -4,-6 -4,-4 -3,-6l-10 2c4,0 3,-1 5,2 0,4 -3,4 -7,5l-1 0 1 2 1 0c5,1 9,0 15,1 6,-1 30,-12 35,-16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil103",
    d: "M289 426c-1,-7 4,-7 10,-7l0 -3c-1,-4 -1,-3 -5,-4 -1,3 0,1 -1,2 -1,0 -1,0 -1,0l-8 4c-5,1 -4,-2 -11,-4 -4,3 -3,5 -11,5 -1,2 -2,5 -5,2 3,2 2,-1 8,1 0,6 -1,4 -7,7l-3 1c-3,-1 -3,-2 -6,-6 0,0 0,-1 -1,-1l-4 1 -5 1c3,4 4,5 9,6 4,1 9,0 13,0 4,1 24,-3 28,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil104",
    d: "M131 1153l2 0c0,-18 8,-30 4,-48 -2,-8 -13,-28 -19,-33l-2 1c2,1 2,2 3,4 1,1 1,1 2,4 4,4 10,18 12,24 1,2 2,11 2,13 0,1 0,4 0,6 -1,7 0,5 -4,5 1,4 1,1 -1,6 -6,0 0,-1 -6,-4 -2,3 2,2 -3,4 0,1 0,1 0,2 1,2 1,0 0,2 -6,-1 -2,1 -4,-3l-2 3c5,2 14,-1 12,6 -3,2 -10,0 -14,-1l-5 6c0,0 -3,2 -3,2l-4 3 24 -3c7,-1 6,0 6,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil104",
    d: "M176 1215l-3 -12 -4 0c2,-1 -1,-3 -2,-5 -3,3 -4,3 -5,8 2,2 0,0 2,2 3,2 4,2 4,5 -5,-2 1,-1 -4,-4 -1,1 -1,0 -1,2 -1,3 -1,2 0,4 4,3 4,0 6,3 -4,2 1,-2 -9,0l1 5 6 2c6,4 5,1 8,2 1,0 1,1 5,1 -3,-7 0,3 -1,-4l-1 -2c0,0 0,-1 0,-1 -3,-4 0,0 -2,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil104",
    d: "M42 282c-4,-2 -2,0 -3,-4 2,0 -1,-1 4,0 6,-1 12,-2 16,-6 -4,-2 -9,-6 -13,-7 -5,6 -7,7 -14,11 2,5 5,8 8,10l2 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil104",
    d: "M364 555c-3,2 -4,1 -8,0 3,4 3,1 7,3 -1,2 1,4 -8,5 -2,6 0,2 -4,5l-1 2c-2,3 -1,0 -1,3l14 2c0,-8 4,-10 7,-16 -3,-3 -3,-3 -6,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil104",
    d: "M103 1170l7 -8c0,0 0,0 0,0 2,-2 1,0 2,-2 -6,0 -11,-1 -16,1 -2,5 -6,12 -6,16l6 3c2,-3 4,-2 8,-1 -2,0 1,0 -1,0 0,-1 -1,-1 -2,-1 -3,-1 -3,-1 -5,-2 1,-4 -2,-2 7,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil104",
    d: "M155 1194c1,-1 1,0 -1,-2 0,-4 1,-7 -1,-11 -6,1 -5,7 -5,13l7 7 0 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil104",
    d: "M312 541c-2,-4 0,-1 -3,-4l-2 -3c-2,-2 0,0 -2,-2 0,4 1,7 1,10 0,4 -1,5 0,11 5,-3 6,-6 6,-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil104",
    d: "M155 343c-5,1 -2,1 -4,3l2 3c4,-3 4,-3 2,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil104",
    d: "M321 862c-2,-1 1,-1 -4,0l-2 3 4 1c2,-3 1,-1 2,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil104",
    d: "M350 257l-3 5c3,2 0,2 5,1l-2 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil104",
    d: "M249 613l-3 0 -1 5c1,1 0,1 2,0 0,0 2,-1 2,-2l0 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil105",
    d: "M225 604c3,-5 4,0 9,2 1,-2 3,-4 4,-4 6,-3 0,-1 4,-1 0,0 1,0 1,0 0,0 0,0 0,0 1,-6 21,-8 21,-15 -5,-4 -20,-1 -26,-1 2,3 2,4 2,8 0,4 1,1 3,5 -3,0 -9,2 -17,0 1,-6 0,0 1,-3 2,-4 1,-5 3,-8 6,2 6,0 1,6 3,-1 2,-2 4,0 2,-5 1,-1 0,-4 0,-1 0,-1 0,-1l-2 -4c-4,-8 -5,-5 -2,-5l-1 -2c-5,3 0,0 -3,3l-2 2c0,0 0,0 -1,0 0,1 0,1 0,1l-1 5 -12 1c1,3 0,2 2,3 0,0 0,-1 4,-1 3,0 3,1 4,1 -2,4 -2,3 -6,3l0 2 8 3 -2 6 4 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil105",
    d: "M83 730l1 -1c-2,0 -4,2 -6,-7 4,1 2,0 6,2l1 1c0,0 0,0 0,1l2 0 -7 -10 4 -3 -3 -2 2 -3c3,-4 4,-4 9,-3 -1,-1 0,-1 -5,-1 -13,-1 -11,1 -13,-7l-1 0c-1,6 2,8 -4,9l3 2c1,3 2,-3 0,1 -2,2 -1,-2 -1,2 4,4 3,-1 5,6l-1 0c-3,1 0,0 -2,1 -3,1 -1,6 -9,4 0,0 0,0 0,0l2 -4c1,-2 1,-1 3,-1l-6 -3c1,8 -3,13 -2,21l2 5c0,1 0,1 0,1 0,0 0,1 1,1 3,-2 5,-12 8,-17 5,2 6,5 11,5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil105",
    d: "M92 367c-3,2 -1,-1 -3,3l-1 2c-5,-5 -1,-2 -4,-7 -5,-9 -6,-5 -8,-11l0 0 -3 -1c1,-8 10,-14 10,-19 -2,-4 2,-3 -4,-3 -2,3 1,-1 -1,2l-3 7c-2,4 -1,5 -4,6 0,-1 0,-1 0,-2l-5 -8c-1,-2 -1,1 -1,-5l-2 2 -2 -3c0,0 -1,1 -1,1 0,-1 -1,0 -2,1 6,8 9,4 11,19 2,0 1,0 2,1 1,0 2,2 2,2 3,3 4,2 2,3 3,6 7,8 8,15l2 4 3 -2c3,-2 3,-4 4,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil105",
    d: "M315 881c0,0 0,-2 -1,-2 0,0 0,-1 0,-1 -1,-3 0,-2 -3,-3l-1 3c-6,-2 -13,-4 -19,-4l-3 2c1,4 12,13 16,15l1 -2c-3,-6 0,2 4,-7l6 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil105",
    d: "M267 1219l-9 -8 3 -6 -6 3 -1 -4c0,1 -1,1 -1,1l-2 1 6 4c-3,7 -8,13 -10,20l2 -1 2 3c4,-2 14,-9 16,-13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil105",
    d: "M327 232c-5,-4 -12,-3 -18,-6l-1 4 -3 0c3,4 12,12 16,14 2,-3 1,0 2,-4l-3 0c7,0 3,2 5,-4 2,-4 -1,-1 2,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil106",
    d: "M191 510c-7,-4 -9,-5 -18,-6 -6,0 -14,3 -20,0 -8,-4 -1,-5 1,-8 1,-5 1,-2 -1,-7l3 -1 3 -2 5 -3 0 -4 0 0c-3,-1 -3,-1 -6,-3l-19 7 -1 2 2 0 -2 2 8 -1c1,2 0,0 0,2l2 8 -2 -1c-4,-2 -1,-2 -1,-2 -3,1 -4,0 -4,1 -1,0 -1,0 -1,0l4 3c-1,2 3,2 -3,2 3,2 7,0 8,-1l-4 7 14 8c-1,-5 -2,-1 1,-4 2,1 2,2 2,-1 -1,0 -2,2 -4,-1 8,0 12,-5 19,0 -3,1 -11,1 -11,1 2,4 -1,4 4,7l0 -4c3,-2 2,0 1,-3l7 1 4 2c5,3 0,2 4,5l-2 2c1,2 1,4 0,5 3,0 4,0 5,2l11 1c-4,-3 -1,-1 -9,-1 0,-3 0,-1 1,-4 0,-2 0,-1 1,-1 -6,-3 -2,3 -5,-4 -1,-4 2,-5 3,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil106",
    d: "M310 396l-5 0c5,-7 8,-4 12,-9 1,-2 0,-1 2,-3l0 3 3 2 0 -3c-3,-2 1,-10 1,-14 0,-4 -1,-4 -3,-7 -3,-4 -1,-3 -6,-5 -1,3 -2,1 -6,1 4,6 5,-3 9,7 2,8 3,12 -3,18 -2,2 -6,5 -8,7 -3,2 -2,1 -5,2 -3,3 -8,4 -12,4l-3 0c-8,3 -4,5 -17,6 -7,0 -13,0 -20,1l0 1 27 -2c-4,9 -14,2 -22,7 7,0 10,0 17,-1l9 -1c0,0 0,0 0,0l3 -1c7,-2 22,-9 27,-13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil106",
    d: "M305 1035l3 -3c0,0 2,-1 3,-1l-5 0c-3,1 -5,2 -7,3 -2,1 0,0 -1,-1l-7 -1c-2,1 -2,1 -8,2 0,-1 1,-3 1,-4 0,0 0,0 0,0l0 -1c1,0 1,-1 1,-1 1,-2 0,0 2,-3 6,0 7,-3 18,2 6,0 2,0 3,-3 -9,-3 -15,-5 -25,-4l-1 1c-3,2 -3,3 -3,5 -1,9 -1,10 9,10l-4 3 6 1 4 0c3,0 9,-3 11,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil106",
    d: "M157 546c-4,-6 -3,-7 -5,-11l-2 -1c-4,-4 -2,-4 -4,-8 -1,0 0,1 -3,2l-2 -1c0,6 3,10 -1,12 -3,2 -2,0 -3,-1 -1,-1 -1,1 -1,-2l0 3 2 5c1,-3 -1,-2 3,-2 3,3 5,6 9,9 5,3 2,1 6,4 2,1 4,2 7,3l-2 -5c-3,-7 -4,-3 -4,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil106",
    d: "M92 443c0,-3 0,-4 4,-4 2,1 2,2 6,3 0,-4 -1,-6 -3,-7l-2 -1c-5,-2 -2,-4 -4,-5 -10,0 -7,12 -7,18l3 3c0,-2 2,-5 3,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil106",
    d: "M347 1114l-1 -1 -1 5c0,3 1,2 1,6 0,1 -1,1 -1,1 0,0 -1,0 -1,0 -9,4 -4,1 -6,4 6,3 5,2 9,1 6,-1 3,1 7,1 8,-6 -4,-13 -7,-17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil106",
    d: "M326 1148l0 -9c1,-4 1,-2 -1,-3l-1 3 -4 -2c-3,6 -3,3 -9,4 1,9 1,3 -1,6l2 3 4 -1 2 -2c3,3 5,6 8,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil106",
    d: "M229 1133c-6,-3 -2,-1 -4,-4 -4,-5 -3,-2 -6,-1 -1,-3 0,-3 -4,-4 -3,2 -2,2 -5,4 -2,2 -4,3 -5,5 4,0 2,0 5,2 6,-2 4,-2 8,-5 2,4 0,6 7,5 4,-1 2,0 4,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil106",
    d: "M206 520l-12 -2c3,-4 3,-2 0,-8 -1,1 1,1 -3,0 -1,1 -4,2 -3,6 3,7 -1,1 5,4 -1,0 -1,-1 -1,1 -1,3 -1,1 -1,4 8,0 5,-2 9,1l7 0 -4 -3 3 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil106",
    d: "M102 462l3 -6c0,-1 -1,0 -1,-1 -2,-5 1,1 -5,-2 -2,-1 -2,-1 -5,-2 0,3 4,11 8,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil106",
    d: "M181 529c2,2 1,1 2,1 1,-1 2,1 0,-2 -5,-2 -1,-1 -2,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil106",
    d: "M221 1114l-2 -1c1,3 -1,2 2,3 1,-1 3,2 0,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil107",
    d: "M229 943c0,-2 4,-5 7,-6 5,-2 9,1 13,-3 -7,1 -10,-1 -14,-1 -3,1 2,-1 -1,1 -5,3 -6,5 -12,-1 -1,-2 0,2 -1,-3 6,-3 0,4 12,-6 1,0 5,-2 1,5 2,0 2,0 4,2 -3,-4 -3,-6 1,-8 5,-2 8,0 11,1 -6,-16 -15,4 -31,-3 -4,-2 -2,1 -3,-3 -4,1 1,2 -3,1 -4,0 -1,-1 -7,-1 -2,4 -2,3 -2,8l1 0 5 3c8,4 8,12 8,20l8 3 1 -1c-1,-1 -2,3 0,-4 0,-2 1,-3 2,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil107",
    d: "M329 389l3 -4c2,-6 7,-6 12,-7 -2,-2 0,0 -4,-1 -1,0 -1,0 -1,0 -13,-1 -6,-1 -9,-4 -5,-4 -4,1 -6,-12 11,2 8,4 9,5 -6,3 -6,-1 -8,3 5,2 0,0 6,-1l13 -3c0,0 1,0 1,0 0,0 0,0 1,0 0,0 0,0 0,0l3 0c0,0 1,0 1,1 9,3 2,0 10,5 -2,-10 -5,-11 -15,-9 -13,2 -10,-3 -16,-3l-4 -3 -6 -4c-4,2 -4,3 -5,7l0 1c5,2 3,1 6,5 2,3 3,3 3,7 0,4 -4,12 -1,14 3,2 3,3 7,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil108",
    d: "M196 179c0,-8 6,-5 1,-12 -2,-2 -3,-3 -4,-6 0,-4 -1,2 0,-3l3 -7 4 1 1 -2c-6,0 -1,-1 -4,-1 -2,0 1,2 -3,0l0 -3c4,-3 1,-1 7,-1l-1 4 3 -3c2,3 -1,13 -1,17 5,0 16,-6 19,-9 -6,-4 -7,2 -16,-12l-4 -3c0,0 3,3 1,-4 -3,3 3,3 -7,3 2,6 -2,3 -3,7l-3 0 -1 2c1,2 0,0 2,2 4,4 0,2 -3,4 4,2 4,2 1,6 -1,0 -1,2 -2,-2 0,6 -1,2 2,5 1,2 1,-3 1,6l1 3c-2,4 0,5 1,10 -2,-1 -7,-2 -9,-3 -7,-1 -3,2 -10,2l1 3c6,-3 5,3 9,-3 -1,4 -1,2 2,5l4 0 1 -4 2 5c0,0 0,0 0,0 4,-2 0,1 3,-3 1,-3 -1,-1 2,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil108",
    d: "M201 727c-3,-4 -5,-4 -5,-8 -8,-2 -5,0 -8,-3 0,-2 -1,-1 2,-2 3,-2 2,0 4,-3l0 -1c-6,-1 -3,1 -7,-2l-4 3c0,2 1,1 -2,3 0,0 -2,1 -3,1 -3,-2 -8,-5 -10,-7 -5,2 0,5 0,5 0,1 -1,2 -1,3 -1,-3 -1,-3 -4,-4 0,5 2,2 -2,5l3 1c0,4 -1,2 1,4 2,3 2,1 4,1l1 -5 10 -1c3,3 1,0 1,4l1 4c0,0 -1,-5 0,-3 0,1 1,0 1,0l3 2c2,1 3,4 4,6 0,1 0,1 0,1 2,-2 4,-5 4,-5l-1 2c6,0 2,0 4,1l2 4c2,3 1,5 0,9l3 -1c1,-1 1,-1 1,-1l2 -2c0,-2 0,-1 0,-2l-2 -2c0,0 0,0 0,0 -4,-7 -2,-1 -4,-5l2 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil108",
    d: "M180 149l0 0 1 -2c0,-7 0,-1 2,-5 2,-4 -2,-4 5,-8 4,-3 2,0 3,-5 -4,2 -5,1 -11,0 -5,-1 -5,-3 -7,-7l-1 -1 -3 0c1,2 0,3 -1,5 2,4 -1,5 -2,10l4 4c-5,3 -2,-4 -5,1l5 4c4,3 5,2 4,7 3,-2 0,-4 3,-7l3 4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil108",
    d: "M185 735c-1,5 -2,4 -4,8 -2,3 -3,5 -4,8l21 -1c-1,-1 -3,-2 -4,-3l-6 -8c0,-1 0,-2 -1,-2 -1,-2 2,0 -2,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil108",
    d: "M196 193l-1 -5 -4 1c2,2 1,1 0,5l5 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil109",
    d: "M333 649c-1,-1 0,0 -1,-2 -1,-1 -1,-2 -2,-3 -1,-3 -1,-1 -2,-6 -4,-3 -5,-9 -5,-15 6,2 3,2 6,7l2 0c-1,-4 -5,-9 -3,-13 3,1 3,2 5,5 7,0 3,2 9,0 2,0 1,0 3,-1l1 4c0,0 0,0 0,0l-1 2c0,1 1,1 1,1 1,1 11,6 3,13 0,2 -1,5 -1,7l5 2 -3 -6c1,-3 5,-6 5,-9 1,-2 -1,-8 -1,-12 -9,2 -5,-5 -18,-12 -2,-1 -2,0 -4,-1 -4,-3 -5,-5 -6,-9l-3 3c-1,4 -2,8 -2,13 0,2 0,4 0,6 1,4 2,5 -1,7 2,6 12,27 17,31l2 0c-1,-5 -1,-2 -3,-6 -1,-2 -2,-4 -3,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil109",
    d: "M104 236l-2 1c-3,-11 -2,-4 -5,-11 1,6 4,13 -2,16l-2 -7c-9,-3 2,-4 -7,-4 3,-9 -4,2 0,-9 0,0 -1,0 -2,-1 -3,0 0,1 -2,0 0,-5 1,-9 6,-8l0 -4c-13,7 -7,4 -12,16 6,3 2,6 8,16 5,8 6,4 8,16 4,-2 11,-14 12,-21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil109",
    d: "M133 1105c3,8 1,2 -1,4 -6,-5 -1,-5 -11,-7 4,3 9,8 8,14 -5,0 -4,-5 -8,-8l1 3c-10,-3 -1,-1 -10,0l3 -3c-2,-2 -2,1 -4,-2 0,-1 0,-2 -1,-3 0,0 -1,1 -2,1 -1,0 0,0 -1,0 -3,-5 -5,-8 2,-11l-4 -1c-8,8 -2,9 -2,18 5,1 4,1 7,4 5,5 2,3 7,6 5,2 12,5 14,9 4,0 3,2 4,-5 0,-2 0,-5 0,-6 0,-2 -1,-11 -2,-13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil109",
    d: "M354 597l-13 -3 -5 0c0,0 0,1 0,1l1 4c-3,0 -2,0 -4,2l18 15c0,0 0,-1 0,-1l-1 -1c-6,-8 -1,-5 0,-10 0,-1 -1,-2 -1,-6l5 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil109",
    d: "M124 1131c-2,-1 -14,-10 -15,-11 0,6 0,-2 1,4 1,5 -1,5 -3,7 2,4 2,4 4,3l2 4 2 1 2 -3c2,4 -2,2 4,3 1,-2 1,0 0,-2 0,-1 0,-1 0,-2 5,-2 1,-1 3,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil110",
    d: "M273 414c8,-3 16,-4 25,-6l-4 4c4,1 4,0 5,4 10,-6 2,-2 7,-9 7,-1 4,3 11,-1l-6 -4c1,-9 4,-7 12,-9l0 3c0,3 -1,-1 0,2 4,-1 -3,2 2,-1 2,-1 -2,0 1,0l1 9 1 0c2,-6 -1,-9 -2,-15l3 -2 0 0c-4,0 -4,-1 -7,-3l0 3 -3 -2c-4,4 -5,6 -9,9 -5,4 -20,11 -27,13l-3 1c0,0 0,0 0,0l-9 1c-7,1 -10,1 -17,1 -5,1 -4,0 -8,-1 -3,0 -4,0 -8,1l-1 5c2,1 2,1 4,2 4,-1 9,0 12,-1 4,-1 -1,-2 5,-1 1,0 3,1 4,2 8,0 7,-2 11,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil110",
    d: "M198 384c3,-2 6,-3 9,-2l2 7c-7,0 -6,-1 -7,-1l-2 -1c-2,-2 -1,2 -2,-3zm2 15c-2,-5 -2,-3 -3,-10 8,4 0,2 11,7 2,1 2,1 2,1 1,0 3,4 4,5 8,-2 6,-3 6,-5 -3,-2 -5,-1 -9,-1l-2 -5c10,-4 7,-2 8,-5 -3,-3 -4,-6 -6,0 -1,-4 0,-3 0,-7 -1,-8 1,-1 1,-6 -9,-2 -2,0 -10,3l-3 1c-4,2 -6,6 -6,11 3,5 4,6 2,13l0 0 1 0 0 -2 4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil110",
    d: "M114 994c-2,-1 0,0 -1,-3 6,1 3,1 7,2l4 -4c-3,-5 -4,-2 -7,-2 -7,1 -2,-2 -10,1 0,-1 0,-1 0,-1 0,0 0,-1 0,-1l-1 -2c-3,1 -1,-1 -2,2 5,5 6,1 10,4 -1,2 2,1 -2,2 -3,1 -3,0 -6,0 2,4 0,1 4,3l4 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil110",
    d: "M162 1013c-6,-1 -10,0 -15,-1l0 6 15 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil111",
    d: "M255 128l2 -9c0,0 -1,1 1,3 1,2 -1,0 2,2 8,5 -6,-1 2,1 2,-5 1,-5 1,-9 0,-6 -9,-29 -12,-36l-4 0 -1 -2c-1,4 0,4 -2,5l-2 -2c-1,-6 1,-3 -4,-4l2 18c-5,-4 -3,-2 -4,-8l-1 -7c0,0 0,0 0,1 0,0 0,0 -1,1 -3,10 3,19 4,25 -1,-2 -1,0 1,-1 -1,-1 -1,-2 -2,-3 1,0 1,0 1,0 4,-3 4,-6 4,-5 0,0 0,-1 0,-1l1 6c4,-4 1,-4 5,-1 -1,-7 -1,-3 1,-9 0,0 1,-3 1,-3 0,0 0,0 0,-1l2 -2c3,10 4,16 4,27l0 -1c0,4 -2,3 -3,10l-1 3c-8,1 -7,-1 -6,5 1,-3 -1,-5 4,-3 0,1 -1,3 -1,3l0 1c0,0 0,1 0,1 -1,2 -1,2 -1,5l1 -6c0,0 2,2 2,3l1 1c2,3 4,8 4,12 2,-5 0,-6 0,-7 -2,-4 -2,-10 -1,-13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil111",
    d: "M216 88l2 1 5 1 0 -1c0,-7 4,2 0,-8 -6,-3 -6,-1 -7,0 -1,2 -3,4 0,7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil111",
    d: "M69 351l-1 4 7 2c2,-1 1,0 -2,-3 0,0 -1,-2 -2,-2 -1,-1 0,-1 -2,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil112",
    d: "M230 692c3,-4 2,-1 1,-4l-1 -4c5,-1 3,1 4,-3l-3 0 -16 -14c-4,-2 -3,-3 -6,0 0,0 0,0 -1,1 -5,-7 -5,-10 -11,-7l3 5c2,3 15,9 18,15 -6,-1 -10,-7 -16,-6 -1,0 -4,0 -4,0 -3,0 -1,0 -4,1 4,2 4,-5 3,3 -4,1 -4,0 -7,0 3,6 2,3 7,6 7,0 20,1 24,6 6,0 4,3 9,-2l0 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil112",
    d: "M277 153c0,-7 -5,-12 -4,-18l-10 -19c0,4 1,4 -1,9 -8,-2 6,4 -2,-1 -3,-2 -1,0 -2,-2 -2,-2 -1,-3 -1,-3l-2 9c0,0 1,4 1,4l7 13c5,-2 -2,-1 3,-1 0,0 7,1 3,8 0,0 3,2 3,2 1,4 3,9 4,14 5,-8 0,-8 1,-15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil112",
    d: "M327 111l-1 7c5,-2 3,-2 5,-6 0,5 -1,8 -2,11l3 0c0,0 1,-1 1,0 4,0 -1,-2 2,1 0,0 0,0 0,0l2 2c0,-9 1,-2 4,-8l1 4c1,-3 0,-3 3,-5l-2 7c7,-2 2,-3 6,3 0,0 -3,1 -4,2 -3,3 1,3 1,3 6,-5 2,-2 5,-3 -1,-6 1,-6 1,-10 -4,-1 -1,-1 -5,3 2,-5 2,-3 1,-8 -4,3 -1,6 -4,1 -3,-4 -2,-6 -3,-8l-3 8c-1,-3 1,-2 -5,-12l-1 6c-6,-1 -5,1 -5,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil112",
    d: "M90 280l0 -3 -5 -1 -3 1 1 3c0,1 -1,2 -1,4 0,2 1,2 3,3 2,-2 1,0 2,-3l3 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil112",
    d: "M305 512c0,-5 -2,-3 -1,-9l-10 1 -1 1c3,1 1,0 2,2l0 -1 6 1 2 6 2 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil113",
    d: "M206 427l-1 -2 3 0c5,1 16,6 21,4l0 -2 0 0c-2,-1 -2,-1 -4,-2 -4,-1 -3,0 -6,-2 0,-4 -1,-3 3,-4l4 0 -3 -5c-5,-5 -6,-5 -19,-10 -6,-2 -5,1 -8,-3l-1 0c1,19 7,29 22,38 1,-3 1,1 5,-5 -6,-2 -14,-3 -16,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil113",
    d: "M98 927l1 -5 4 0 1 -2 -7 1c-1,-5 -1,-2 2,-6 3,-3 2,-3 5,-5l4 5c0,1 1,1 1,1 -4,1 -5,1 -5,5l5 0 4 0 1 -2c0,-4 -1,-3 2,-6l-1 -2 -2 -2c5,-2 3,-1 6,-4l-7 3 3 -5 -2 0 -5 1c5,-7 22,-10 28,-18 -6,1 -26,9 -28,13 -3,4 -7,7 -9,10 -4,4 -7,6 -8,12 -3,4 -1,2 -2,5 0,1 0,4 0,4 1,3 1,2 2,4l4 -13 3 6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil113",
    d: "M319 440c4,-6 6,-3 11,-8 -6,2 -1,1 -3,-1 3,-4 1,-2 4,-3 3,-2 1,0 2,-4l-5 -3 -1 -3c-1,-2 -2,-1 -3,-2 -3,4 -4,3 -7,6l-1 0c-1,5 1,7 -2,8l0 1 -1 7c-3,2 -1,2 -4,1l-2 3 -2 4 14 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil113",
    d: "M294 447l0 -6c-1,-2 -2,-8 -3,-8 -6,0 -10,0 -14,4 -3,4 -3,3 -4,8l1 0 1 3c2,-2 0,-1 3,-1 7,-1 6,-6 6,-6 0,0 0,0 0,-1 4,4 3,3 8,2 -1,3 -1,1 -5,4l7 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil113",
    d: "M262 303c-7,0 -29,2 -34,5 -3,4 1,-1 -3,3 -1,1 0,-1 -1,1 0,0 35,-7 38,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil113",
    d: "M109 998l-2 -1 -6 2c1,2 1,4 2,6 1,2 0,-1 1,2 1,3 0,0 1,3 2,-3 3,4 2,-3 1,3 1,5 4,0l3 5c1,-3 2,-2 4,-6 -12,-8 -3,3 -13,-6 2,-2 -3,-2 4,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil113",
    d: "M129 1012c0,-4 0,-4 5,-5l-4 -4 -2 0 0 1c-13,2 -8,1 -10,3 3,5 -4,-4 4,3l1 2c1,0 1,1 1,1 2,-2 -3,-1 3,-2 4,0 1,0 2,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil114",
    d: "M214 793l2 3 4 -1c-1,-7 -5,5 -5,-8 0,0 2,-8 2,-8 -1,-1 1,0 -1,0 0,0 0,0 0,0l-2 0c1,-2 1,-4 2,-4l1 -12 -4 -2c-2,-2 -1,-3 1,-5 -5,1 -7,-1 -12,-2 0,6 -4,11 -7,5 -6,7 1,2 -4,8l-4 0c1,3 0,1 1,4 1,4 -1,1 2,4 1,-5 1,-7 7,-7 4,1 7,2 9,6l-4 5c4,0 -2,2 4,0 -1,3 -1,4 1,6 -7,-2 -4,-3 -7,0 -2,2 1,1 -4,4 -2,3 -2,2 -1,5 1,0 2,-1 3,-1l2 -1c1,0 2,-1 3,-2 0,2 -1,6 -3,7l0 2 3 1c3,-10 0,2 3,-4 3,-7 -5,-2 1,-11l5 0 2 8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil114",
    d: "M239 172c2,2 1,-2 2,4l1 -4c2,-5 -4,2 1,-1 0,0 0,0 0,0 0,0 1,0 1,0 -1,-3 -1,-3 -3,-5l6 1c-2,-13 -3,-6 -9,-10 2,-9 0,-3 0,-6 -1,5 -1,4 -7,5 1,3 1,-1 1,4l-4 0c-1,2 0,6 0,6 -5,-1 -3,0 -5,-2 -3,8 3,8 -2,10l-1 -5c-4,4 1,2 -5,1 -2,0 -2,0 -5,4l1 3c3,0 6,-2 8,-1 3,0 3,3 3,5l3 0c-5,-12 7,-9 14,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil114",
    d: "M233 142l3 0c0,0 0,0 0,0l2 -1c-7,1 -1,1 -4,-1 0,-7 0,-4 -3,-9l-4 3 2 2c-4,0 -3,0 -8,-2l3 7c1,0 0,0 2,1 2,0 1,0 3,1l0 1 4 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil114",
    d: "M235 152c1,-4 -1,-6 -5,-6l1 1c-4,-1 -3,-1 -6,1 1,4 0,1 2,5l8 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil115",
    d: "M97 563c0,0 0,-3 0,-3 7,1 7,1 8,9l-7 -1 -1 -5zm16 8l-4 -4c-3,-3 -5,-5 -7,-9 -3,-3 -9,-5 -13,-8l1 -6c-6,-5 -12,-5 -15,-9l-13 -4c-4,1 -1,3 -6,0l-12 -7c-6,-4 1,-3 -8,-1 -1,4 -1,1 1,2 6,-1 16,12 21,15 -1,-4 -1,-1 0,-3l2 2 0 -4c1,0 2,0 4,0 0,0 0,0 1,0l6 6c2,-1 1,-6 7,-1 2,2 0,2 2,4 1,1 4,1 6,10 -5,2 4,-1 -2,0 -4,1 -2,-1 -3,3 -2,2 0,0 -3,1 -3,2 -1,0 -4,2 5,7 26,12 35,12l4 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil115",
    d: "M137 538c0,-9 -5,-12 -6,-22 4,0 6,2 10,3 4,2 5,3 5,7 2,4 0,4 4,8l2 1c4,-5 0,3 4,-3 -1,-9 -9,-15 -17,-18 -8,-3 -14,-8 -21,-13l2 -2c3,-6 4,0 4,-6 -3,1 -6,1 -9,1 0,0 -5,0 -5,0 -4,-1 -1,3 -3,-2 -3,2 -5,3 -6,8 11,-1 9,-3 16,5 3,3 8,6 9,10l2 1c1,7 5,14 7,22 -1,2 -1,1 1,1l0 -3c0,3 0,1 1,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil115",
    d: "M288 1094c-3,-3 -1,0 -1,-4 -8,0 -10,-1 -17,-2 -5,-2 -1,-2 -7,-3 3,5 4,2 5,7 -3,3 -9,3 -13,4 0,-2 1,-5 1,-5 0,-4 -2,-3 -1,-5 2,-3 -4,-3 4,-2 -2,-1 -16,-11 -14,-3 1,4 2,3 3,6 -5,1 -4,1 -8,-1 -5,4 -1,1 -2,4l3 1c-4,4 -2,0 -3,4 5,5 17,5 23,3 10,-3 16,-4 27,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil115",
    d: "M138 487c-2,2 -5,6 -7,8l2 3 8 1c6,0 2,0 3,-2l-4 -3c0,0 0,0 1,0 0,-1 1,0 4,-1 0,0 -3,0 1,2l2 1 -2 -8c0,-2 1,0 0,-2l-8 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil115",
    d: "M280 1117l1 -10c-1,1 -1,-2 -6,1 -1,1 -2,2 -3,2 1,3 -2,2 4,4 -5,4 -5,0 -8,4l3 1c4,2 -2,-3 2,1l1 3c5,-2 5,-2 6,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil115",
    d: "M135 440l-5 0c0,-5 1,-3 -2,-6 -5,0 -4,0 -5,3 3,5 -4,4 5,6 2,0 2,-1 5,0 2,2 1,1 2,3l2 -2 -2 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil116",
    d: "M242 805l3 -5 5 -30c-4,4 -2,0 -3,5 -2,6 3,6 -6,9 1,-4 3,-9 0,-12 -3,2 -2,-1 -2,6l0 3c0,5 2,4 3,8 3,-7 -2,-4 5,-7l-6 14c-2,4 -2,2 -4,6 -4,4 0,3 -5,5l3 -7c-1,-1 -8,3 -3,2 -2,-5 1,2 -1,-2 0,0 0,-1 0,-2 -1,-3 1,0 -1,-3 -4,12 -3,10 -1,18 -9,-1 -4,-4 -7,2 -3,6 -1,2 -7,5 6,-2 3,0 4,0 -13,11 -33,7 -44,13 4,2 0,2 5,1l-2 5c12,-2 29,-8 39,-10 9,-1 18,-20 25,-24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil116",
    d: "M317 742c1,2 -1,9 -1,9l3 -3 1 12c6,-5 -2,-6 5,-6 1,3 1,3 -1,6 3,4 6,7 3,9 -4,3 -1,1 -2,0 1,3 -1,0 2,1 0,0 1,0 1,0 1,0 1,0 3,1l-5 8 1 2c0,-6 -1,-6 5,-7 -1,5 -1,2 -2,6 -3,7 -1,3 -1,4 0,1 3,-1 -1,4 -4,3 -2,0 -4,4 1,0 0,0 1,0 1,1 1,1 1,1 0,0 1,0 1,0 7,-9 11,-5 17,-11 1,-8 -19,-36 -27,-40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil116",
    d: "M247 225l-7 2c0,-2 2,-3 3,-5 -4,1 -27,13 -28,14 -3,3 -2,2 -6,4l-11 4c0,0 -1,0 -2,1l-3 1c-8,4 -15,5 -19,10l2 1c12,-1 63,-23 71,-32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil116",
    d: "M308 793l1 -5c1,1 1,-1 0,4 3,3 1,2 5,1l0 4c4,-2 2,0 3,-6 1,0 2,-2 1,1 -1,4 2,0 -2,2l3 1c0,0 1,0 1,0l2 2c1,-5 0,-3 2,-5 -1,1 -2,0 -3,1 0,-5 0,-6 0,-8l-5 4 -3 -6c0,-1 1,-2 2,-2 2,-8 0,-4 -1,-5 -4,2 -1,1 -2,3l-1 4c-4,0 -3,1 -5,-2 -1,5 -4,7 -8,9 -2,7 -10,9 -11,11 1,2 4,3 5,5l9 1 1 -3 -6 -3c0,0 0,-6 6,-7 4,0 -1,1 3,0l3 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil116",
    d: "M66 705l-2 -1c-7,-2 -18,-3 -26,-3 2,6 13,14 19,16 7,-9 6,-7 4,-9l5 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil116",
    d: "M63 62c-2,-4 -5,-7 -7,-10 -3,-4 -3,-7 -7,-7 -3,6 1,20 2,27l2 -3c0,0 1,-1 1,-1 1,-2 0,-1 0,-2 6,3 6,-2 9,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil116",
    d: "M202 70c-4,-5 -21,-11 -28,-12 -4,2 -2,0 -3,2 3,4 1,2 6,2l0 5 -1 0c5,3 3,4 10,3 4,0 7,1 10,3l2 -3c2,-1 1,-1 4,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil116",
    d: "M240 669l-2 1 -2 -4c-2,3 -1,1 -3,3l-2 12 3 0c0,-3 -1,-1 2,-6 1,-1 2,-2 3,-4l-1 9 3 -4 8 11c0,0 0,1 0,1l4 1c-2,-6 -9,-15 -13,-20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil116",
    d: "M53 85l-1 -3c4,0 2,2 4,0 -1,-3 0,-1 -3,-2l-3 -2c-6,5 -4,3 -5,0 -6,5 -2,2 -5,7 -2,3 -4,1 -3,6 4,0 13,-4 16,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil116",
    d: "M79 80l-5 -6c-2,2 -2,1 -6,2 -1,5 -1,5 3,8 3,-5 1,0 6,-3l2 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil116",
    d: "M160 215l6 -1c6,-6 3,1 6,-4 0,0 0,0 -3,-1l-10 0 1 6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil117",
    d: "M205 813c-7,-2 -13,-1 -16,-1 -4,-1 -2,1 -4,-2l5 -2c-3,-1 -41,-8 -48,-9l-34 -10c-6,0 -4,5 -1,7 4,3 38,13 44,14 31,3 22,4 54,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil117",
    d: "M230 577c-3,-5 -1,-2 -5,-4 -3,-3 -1,-4 -5,-4 -1,4 2,11 4,14 0,0 0,0 0,-1 1,0 1,0 1,0l2 -2c3,-3 -2,0 3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil117",
    d: "M283 1213c-2,2 -2,1 -3,5 1,2 1,1 2,2 1,0 1,0 1,0l2 1c4,0 4,1 8,1 -1,-5 -6,-7 -10,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil118",
    d: "M159 774c2,-9 13,-11 20,-5 0,-1 0,-3 3,-4 1,0 3,2 5,2l4 0c5,-6 -2,-1 4,-8 3,6 7,1 7,-5 -9,0 -21,2 -28,-1 -1,-5 -1,-6 2,-9 3,-4 4,-6 7,-8 -1,-5 -1,-5 -6,-6 -3,4 0,2 -2,7 0,0 -2,2 -2,3 -3,2 -3,3 -4,6 0,0 0,1 0,1 0,8 6,6 -2,12 -3,1 -1,2 -3,3 -4,2 -2,0 -6,0l-3 1c-4,1 -5,0 -6,-4 -2,2 -2,2 -5,4 0,-4 1,-2 -2,-5 -3,3 -2,0 -2,5l7 9c3,-2 3,-2 6,-3l2 7 4 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil118",
    d: "M211 177l-1 -3c3,-4 3,-4 5,-4 6,1 1,3 5,-1l1 5c5,-2 -1,-2 2,-10 2,2 0,1 5,2 0,0 -1,-4 0,-6l4 0c0,-5 0,-1 -1,-4 -6,2 -9,3 -15,6 -5,2 -10,5 -16,5 -3,-6 -1,-8 0,-15l-4 -1 -3 7c-1,5 0,-1 0,3 1,3 2,4 4,6 5,7 -1,4 -1,12l7 0c4,0 5,-1 9,1l-1 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil118",
    d: "M250 198c1,-3 0,-7 3,-8 2,-2 2,-1 4,-2 0,0 3,-1 4,-2 -1,-4 -1,-3 -3,-5 0,0 1,2 0,2 0,2 0,1 -1,3 -5,-1 -4,-3 -5,-8 0,-1 -1,0 -1,-1 -1,-4 0,0 -1,0l-5 -4c1,-4 2,-2 3,-3l-1 -3 -6 -1c2,2 2,2 3,5 0,0 -1,0 -1,0 0,0 0,0 0,0 -5,3 1,-4 -1,1l-1 4c-1,-6 0,-2 -2,-4 0,9 -4,10 -13,10 3,3 3,3 8,1 6,-3 -1,-1 6,-4 0,0 3,3 3,3 2,2 1,0 2,3l2 8c0,0 0,0 0,0l-3 2 0 3 2 0 4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil118",
    d: "M184 185c-3,-3 -3,-1 -2,-5 -4,6 -3,0 -9,3l-1 -3c-4,-3 -3,2 -4,-2l-3 0c5,12 10,8 13,16 0,2 0,0 1,0 3,1 5,1 7,3 -3,-6 3,-7 3,-7 0,1 1,0 1,0 -7,-3 -1,-2 -6,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil118",
    d: "M214 793l-2 -8 -5 0c-6,9 2,4 -1,11 -3,6 0,-6 -3,4l4 1 1 -5c3,0 3,-1 6,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil118",
    d: "M200 149l1 -4c-6,0 -3,-2 -7,1l0 3c4,2 1,0 3,0 3,0 -2,1 4,1l-1 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil119",
    d: "M285 187l1 -9 -3 -11c-3,-4 -1,-10 -6,-14 -1,7 4,7 -1,15 -1,-5 -3,-10 -4,-14 -3,3 -3,3 1,12 1,4 7,1 3,13l2 -1c3,0 0,-2 2,1 2,2 0,3 -1,6 -1,5 3,6 -2,8l0 -9c0,0 -1,-3 -3,3l-2 -5c-2,2 0,4 -3,7 -2,-8 3,-5 0,-11 -2,-3 -2,-2 -4,-6l-1 -1c0,0 0,-1 0,-1 0,0 0,0 0,0l-2 -2c-1,-1 -1,-3 -2,-4l-1 6c-4,-5 0,-6 -6,-10 1,7 5,15 5,21 2,2 2,1 3,5l2 10 3 -1 3 7c1,-3 1,-3 -1,-6 0,-2 -2,2 0,-4 2,-6 0,-1 3,-4 0,3 -1,4 1,7 4,5 1,-5 3,2 0,0 1,0 1,0 -2,6 0,8 -2,13 -1,3 -2,6 -4,10 5,-1 5,0 7,-6 1,-3 2,-6 3,-9 1,-5 2,-14 5,-18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil119",
    d: "M344 164c1,-2 1,-3 1,-4l0 -2c0,0 0,-1 0,-1l-2 2c0,-1 -3,-6 2,-7l5 0c2,0 4,1 5,2l7 -21 -5 2c6,-4 -3,3 -3,15 -3,-4 0,-2 -3,-5l-2 -4c0,1 -2,8 -6,5 0,-2 1,-7 0,-8l-2 0c-1,0 -1,1 -1,0l2 -2 -1 -6c-5,4 -2,2 -2,5 0,4 1,1 -1,6l-3 -2 -3 11 -1 4c2,1 2,-1 1,6 6,-6 -1,-6 5,-8l1 -1c1,-1 0,0 1,-2l2 6c-4,5 -3,0 -4,8 -1,-1 -1,0 -3,-4 0,4 1,2 -2,5 0,0 0,0 0,0l1 -3 -4 1 -1 -3c-2,3 -3,4 -3,7 6,2 -1,-1 3,0 3,0 -2,-4 3,0l13 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil119",
    d: "M202 263l-3 -2 -3 5c-1,0 -1,0 -1,0 -1,-1 -2,-1 -5,-1l2 -5c-4,1 -8,3 -12,5 -5,3 -6,2 -6,8 7,0 24,-6 28,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil120",
    d: "M216 88c-3,-3 -1,-5 0,-7 1,-1 1,-3 7,0 4,10 0,1 0,8 3,-4 1,-2 4,-4 -1,0 -1,-1 -1,-1 -1,0 -1,-1 -1,-1 0,0 -1,-1 -1,-1 4,-11 3,-3 5,-9 2,0 -2,1 6,2 2,1 0,1 3,1 2,0 0,-1 3,-2l1 7 2 2c2,-1 1,-1 2,-5l1 2 4 0 0 -1 -2 -3 -20 -12 -5 1 -1 8 0 4c-7,0 -15,-4 -21,-7 -3,-1 -2,-1 -4,0l-2 3c-3,-2 -6,-3 -10,-3 -7,1 -5,0 -10,-3l-14 0 -1 4c-4,-1 4,-1 -4,-2l-3 4 9 0 1 -3c2,5 0,2 4,4 3,-2 1,2 3,-4l0 4c5,-2 9,-2 12,2l29 6c-4,2 -13,-2 -18,1l14 1c-2,3 -2,3 -5,5l0 -1c0,0 1,-1 0,0 0,0 -1,0 -2,4l15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil120",
    d: "M128 1183c2,-7 5,-9 9,-13l4 2 3 1c3,-1 2,0 1,-2l-5 -4 9 -2c-2,-6 -5,-4 -8,-14l-5 -1 -3 3 -2 0c-1,3 6,0 5,11l-8 -2c2,4 -1,3 3,4l-3 6c0,0 0,0 0,-1 0,-1 -3,-3 -4,-3 0,0 0,-1 0,-1l1 -3c-9,-4 -11,5 -18,5l-2 5c4,1 3,1 7,0 3,-1 1,0 3,-3 7,-3 6,-5 12,2 -1,4 -3,6 -5,9 -2,5 2,5 -4,7 -4,-2 -1,-1 -4,-4 -4,-3 -3,-4 -5,-1 6,8 7,6 10,16l6 0 1 -5 -5 -4c4,-2 4,-6 7,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil120",
    d: "M69 706c-3,-1 -2,0 -3,-4l0 3 -5 3c2,2 3,0 -4,9 5,4 1,12 4,18 -1,-8 3,-13 2,-21l6 3c-2,0 -2,-1 -3,1l-2 4c0,0 0,0 0,0 8,2 6,-3 9,-4 2,-1 -1,0 2,-1l1 0c-2,-7 -1,-2 -5,-6 0,-4 -1,0 1,-2 2,-4 1,2 0,-1l-3 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil120",
    d: "M307 93c-4,0 -2,-1 -3,3 -1,5 -1,2 0,5l3 -6 2 5c3,-3 1,-2 3,-3 5,-4 -1,4 1,-1 1,-2 2,-4 1,-6 1,2 0,1 -1,5l-4 -3c-3,0 2,-4 -2,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil121",
    d: "M295 166c-2,-3 -2,-3 -2,-6 0,0 -11,-36 -12,-40 -2,-2 -3,-10 -6,-16 -4,-6 -4,-11 -6,-17l-2 -2c-2,2 -1,1 -2,3 0,2 0,1 1,3 0,5 1,7 -1,11 -4,-3 -2,-2 -3,-4l-1 -3c0,0 0,0 0,-1 -1,-4 0,-6 -1,-11l-1 -2c0,-1 0,-1 0,-1 0,-1 1,-1 2,-1l-5 -2 1 4 -6 -2 0 1c3,7 12,30 12,36l10 19c3,-2 -3,2 3,-1l-4 -13c-1,-4 0,-3 3,-6 0,5 14,34 15,45 0,2 -1,4 -1,8 1,6 2,3 -2,7 -2,-6 0,-5 0,-9 -2,3 1,2 -4,1l3 11c1,-2 1,-1 2,-2l4 -2 0 5 3 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil121",
    d: "M260 791c-2,-7 2,-18 3,-26 1,-6 0,-22 3,-26l1 -11c-2,-4 -1,-11 0,-16l0 -5 -2 0c0,0 -1,1 -1,1 0,2 -2,6 -3,8 -3,9 0,3 -5,5l1 -9c1,-7 3,-1 4,-10l-5 4c2,-7 0,-8 0,-15l-2 0c1,7 -1,35 -3,42l0 19c2,1 1,1 4,2l2 -19c4,-2 -3,1 1,0l2 0c0,0 0,0 0,0l0 -1c1,0 2,1 2,1 -2,3 -2,26 -2,31 -1,10 -2,21 -7,28l3 1 4 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil122",
    d: "M137 974c1,-3 0,-4 3,-5 0,0 2,-3 6,-1 0,0 0,0 0,0l1 1c1,0 1,1 5,1l-1 -3c-2,-3 -2,-1 -3,-5l2 -2c2,-3 0,-7 -1,-12 -3,-2 -2,-2 -2,-5 -7,0 -9,5 -10,6 -4,3 -3,2 -6,0 1,-5 -1,-1 2,-6 -5,2 -3,3 -8,5 -4,2 -3,0 -7,4 -3,3 -7,8 -12,10 -1,3 -5,9 -9,11 4,-1 3,0 6,-3 2,-3 0,0 2,-4 5,-3 6,-6 8,-7 0,0 1,0 1,-1 8,-6 8,-10 12,-6 1,1 3,5 -2,7 -3,1 -3,1 -7,1l-2 5c4,2 0,-1 3,1 0,0 1,0 1,0 5,3 0,-3 2,2 -1,1 -8,2 -7,4 1,4 16,3 18,4 7,0 5,2 8,3 0,-4 -8,3 -3,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil122",
    d: "M253 394l0 -4 -1 -5c0,-5 -2,1 -2,-6 2,-2 0,-1 4,-2 1,-7 -1,-11 0,-18 -13,5 0,10 -11,9 3,-5 4,-1 3,-6 -7,4 -2,2 -13,3 -1,2 -1,5 -5,6 -2,0 -4,-1 -8,-1 -2,4 2,0 -2,4 1,0 4,1 4,1l4 3c3,4 2,7 2,10 11,4 4,6 11,6l2 0c2,-9 -5,6 -4,-9 9,1 2,0 7,4 3,3 5,3 9,5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil122",
    d: "M140 915c-8,0 -8,1 -12,6l0 0 -3 8c4,-3 1,-2 6,-3 4,-1 2,-1 7,-3l4 3c6,1 2,-1 7,2l-3 3 3 -1c3,-3 -6,-2 2,-2 -1,-5 1,0 2,-6 1,-6 -4,-5 -4,-5 5,0 1,-4 0,-6 -6,1 -5,0 -9,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil122",
    d: "M256 331l-14 2 0 1c-2,4 -3,4 -6,7l11 -1c9,1 3,4 13,4l0 4c4,-1 2,-3 7,-5 -1,-7 -2,-5 -3,-7 0,0 2,-1 0,-5l-8 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil122",
    d: "M306 1031l2 -4 -3 0c-11,-5 -12,-2 -18,-2 -2,3 -1,1 -2,3 0,0 0,1 -1,1l0 1c0,0 0,0 0,0 0,1 -1,3 -1,4 6,-1 6,-1 8,-2l7 1c1,1 -1,2 1,1 2,-1 4,-2 7,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil123",
    d: "M294 129l-3 1c1,-7 -1,-6 0,-11 1,-6 1,-4 0,-10 2,2 2,2 5,3 1,-9 1,-6 -2,-7 0,-1 -1,-1 -1,0 0,0 0,0 0,0 1,-5 0,-2 3,-4 2,3 0,4 2,4 6,0 -3,-3 2,0l1 3c0,0 0,0 0,0 1,0 3,-1 5,-2l1 3 0 -1 -1 -3c0,0 0,0 0,-1l-2 -2 -2 5c-3,-15 2,-6 -1,-19l-3 1c0,0 0,0 0,0l-4 -1c-6,-2 -6,-2 -6,6l-1 -6c-2,6 0,0 -7,2 -2,-6 2,0 0,-5 -3,1 2,0 -2,0 0,0 -1,0 -2,0 0,0 0,1 0,1 0,0 0,1 0,1l-1 5c0,-2 0,-2 0,-4 -1,-4 -1,0 -2,-6l-4 0 0 5c2,6 2,11 6,17 3,6 4,14 6,16 3,-4 -1,-3 2,-3 6,0 2,0 4,8 2,7 0,-6 1,2 0,0 -1,11 3,9l3 11c5,-6 0,-4 0,-8 0,-4 3,-6 0,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil123",
    d: "M274 757l-4 -2c1,-3 3,-8 4,-10l5 -7c2,4 1,4 0,6 9,-7 4,-4 5,-12 6,1 0,7 6,1 5,1 -1,0 3,-4 0,0 5,-3 2,-3 -2,-1 0,-1 -2,1l0 -5c-6,6 -1,-4 -7,2l1 -6c-4,1 -4,2 -7,0l0 0 -4 -3c-3,-2 0,-2 -4,-2 -4,5 -1,5 -2,8 0,5 -1,3 -3,7l-1 11 0 4c2,-5 4,-2 4,1 0,0 -1,6 -1,7 -1,5 -2,0 -2,5 -1,9 2,1 2,6 -2,3 -3,6 -3,10 7,-4 1,-2 4,-7 2,-4 3,-3 4,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil123",
    d: "M326 779l5 -8c-2,-1 -2,-1 -3,-1 0,0 -1,0 -1,0 -3,-1 -1,2 -2,-1 1,1 -2,3 2,0 3,-2 0,-5 -3,-9 2,-3 2,-3 1,-6 -7,0 1,1 -5,6l-1 -12 -3 3c-1,3 -1,1 -4,2 -6,1 -3,1 -6,4 2,4 -2,0 2,2l3 1c-3,5 -2,2 -4,7 3,0 7,1 6,-3 -2,4 -3,6 -4,9 2,-4 0,0 5,-3 0,0 0,0 0,0 1,-1 1,-1 1,-1 0,0 0,-4 2,-1 0,0 0,0 0,0l4 4c-1,4 -3,5 -4,7 4,1 7,0 9,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil123",
    d: "M267 1219c2,-2 -1,-1 4,-3l-5 -1c2,-7 5,-4 1,-9 -3,-1 -1,-1 -4,1 -1,-1 -3,3 -1,-3 -1,3 0,0 -1,1l0 0 -3 6 9 8 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil124",
    d: "M110 995c-4,-2 -2,1 -4,-3 3,0 3,1 6,0 4,-1 1,0 2,-2 -4,-3 -5,1 -10,-4 1,-3 -1,-1 2,-2l1 2c0,0 0,1 0,1 0,0 0,0 0,1 8,-3 3,0 10,-1 3,0 4,-3 7,2l-4 4c-4,-1 -1,-1 -7,-2 1,3 -1,2 1,3l21 -2 -6 0c3,-4 1,-3 2,-6 1,0 2,1 2,1l14 -3c5,-2 0,-2 6,-2 0,0 0,0 0,-1l5 -5c-4,1 -4,-2 -6,-6 -4,0 -4,-1 -5,-1l-1 -1c0,0 0,0 0,0 -4,-2 -6,1 -6,1l0 4c5,0 2,1 13,2l-6 4c0,0 0,1 0,1 0,0 0,1 0,1 -4,2 -10,4 -14,2 1,-2 -1,-2 4,-3 2,0 4,0 6,0 2,-8 0,-3 -6,-6 -5,8 3,1 3,5 -3,-1 -1,-3 -8,-3 -2,-1 -17,0 -18,-4 -1,-2 6,-3 7,-4 -2,-5 3,1 -2,-2 0,0 -1,0 -1,0 -3,-2 1,1 -3,-1l2 -5c4,0 4,0 7,-1 5,-2 3,-6 2,-7 -4,-4 -4,0 -12,6 0,1 -1,1 -1,1 -2,1 -3,4 -8,7l5 0c0,1 -1,3 -1,3 0,4 3,-2 1,8 5,-4 3,-3 8,-1 0,6 2,1 -8,10 -2,-5 1,-1 -1,-7l-2 1c3,-6 0,-3 -1,-4 -4,0 -6,0 -8,5 2,4 0,0 3,2 0,0 0,0 0,0 1,0 1,1 1,1 3,2 0,-2 2,1l-7 1c2,4 3,1 3,8l1 1 6 2c0,0 0,0 0,0l2 1 19 2c1,-4 1,-1 0,-3 -5,2 -4,2 -9,1l-2 -1c-8,0 -6,0 -7,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil124",
    d: "M249 400c1,0 1,0 1,0l5 -4c-2,-1 -1,0 -2,-2 -1,1 -5,1 -6,2 -3,1 -3,0 -3,2 -1,2 -9,0 -11,0 -4,-2 -1,-1 -3,-6 -7,-1 -9,2 -11,-4 6,3 2,1 9,0 0,-3 1,-6 -2,-10l-4 -3c0,0 -3,-1 -4,-1 4,-4 0,0 2,-4 4,0 6,1 8,1 4,-1 4,-4 5,-6 11,-1 6,1 13,-3 1,5 0,1 -3,6 11,1 -2,-4 11,-9l0 0 -1 -4c-7,1 -11,5 -18,5 -7,0 -7,0 -12,3 -4,2 -7,3 -11,5 -1,1 -8,6 -10,8 8,-3 1,-5 10,-3 0,5 -2,-2 -1,6 0,4 -1,3 0,7 2,-6 3,-3 6,0 -1,3 2,1 -8,5l2 5c4,0 6,-1 9,1 0,2 2,3 -6,5 -1,-1 -3,-5 -4,-5 0,0 0,0 -2,-1 -11,-5 -3,-3 -11,-7 1,7 1,5 3,10 1,0 3,1 4,2 3,0 4,0 7,1l12 2c6,-4 2,0 4,-6 12,3 5,0 12,2 7,1 7,-2 10,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil124",
    d: "M146 526c0,-4 -1,-5 -5,-7 -4,-1 -6,-3 -10,-3 1,10 6,13 6,22 1,1 0,3 3,1 4,-2 1,-6 1,-12l2 1c3,-1 2,-2 3,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil124",
    d: "M294 412l4 -4c-9,2 -17,3 -25,6 7,2 6,5 11,4l8 -4c0,0 0,0 1,0 1,-1 0,1 1,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil124",
    d: "M99 966l-1 -5c-1,0 3,-2 -3,0 2,-7 2,-3 0,-5 -2,3 -2,6 -4,10 0,0 2,2 2,2 1,2 0,0 2,3l4 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil125",
    d: "M294 306c-7,-4 -23,-2 -32,-3 -3,2 -38,9 -38,9 -4,4 -2,0 -6,6 4,-2 6,-4 11,-5 4,-1 4,-1 7,1l1 1c3,-3 0,-2 6,-4 6,-3 6,-1 10,-1l-12 4 8 1c-3,7 -7,2 -13,6 1,1 -2,4 8,0 5,-1 3,0 9,-1 2,-5 1,-4 -1,-8 5,0 2,-1 9,3 2,1 -1,-3 2,1 -2,1 -5,3 -7,2l1 4c-6,0 -3,-1 -6,2 12,-1 22,-2 34,-2 12,1 18,4 29,7 2,1 -1,-3 -5,-5 -1,0 0,1 -3,-1l3 -3c0,0 0,0 0,0 -12,-7 -26,-7 -32,-10 0,0 -1,0 -1,0 0,0 -1,0 -3,-3l2 -1c7,-2 10,3 19,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil125",
    d: "M320 1058c2,-1 13,-20 15,-24 5,-7 15,-17 18,-24l-7 2c0,0 -1,0 -1,1 -3,4 -5,3 -5,7l-5 -2c-3,7 -3,6 -10,7 -6,0 -12,0 -17,-1 -1,3 3,3 -3,3l3 0 -2 4 5 0c-1,0 -3,1 -3,1l-3 3c9,-2 10,1 20,-2 -2,4 -6,9 -8,14 -2,5 -5,10 -7,16l4 1c1,-1 2,-2 3,-3 2,-1 -1,0 3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil125",
    d: "M62 531c-6,-7 -4,-5 -11,-9 6,-4 23,-7 29,-13l-2 -4 -4 0c0,0 -1,0 -1,0 -5,0 -23,7 -29,9 -11,3 -22,4 -33,7l0 3c5,-1 3,-1 7,1 0,3 0,1 -2,3l21 -3c-2,-1 -2,2 -1,-2 9,-2 2,-3 8,1l12 7c5,3 2,1 6,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil125",
    d: "M125 910c1,-3 -1,-2 4,-4 6,-2 3,3 4,-2 0,0 4,0 1,-4 0,-1 0,-1 -1,-2 -4,-4 -1,2 -1,-1 4,-3 3,-3 8,0 0,0 1,-1 1,-1 2,-2 0,-1 4,-2 2,1 2,-3 1,3 1,0 2,4 5,1l2 -2c0,0 0,0 0,0 3,-5 0,-1 7,-8 -8,1 -7,-1 -9,-3 4,-2 5,-1 7,-4l-22 5c-6,8 -23,11 -28,18l5 -1c2,-3 1,0 4,-1 6,-3 2,-4 15,-8l-3 3c-4,3 -3,2 -7,4l4 0c1,0 3,-1 3,-1 0,6 -2,3 -10,9l-4 2 1 2 7 -1 2 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil125",
    d: "M262 1031l0 5c-2,0 0,2 -4,0 -5,-1 -3,-2 -3,-3 3,-3 3,-2 7,-2zm21 -11c-7,0 -37,9 -37,17l6 1 10 1c3,1 10,-2 16,-2 2,5 0,4 3,5 3,1 5,0 8,-1l1 -1 -6 -1 4 -3c-10,0 -10,-1 -9,-10 0,-2 0,-3 3,-5l1 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil125",
    d: "M173 952l-3 1 -2 -5 -5 1c1,5 0,3 4,6 4,4 0,3 5,3 1,0 2,0 2,0 2,-1 1,0 3,-2l-4 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil125",
    d: "M210 1135c-3,-2 -1,-2 -5,-2 -3,2 -5,4 -6,8 2,2 0,1 4,2 1,-2 2,-3 4,-5 2,-2 1,-1 3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil125",
    d: "M215 520l-9 0 -3 3 4 3c4,-1 7,0 9,-3l-1 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil126",
    d: "M285 775c-2,8 0,1 -9,8 -1,0 -1,-1 -1,-1 -3,-6 -6,0 -6,-9l7 -4 6 4c4,2 2,-1 3,2zm13 5c0,0 0,0 -1,0l-4 -2 3 -6c2,-8 3,-2 4,-10 -1,-6 -6,0 -9,-7 -2,-3 -1,-2 -3,-5l1 -2 -3 -3c-6,3 -3,2 -7,6 3,2 3,-3 2,3l5 -4c-1,4 0,1 -3,5 1,1 0,1 4,1 -3,5 -1,3 -2,5l-4 1c-4,-6 1,0 -5,-3 0,-3 0,-1 1,-4l-3 2c-1,5 -2,4 -4,8 -3,5 3,3 -4,7 0,-4 1,-7 3,-10 0,-5 -3,3 -2,-6 0,-5 1,0 2,-5 0,-1 1,-7 1,-7 0,-3 -2,-6 -4,-1l0 -4c-3,4 -2,20 -3,26 -1,8 -5,19 -3,26 6,1 14,-1 20,-4 10,-5 5,-7 18,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil126",
    d: "M167 1225l-6 -2 -1 -5c3,-9 -7,-47 7,-25l6 10 3 12c3,-1 1,3 4,-3 0,-13 -22,-37 -35,-41 1,2 2,1 -1,2l-3 -1c-1,5 0,4 0,9 2,5 0,9 2,14 1,6 0,3 3,5 3,-12 1,-10 -1,-21l-1 -5c4,1 2,-1 5,4l4 3c2,4 1,7 1,11 2,2 2,1 1,2 6,4 3,6 1,10 3,1 0,0 1,2l0 7c-3,0 -8,-2 -10,-6l-7 3c-2,-8 -4,-2 -4,-2 3,10 5,4 14,9 4,2 7,11 9,11 3,-1 0,0 4,-1 2,0 -1,0 2,1 2,-1 2,2 2,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil126",
    d: "M364 555l-11 -3c-2,1 0,1 -3,0 0,0 -2,-2 -2,-2 -3,-2 -2,-1 -4,-4 3,5 1,1 2,6 1,4 2,3 3,4 0,1 0,1 1,1l-2 2c0,0 0,0 0,1l8 -1c-2,2 -2,2 -1,4 9,-1 7,-3 8,-5 -4,-2 -4,1 -7,-3 4,1 5,2 8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil126",
    d: "M53 285c-4,-2 -3,-4 -11,-3l-2 4 7 7c3,-3 0,-1 3,1 1,-6 1,-2 0,-9l3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil126",
    d: "M356 235l-13 -2c-2,6 1,-1 -2,2 -1,1 -1,-1 -2,2 0,5 3,5 6,5 3,-6 1,0 4,-5 0,0 0,-1 0,-1 0,0 0,0 1,-1l6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil127",
    d: "M309 136c4,2 2,1 3,3 0,0 0,1 0,1l1 4c-1,5 1,0 -6,8 0,0 -1,0 -1,0 -4,-5 -4,3 -8,-3 -4,-8 4,-1 1,-11 3,1 6,3 6,-1 2,2 -1,5 4,4 2,-3 0,-1 0,-5zm11 7c0,-4 1,-15 2,-19 -4,1 -1,-2 -5,2 3,-7 -2,-1 8,-3 -2,-3 -2,-3 -6,-4 3,-4 2,-2 2,-8 -6,3 -4,0 -9,6l7 -2c-1,5 0,9 -6,7 -5,-1 3,0 -8,-4 2,-4 2,-2 4,-2 6,-1 -3,4 1,-1 -4,-5 4,0 -3,-3 4,-4 -1,-2 3,-1 2,0 1,1 1,2l0 -4c0,0 0,2 -4,-1l0 1 -3 5c-2,0 -2,-1 -4,2 -3,7 1,5 -6,6 1,5 3,4 0,7 3,4 0,6 0,10 0,4 5,2 0,8l-3 -11c-4,2 -3,-9 -3,-9 -1,-8 1,5 -1,-2 -2,-8 2,-8 -4,-8 -3,0 1,-1 -2,3 1,4 12,40 12,40l1 -5c1,0 1,-2 2,3 0,-1 1,-4 2,-4 2,-3 0,-1 3,-3 1,3 1,3 0,6 1,-3 1,-4 2,0 2,3 1,1 1,4l-3 -1 -4 6c13,-4 17,-14 23,-23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil127",
    d: "M318 542l-1 -7 -5 1 0 5c0,6 -1,9 -6,12 -1,-6 0,-7 0,-11 0,-3 -1,-6 -1,-10 0,0 0,0 -1,-1 0,-1 -1,-2 -1,-7 0,-4 1,-4 1,-9l5 4c1,0 1,0 1,0 6,4 3,-2 5,4 3,-2 3,1 3,-2 0,1 -1,1 3,2 2,2 0,2 2,0 0,-6 -3,-4 -8,-6 -3,-1 -6,-4 -10,-5l-2 1 -2 -6 -6 -1c2,2 -2,1 3,2 5,1 2,6 2,10 -1,4 -1,8 -1,13l-3 1c2,2 2,1 3,6 0,3 0,3 0,7 -4,-2 -3,-3 -6,-7l-5 -9c-3,-5 -3,-9 -4,-15 -4,-2 0,-1 -4,-2 3,-11 -1,-4 -2,-15 8,2 2,2 7,5 2,1 1,1 3,1 2,1 4,0 5,-1 -8,-3 -8,-3 -13,-10 -4,0 -1,0 -4,4 -1,13 10,49 24,55 4,4 2,2 6,4l6 -4 3 6c0,0 1,0 1,0 0,-1 0,-1 0,-1l1 -2c2,-1 -4,-1 0,1l1 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil127",
    d: "M180 649c-4,-5 -45,-16 -51,-11 -2,5 5,5 9,6 18,4 29,9 45,13 -4,-7 -3,-3 -8,-6 2,-2 1,-2 5,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil127",
    d: "M158 790c-2,-2 -34,-16 -37,-16 -7,-1 -5,0 -2,6 1,1 32,13 36,14 0,-3 0,-3 3,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil127",
    d: "M249 613l-6 -12c0,0 0,0 0,0 0,0 -1,0 -1,0 -4,0 2,-2 -4,1 -1,0 -3,2 -4,4 -5,-2 -6,-7 -9,-2 -1,2 -1,3 -1,4 0,3 1,0 0,2 0,2 -2,3 -3,7 4,-4 9,-8 14,-9l10 10 1 -5 3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil127",
    d: "M115 1171c-2,3 0,2 -3,3 -4,1 -3,1 -7,0l2 -5 -4 1c-9,4 -6,2 -7,6 2,1 2,1 5,2 1,0 2,0 2,1 2,0 -1,0 1,0 -4,-1 -6,-2 -8,1l13 4c2,-3 1,-2 5,1 3,3 0,2 4,4 -2,-2 -3,-3 -4,-5 -3,-11 9,-1 5,-8 -3,-4 -2,1 -4,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil127",
    d: "M350 257l-4 -7c-1,2 0,2 -2,2 -3,-5 0,-2 -3,-4 -5,4 -1,0 -5,6 2,3 7,6 11,8l3 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil127",
    d: "M327 793c0,0 -1,0 -1,0 0,0 0,0 -1,-1 -1,0 0,0 -1,0l0 0c-2,2 -1,0 -2,5l-2 -2c0,0 -1,0 -1,0l-3 -1c4,-2 1,2 2,-2 1,-3 0,-1 -1,-1 -1,6 1,4 -3,6l-2 1c3,1 2,1 4,2 3,4 -1,1 3,3 4,-2 5,-6 8,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil127",
    d: "M313 905c-1,-1 -1,1 -2,-3l-5 1 -1 5 0 8c4,-1 3,0 5,-4 1,-3 2,-5 3,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil128",
    d: "M101 500c1,-5 3,-6 6,-8 4,-1 14,-12 15,-16 -5,2 -1,2 -6,1 3,-5 1,0 1,-6l5 -2c1,5 0,3 3,6l14 -17 -2 -2 1 -6 0 0c-3,-2 -2,-1 -3,-4 -1,-2 0,-1 -2,-3 -3,-1 -3,0 -5,0 -9,-2 -2,-1 -5,-6l-6 5c-4,15 4,23 -7,38l-4 2c-2,-4 0,-4 0,-10l-1 -6 -8 -2c1,8 3,11 1,18 -1,6 -4,9 -5,12 1,5 4,-1 1,5 1,1 -1,2 2,1l5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil128",
    d: "M306 1120c-4,-2 -6,-5 -3,-10l5 5 -2 5zm5 21l-2 0c-1,-5 -2,-4 1,-7 3,6 -1,7 6,5 0,0 6,-7 -1,-4 7,-1 1,0 3,-2 1,-1 1,-4 0,-1l5 0c-6,-12 -15,-10 -15,-29l0 -3 2 0c-3,-5 -2,-4 -4,-8 0,1 0,1 0,1 0,0 0,1 0,1 -1,4 0,-2 -1,2 0,2 0,1 0,3 -2,-2 -2,-2 -3,-5 -3,4 -2,18 -2,24 0,8 0,14 -1,23l4 -1 2 5 1 0 3 0 1 2c2,-3 2,3 1,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil128",
    d: "M345 1118l1 -5c-5,-2 -12,-1 -22,-8 -9,-7 -8,-12 -13,-18 0,2 1,5 1,7 0,9 1,4 -2,6 3,2 2,2 3,5 3,4 5,4 9,9 2,3 6,9 8,11l7 3 0 -8 3 -2 5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil128",
    d: "M249 1122l2 -2c1,-3 -1,-1 4,-5 -3,-1 -2,0 -3,-1l-3 -2c-5,0 -7,1 -11,2 -2,0 -10,1 -12,1l0 0c0,0 0,2 2,5 1,0 1,0 1,-1l3 -2 9 1c0,2 1,3 0,7 -6,3 -4,1 -8,2 0,6 1,1 -2,2l-4 -5c-4,-4 -3,-3 -5,-4 -1,2 2,1 -3,2l-4 2c4,1 3,1 4,4 3,-1 2,-4 6,1 2,3 -2,1 4,4l2 1c3,-3 2,-1 6,-3 1,0 3,-2 4,-3 5,-3 5,-2 8,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil128",
    d: "M271 1119l-3 -1c3,-4 3,0 8,-4 -6,-2 -3,-1 -4,-4 1,0 2,-1 3,-2 5,-3 5,0 6,-1l-1 10 0 5 4 -1c0,-6 3,-15 5,-19 -6,-4 2,-1 -2,-5 -4,3 -5,3 -10,6 -5,1 -8,2 -12,4 -1,5 -1,4 0,9l-1 3 1 5 3 0 4 1c-2,-5 0,-1 -1,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil128",
    d: "M99 453c6,3 3,-3 5,2 0,1 1,0 1,1l-3 6c-4,0 -8,-8 -8,-11 3,1 3,1 5,2zm7 -1c0,-4 -1,-8 -4,-10 -1,1 -1,2 -2,3l-1 1c-1,1 -1,1 -1,1l-4 0 -2 -4c-1,2 -3,5 -3,7 0,0 8,14 8,14l8 2 1 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil128",
    d: "M141 499l-8 -1 -2 -3c2,-2 5,-6 7,-8l2 -2 -2 0 -14 8c0,6 -1,0 -4,6 11,-1 15,6 25,6l4 -7c-1,1 -5,3 -8,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil128",
    d: "M209 345c2,-7 5,-6 3,-12 -2,4 -6,5 -10,7 -1,2 -3,3 -6,4l0 1c1,4 2,2 -1,6 4,-1 0,0 3,-2 2,-1 2,-1 4,-2 2,-1 4,-2 7,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil129",
    d: "M235 725c1,-6 -2,-4 2,-9 -3,-1 -3,1 -5,-1 3,-14 2,0 7,-10 -1,-3 2,-7 3,-10 3,-7 -1,-4 5,-8 -1,7 -4,2 -1,7 1,3 -1,3 6,2 1,0 1,0 1,0l-2 10c-1,12 1,15 -3,24 -2,5 -1,-5 0,2l1 4c-2,5 -1,2 -4,3 0,0 0,0 0,-1l0 -2c0,-1 1,-4 1,-4 -6,2 -1,-1 -6,4 1,-4 1,-2 2,-5 0,-3 0,-2 0,-3 0,0 0,0 0,0 0,0 0,0 0,0 0,-1 0,-1 0,-1l-1 -4c-2,2 0,1 -1,0 3,-2 2,-5 1,-8 -6,2 -2,-1 -4,5 -2,5 1,2 -2,5zm16 8c2,-7 4,-35 3,-42l-1 -2 -4 -1c0,0 0,-1 0,-1l-8 -11 -3 4 1 -9c-1,2 -2,3 -3,4 -3,5 -2,3 -2,6 -1,4 1,2 -4,3l1 4c1,3 2,0 -1,4l1 0c2,10 -1,14 -1,23 1,11 -2,13 2,18l3 -8c2,4 1,5 0,10 4,1 2,-1 2,3 2,-4 -1,-2 -4,-2 0,3 0,7 2,10 2,-2 1,-3 2,-4l2 3c1,1 1,0 2,0 -1,3 -2,2 -1,5 0,2 -2,2 -3,2 0,0 0,0 0,0l2 6c0,1 0,1 0,1l5 -7c0,7 0,6 1,13 -1,0 -1,0 -1,0 0,0 -1,1 -1,1 0,0 0,0 0,0 -2,2 0,0 -1,2 5,3 -1,5 4,7 5,-12 -2,-31 5,-42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil129",
    d: "M253 123c1,-7 3,-6 3,-10l0 1c-5,-4 -2,-11 -10,-8 -4,1 2,1 -2,1 -3,0 -1,0 -3,-3 -1,4 0,4 -2,4l0 -2c-2,1 -2,-1 -1,1 -1,-6 -7,-15 -4,-25 1,-1 1,-1 1,-1 0,-1 0,-1 0,-1l1 7c1,6 -1,4 4,8l-2 -18c5,1 3,-2 4,4l-1 -7c-3,1 -1,2 -3,2 -3,0 -1,0 -3,-1 -8,-1 -4,-2 -6,-2 -2,6 -1,-2 -5,9 0,0 1,1 1,1 0,0 0,1 1,1 0,0 0,1 1,1 1,9 7,26 11,32 7,3 2,3 7,8 2,-3 1,-5 0,-9 4,2 2,6 6,10 2,-3 2,1 1,-6l1 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil129",
    d: "M199 92l2 0c1,-4 2,-4 2,-4 1,-1 0,0 0,0l0 1c3,-2 3,-2 5,-5l-14 -1 -4 0 -3 6 3 0 -3 1 -1 4c4,-1 2,1 7,-1 5,-1 0,-2 6,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil129",
    d: "M211 129c11,-3 7,-3 8,-8 -4,1 -5,0 -7,3l-1 2c0,0 0,1 0,1l0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil129",
    d: "M74 289l-2 1 0 3c4,0 4,-1 6,1l2 -4c-4,-3 -1,-2 -6,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil130",
    d: "M226 952l-8 -3c0,-8 0,-16 -8,-20 5,6 6,7 7,15 0,0 -1,0 -1,-1l-5 -5c-3,-3 -1,-3 -3,-6 -2,-2 -28,-8 -29,0 0,4 3,4 5,4 6,-1 1,-3 7,0l-3 6c-4,-2 0,-2 -3,-1 -3,0 -1,1 -5,1 -8,1 -6,-2 -8,-4 -8,3 -18,-3 -18,1 1,2 4,3 6,5 2,2 2,4 3,5l5 -1 2 5 3 -1c3,-2 4,-2 7,0 4,1 -2,0 5,1 5,1 8,0 12,-1l6 -1 0 -5c3,-1 5,2 7,3 -3,4 -9,7 -13,9 -5,2 -3,-1 -5,3 5,1 2,0 6,-1l1 0c5,0 4,-1 6,1l12 -14 -1 7c5,0 7,1 8,5l5 4 -1 6c5,-6 -1,-10 -4,-14 1,-2 -1,0 2,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil130",
    d: "M308 361l-1 0c-5,-1 -8,-4 -12,-1 0,3 1,3 5,6 -2,1 -4,3 -6,5 -3,-1 -2,-4 -4,-2 -6,6 7,5 9,5 1,0 5,1 5,1 4,1 4,2 5,3 3,3 2,1 3,7l-10 3c-5,3 -4,0 -9,1 -1,4 8,1 13,4 2,-2 6,-5 8,-7 6,-6 5,-10 3,-18 -4,-10 -5,-1 -9,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil130",
    d: "M284 377c-1,-6 -1,-1 2,-7l-7 -4c0,0 1,-1 1,-3l-7 -2c-2,0 -6,0 -9,0 2,5 3,3 4,11 1,5 3,4 4,10l5 0 2 -1c-2,-7 -1,0 -3,-4 4,-2 4,-1 8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M307 93c4,-5 -1,-1 2,-1l4 3c1,-4 2,-3 1,-5 1,2 0,4 -1,6 -2,5 4,-3 -1,1 -2,1 0,0 -3,3l-2 -5 -3 6c-1,-3 -1,0 0,-5 1,-4 -1,-3 3,-3zm15 16c-5,0 -3,1 -7,-1 2,-4 -1,-1 3,-2 0,-1 2,0 2,0 -3,-3 -3,-1 -3,-5 3,-1 1,-2 4,0 1,1 0,1 1,2 4,6 3,0 3,5 -4,3 0,-2 -3,1zm40 24c4,-2 7,-6 7,-11 -3,-7 -33,-22 -41,-26 -12,-6 -8,-8 -24,-10 -10,-1 -21,-3 -31,-4 1,6 1,2 2,6 0,2 0,2 0,4l1 -5c0,0 0,-1 0,-1 0,0 0,-1 0,-1 1,0 2,0 2,0 4,0 -1,1 2,0 2,5 -2,-1 0,5 7,-2 5,4 7,-2l1 6c0,-8 0,-8 6,-6l4 1c0,0 0,0 0,0l3 -1c3,13 -2,4 1,19l2 -5 2 2c0,1 0,1 0,1l1 3c4,3 4,1 4,1l0 4c0,-1 1,-2 -1,-2 -4,-1 1,-3 -3,1 7,3 -1,-2 3,3l2 2c5,-6 3,-3 9,-6 0,6 1,4 -2,8 4,1 4,1 6,4 -10,2 -5,-4 -8,3 4,-4 1,-1 5,-2 3,2 3,3 2,7l0 -6c1,1 2,2 3,3 0,-6 -2,-8 -4,-10 -3,-4 -1,1 -2,-4 4,-3 -4,0 2,0 4,0 -2,3 2,0 -2,-4 -3,0 -3,-5l5 2c0,-1 -1,-3 5,-2l1 -6c6,10 4,9 5,12l3 -8c1,2 0,4 3,8 3,5 0,2 4,-1 1,5 1,3 -1,8 4,-4 1,-4 5,-3 0,4 -2,4 -1,10 -3,1 1,-2 -5,3 -3,3 1,4 -4,4l-2 2c0,1 0,0 1,0l2 0c1,1 0,6 0,8 4,3 6,-4 6,-5l2 4c3,3 0,1 3,5 0,-12 9,-19 3,-15l5 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M139 322l8 -2c0,0 1,1 1,1l2 6c-5,1 0,3 -7,1 -6,-1 -4,1 -4,-4 -2,3 -3,4 -6,2 2,-5 0,1 2,-2 4,-6 -2,-3 3,-7 5,2 0,-4 2,2 0,0 1,0 1,0 0,0 -2,3 -2,3zm5 16c3,-1 2,1 -2,-5 1,-1 0,0 3,-2 0,0 1,0 1,0 2,0 0,0 2,0 5,1 -2,2 2,0 2,-4 10,-7 15,-9l2 -6c-1,0 -1,-1 -1,-1 -26,-1 -17,2 -28,-10l-9 -8c-2,4 2,14 2,20l-13 0 1 4c3,-3 2,-2 4,-1 2,0 3,0 5,1 -2,3 -1,2 -6,2l0 2 8 4 -1 4c3,0 1,-1 3,1l0 7c5,-3 7,-5 12,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M310 747c3,4 1,-2 1,2 -2,1 -7,1 -10,-3 3,-2 3,-1 6,0 -3,-4 -3,-4 1,-6 2,3 1,5 1,5 0,0 0,1 0,1l1 1zm-1 26c1,-3 2,-5 4,-9 1,4 -3,3 -6,3 2,-5 1,-2 4,-7l-3 -1c-4,-2 0,2 -2,-2 3,-3 0,-3 6,-4 3,-1 3,1 4,-2 0,0 2,-7 1,-9 -2,-8 -12,-18 -20,-21l-1 3c4,2 2,-1 1,4 6,0 5,0 5,1 1,0 1,0 1,1l1 2c0,0 1,2 1,2 -7,3 -2,-4 -5,4 -2,-4 -3,-4 -2,-6 -4,3 1,5 -2,13 0,-1 0,-3 -4,-2l-3 5c6,4 3,3 6,5 5,-1 1,-5 9,-1l-4 5c1,3 0,2 3,4 -4,1 -1,0 -2,2 2,4 0,2 -1,7 3,1 4,1 5,1 3,2 1,1 3,3l1 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M202 263c12,0 57,-29 64,-39 -7,3 -7,3 -12,8l0 -5c-6,3 -20,14 -30,18 -6,2 -29,12 -32,15l-2 5c3,0 4,0 5,1 0,0 0,0 1,0l3 -5 3 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M178 839l2 -5c-5,1 -1,1 -5,-1 -6,-2 -28,0 -36,0 -9,0 -29,-4 -32,6 10,4 59,2 71,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M323 604c2,-10 3,-12 4,-22l27 -2c6,0 5,-2 9,2 0,-6 0,-1 1,-3 2,-3 0,3 2,-3l-3 -1 -14 -2c-6,1 -10,1 -15,2 -3,-4 0,-3 -4,-4 0,0 -1,0 -1,-1l-3 -1c-1,0 -4,-1 -5,-1 2,3 3,6 2,9l6 2c-1,1 -1,1 -4,2 0,21 -9,25 -5,49 3,-2 2,-3 1,-7 0,-2 0,-4 0,-6 0,-5 1,-9 2,-13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M131 1153c0,-1 1,-2 -6,-1l-24 3 -6 1c2,2 1,-1 1,4l0 1c5,-2 10,-1 16,-1 4,0 9,-1 13,-2l2 3c1,2 0,2 1,1l8 2c1,-11 -6,-8 -5,-11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M199 92c-6,-1 -1,0 -6,1 -5,2 -3,0 -7,1l1 -4 -23 11c-1,7 -1,0 -3,7l2 1c6,0 12,-5 18,-8l18 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M215 667c-2,-7 -16,-21 -21,-23l-3 0c0,3 1,2 3,5l9 10 -9 -3 0 4c-7,-1 -3,-1 -5,1l11 5 -3 -5c6,-3 6,0 11,7 1,-1 1,-1 1,-1 3,-3 2,-2 6,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M187 89l3 -6c-9,1 -26,2 -34,5l-1 3 1 3c5,-1 11,-3 15,-4 5,0 12,1 16,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M202 675c-3,-3 -29,-11 -35,-10 -5,0 -3,-1 -4,1 0,2 -2,0 3,3 0,0 1,0 1,1 5,1 8,1 14,3 4,1 9,4 13,3 3,-1 1,-1 4,-1 0,0 3,0 4,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M170 226l-6 1 -1 2 -6 -1c0,6 -1,4 3,6l6 0c2,-3 0,-1 2,-2 2,-1 0,1 2,-1 2,-3 1,-3 0,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M75 321l3 -7 2 -10 -3 -2 -2 6c-1,8 -3,5 -5,14 5,-1 2,0 5,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M225 222c1,-3 0,-3 1,-4 -2,-2 2,-2 -4,-1 0,1 0,1 0,1l-16 9 19 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M126 825l1 0c9,-2 10,2 16,-1 -2,-2 0,-1 -3,-2l-15 0 1 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil132",
    d: "M215 820c6,-3 4,1 7,-5 3,-6 -2,-3 7,-2 -2,-8 -3,-6 1,-18 2,3 0,0 1,3 0,1 0,2 0,2 2,4 -1,-3 1,2 -5,1 2,-3 3,-2l-3 7c5,-2 1,-1 5,-5 2,-4 2,-2 4,-6l6 -14c-7,3 -2,0 -5,7 -1,-4 -3,-3 -3,-8l0 -3c0,-7 -1,-4 2,-6 3,3 1,8 0,12 9,-3 4,-3 6,-9 1,-5 -1,-1 3,-5l1 -18 0 -19c-7,11 0,30 -5,42 -5,-2 1,-4 -4,-7 1,-2 -1,0 1,-2 0,0 0,0 0,0 0,0 1,-1 1,-1 0,0 0,0 1,0 -1,-7 -1,-6 -1,-13l-5 7c0,0 0,0 0,-1l-2 -6c0,0 0,0 0,0 1,0 3,0 3,-2 -1,-3 0,-2 1,-5 -1,0 -1,1 -2,0l-2 -3c-1,1 0,2 -2,4 -2,-3 -2,-7 -2,-10 3,0 6,-2 4,2 0,-4 2,-2 -2,-3 1,-5 2,-6 0,-10l-3 8c-4,-5 -1,-7 -2,-18 0,-9 3,-13 1,-23l-2 2 -3 41c0,7 -2,12 -1,18 2,8 0,18 -1,26 5,-2 2,1 5,-4l-1 6c2,-1 3,1 2,-3 1,5 -1,3 -2,10l3 -1c-3,7 3,-1 -3,10 -5,7 -1,2 -7,8l-4 -2 -10 -2 -4 -1 -3 -1 -34 -8 -5 -1 -3 0c-3,1 -3,1 -3,4l57 13 -22 1 -5 2c2,3 0,1 4,2 3,0 9,-1 16,1l10 1 0 2 -34 4c-3,2 -5,2 -10,2 -3,0 -6,0 -9,0 -6,0 -16,-1 -19,2 5,4 19,-1 31,2l41 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil132",
    d: "M272 154c0,0 -3,-2 -3,-2 4,-7 -3,-8 -3,-8 -5,0 2,-1 -3,1l-7 -13c0,0 -1,-4 -1,-4 -1,3 -1,9 1,13 0,1 2,2 0,7 0,-4 -2,-9 -4,-12l-1 -1c0,-1 -2,-3 -2,-3l-1 6c0,-3 0,-3 1,-5 0,0 0,-1 0,-1l0 -1c0,0 1,-2 1,-3 -5,-2 -3,0 -4,3 -1,-6 -2,-4 6,-5l1 -3 -1 -3c1,7 1,3 -1,6 -4,-4 -2,-8 -6,-10 1,4 2,6 0,9 -5,-5 0,-5 -7,-8l3 13 5 15 7 15c6,4 2,5 6,10l1 -6c1,1 1,3 2,4l2 2c0,0 0,0 0,0 0,0 0,1 0,1l1 1c2,4 2,3 4,6 3,6 -2,3 0,11 3,-3 1,-5 3,-7l2 5c2,-6 3,-3 3,-3l0 9c5,-2 1,-3 2,-8 1,-3 3,-4 1,-6 -2,-3 1,-1 -2,-1l-2 1c4,-12 -2,-9 -3,-13 -4,-9 -4,-9 -1,-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil132",
    d: "M266 224l4 -4c2,-4 3,-7 4,-10 2,-5 0,-7 2,-13 0,0 -1,0 -1,0 -2,-7 1,3 -3,-2 -2,-3 -1,-4 -1,-7 -3,3 -1,-2 -3,4 -2,6 0,2 0,4 2,3 2,3 1,6l-3 -7 -3 1 -13 2 -4 0c-1,1 1,0 -2,1 0,0 -2,1 -2,1 -2,0 -4,1 -6,1 -8,2 -25,5 -32,5l-1 1c-4,2 -1,0 -3,3 1,1 -1,1 3,2l56 -10 -22 9 -2 6c6,-1 10,-5 16,-6l12 -5c0,7 -16,11 -20,16 -1,2 -3,3 -3,5l7 -2c8,-1 18,-15 23,-15l-2 5c3,1 1,0 3,2l-6 5c-1,-1 -3,3 -1,-2l-10 7 0 5c5,-5 5,-5 12,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil132",
    d: "M279 751c4,-4 1,-3 7,-6l3 3 3 -5c4,-1 4,1 4,2 3,-8 -2,-10 2,-13 -1,2 0,2 2,6 3,-8 -2,-1 5,-4 0,0 -1,-2 -1,-2l-1 -2c0,-1 0,-1 -1,-1 0,-1 1,-1 -5,-1 1,-5 3,-2 -1,-4l1 -3c-2,-3 -9,-6 -13,-8 -5,-3 -10,-8 -15,-8l-2 7c-1,5 -2,12 0,16 2,-4 3,-2 3,-7 1,-3 -2,-3 2,-8 4,0 1,0 4,2l4 3 0 0c3,2 3,1 7,0l-1 6c6,-6 1,4 7,-2l0 5c2,-2 0,-2 2,-1 3,0 -2,3 -2,3 -4,4 2,5 -3,4 -6,6 0,0 -6,-1 -1,8 4,5 -5,12 1,-2 2,-2 0,-6l-5 7c-1,2 -3,7 -4,10l4 2 3 -2 0 -3 2 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil132",
    d: "M335 139l3 2c2,-5 1,-2 1,-6 0,-3 -3,-1 2,-5l1 6c5,0 1,-1 4,-4 0,0 -4,0 -1,-3 1,-1 4,-2 4,-2 -4,-6 1,-5 -6,-3l2 -7c-3,2 -2,2 -3,5l-1 -4c-3,6 -4,-1 -4,8l-2 -2c0,0 0,0 0,0 -3,-3 2,-1 -2,-1 0,-1 -1,0 -1,0l-3 0c1,-3 2,-6 2,-11 -2,4 0,4 -5,6l1 -7 -5 -2c0,5 1,1 3,5 -4,3 2,0 -2,0 -6,0 2,-3 -2,0 1,5 -1,0 2,4 2,2 4,4 4,10l4 -2c3,2 0,1 0,3l3 5c-3,2 -6,3 -10,3l0 -6c1,-4 1,-5 -2,-7 -1,4 -2,15 -2,19 6,-2 9,-4 15,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil132",
    d: "M324 792l0 0c2,-4 0,-1 4,-4 4,-5 1,-3 1,-4 0,-1 -2,3 1,-4 1,-4 1,-1 2,-6 -6,1 -5,1 -5,7l-1 -2c-2,0 -5,1 -9,0 1,-2 3,-3 4,-7l-4 -4c0,0 0,0 0,0 -2,-3 -2,1 -2,1 0,0 0,0 -1,1 0,0 0,0 0,0 -5,3 -3,-1 -5,3l-1 1 -1 3 -10 -1 3 -6c1,-5 3,-3 1,-7l-1 -1c-1,8 -2,2 -4,10l-3 6 4 2c1,0 1,0 1,0l8 1c2,3 1,2 5,2l1 -4c1,-2 -2,-1 2,-3 1,1 3,-3 1,5 -1,0 -2,1 -2,2l3 6 5 -4c0,2 0,3 0,8 1,-1 2,0 3,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil132",
    d: "M212 724c2,-7 -2,-9 -9,-9l-6 1 -1 3c0,4 2,4 5,8l5 -1 6 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil132",
    d: "M239 172c-7,0 -19,-3 -14,9l1 1c9,0 13,-1 13,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil132",
    d: "M190 775l2 2 10 2 4 -5c-2,-4 -5,-5 -9,-6 -6,0 -6,2 -7,7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil132",
    d: "M194 656l1 -3c-6,5 -4,0 -5,0 -2,-2 -7,-4 -10,-4 -4,0 -3,0 -5,2 5,3 4,-1 8,6l6 4c2,-2 -2,-2 5,-1l0 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil132",
    d: "M331 154c0,4 -1,3 -2,8l4 -1 -1 3c0,0 0,0 0,0 3,-3 2,-1 2,-5 2,4 2,3 3,4 1,-8 0,-3 4,-8l-2 -6c-1,2 0,1 -1,2l-1 1c-6,2 1,2 -5,8 1,-7 1,-5 -1,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil132",
    d: "M185 232l2 0c5,-5 4,-1 5,-7l-7 1 0 6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil133",
    d: "M309 378c-1,-1 -1,-2 -5,-3 0,0 -4,-1 -5,-1 -2,0 -15,1 -9,-5 2,-2 1,1 4,2 2,-2 4,-4 6,-5 -4,-3 -5,-3 -5,-6 4,-3 7,0 12,1 -1,-3 -4,-3 -8,-4 -4,0 -10,-1 -12,-4 -12,0 -45,-1 -52,7 7,0 11,-4 18,-5l1 4c6,-6 4,-1 10,2 3,0 7,0 9,0l7 2c0,2 -1,3 -1,3l7 4c-3,6 -3,1 -2,7l1 3c4,0 6,3 10,3 1,0 10,-1 12,-1l-1 -3 3 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil134",
    d: "M173 740c-2,-2 -3,3 -1,-4 0,1 -1,2 -1,1 -1,0 -1,1 -2,2 -5,2 -2,-1 -5,8 0,1 0,1 0,1l-1 3 0 1c-1,2 -1,2 -2,4 0,0 -1,1 -1,2 -2,3 1,0 -2,3 -2,-4 0,0 -4,-3 -2,-3 -1,-3 -1,-4 -4,2 -3,1 -5,3 -2,-10 1,4 -6,-5l-1 0c-1,-2 -2,-3 2,-9 2,1 1,3 4,0 -1,-4 -3,-5 -6,-6l1 -4 0 -1c-9,4 3,9 -8,13 1,6 2,13 6,17l0 1c0,-5 -1,-2 2,-5 3,3 2,1 2,5 3,-2 3,-2 5,-4 1,4 2,5 6,4l3 -1c4,0 2,2 6,0 2,-1 0,-2 3,-3 8,-6 2,-4 2,-12 0,0 0,-1 0,-1 1,-3 1,-4 4,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil135",
    d: "M164 964l2 -2c5,3 3,3 7,2 1,-1 5,-1 5,-6l-6 0c-5,0 -1,1 -5,-3 -4,-3 -3,-1 -4,-6 -1,-1 -1,-3 -3,-5 -2,-2 -5,-3 -6,-5 -5,-2 -3,-2 -7,0l0 4c0,3 -1,3 2,5 4,1 3,1 5,-2l3 5c-3,0 -2,0 -4,-1 0,0 0,0 0,0 0,0 -1,-1 -1,-1 0,1 0,1 0,1 -1,11 -1,-1 6,10l5 -3c-3,6 -1,1 -4,4 2,5 1,3 3,5l2 0 0 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil136",
    d: "M251 706l2 -6c-7,4 -3,2 -8,7 -4,5 1,4 -4,4 -2,-2 -2,-3 -2,-6 -5,10 -4,-4 -7,10 2,2 2,0 5,1 -4,5 -1,3 -2,9 3,-3 0,0 2,-5 2,-6 -2,-3 4,-5 1,3 2,6 -1,8 1,1 -1,2 1,0l1 4c0,0 0,0 0,1 0,0 0,0 0,0 0,0 0,0 0,0 0,1 0,0 0,3 -1,3 -1,1 -2,5 5,-5 0,-2 6,-4 0,0 -1,3 -1,4l0 2c0,1 0,1 0,1 3,-1 2,2 4,-3l-1 -4c-1,-7 -2,3 0,-2 4,-9 2,-12 3,-24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil137",
    d: "M181 820c-12,0 -23,1 -35,0 -9,-1 -24,-3 -31,-3 -3,2 -4,3 -4,6 2,2 10,3 15,2l-1 -3 15 0c3,1 1,0 3,2 -6,3 -7,-1 -16,1 4,3 44,4 47,1 -12,-3 -26,2 -31,-2 3,-3 13,-2 19,-2 3,0 6,0 9,0 5,0 7,0 10,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil138",
    d: "M199 913c1,-5 -2,-3 -7,-5 -3,-2 -4,-3 -8,-4 -1,3 -1,1 1,4 1,2 1,2 2,4 0,0 -3,0 -3,0 -5,0 -4,-1 -8,2 -5,-1 -1,0 -3,-2l-1 0 0 6c-5,4 -3,-1 -4,3 4,3 1,0 2,1 1,0 0,0 1,0 0,1 -2,0 1,2 0,-6 -1,-3 2,-5 4,-2 9,3 13,4 -4,0 -8,0 -11,1l18 0 -2 -2c0,0 0,-2 0,-2 0,0 0,0 0,0 6,-1 8,2 7,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil139",
    d: "M185 971l0 -1 1 -4 4 -1 -1 -1c-1,-5 -7,-5 -11,-6 0,5 -4,5 -5,6 -4,1 -2,1 -7,-2l-2 2 6 3c-2,3 -1,1 -4,3 -4,2 -1,2 -5,1l0 1 2 4c3,-3 1,-3 6,-5 5,2 2,4 7,4 1,-1 7,-3 9,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil140",
    d: "M253 442c2,-1 3,-1 6,-2l-1 -2c-6,-3 -11,3 -28,-2 -1,0 -2,-1 -4,-1 -4,-3 -1,0 -3,-3l7 -1c0,-4 1,-2 -1,-2 -5,2 -16,-3 -21,-4l1 3 -3 -1c2,4 10,5 16,7 -4,6 -4,2 -5,5 1,2 3,4 6,4l7 1c-2,-6 -1,-2 -6,-5 1,-1 0,-3 7,-1 10,3 8,1 16,2 6,0 4,0 6,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil141",
    d: "M238 117c-4,-6 -10,-23 -11,-32 -3,2 -1,0 -4,4l0 1 3 0c-3,5 -2,0 -2,6 2,2 2,1 2,5 0,4 3,5 3,11 1,5 1,7 3,11l1 0c2,3 2,3 4,4 2,2 0,1 4,3l-3 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil142",
    d: "M239 106l0 2c2,0 1,0 2,-4 2,3 0,3 3,3 4,0 -2,0 2,-1 8,-3 5,4 10,8 0,-11 -1,-17 -4,-27l-2 2c0,1 0,1 0,1 0,0 -1,3 -1,3 -2,6 -2,2 -1,9 -4,-3 -1,-3 -5,1l-1 -6c0,0 0,1 0,1 0,-1 0,2 -4,5 0,0 0,0 -1,0 1,1 1,2 2,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil143",
    d: "M187 708c1,-4 2,-4 1,-9l-6 -4c-6,1 -9,-1 -13,4l2 4c0,-1 -1,-4 7,-3 2,1 2,1 3,2l-4 5c2,-2 -4,0 1,-1 2,0 5,-1 5,5l4 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil144",
    d: "M298 508c-5,-1 -1,0 -3,-2l0 1 -12 -1c-1,8 0,0 1,5 1,2 1,-2 1,2l-1 1 2 3c2,-3 1,-2 1,-4l12 0c1,0 1,-1 1,-1 0,-2 0,-2 -2,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil145",
    d: "M147 772l-7 -9 0 -1c0,2 2,7 3,9 1,2 3,5 5,7 5,5 8,7 13,12l5 1c-2,-5 -1,-3 -3,-4l-12 -11c-2,-1 -3,-2 -4,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil146",
    d: "M168 708c-1,-5 -1,-7 1,-12l-5 0 -1 4 -2 1 -1 1 2 2c0,6 -1,0 -1,4 1,2 1,0 2,4 3,1 3,1 4,4 0,-1 1,-2 1,-3 0,0 -5,-3 0,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil147",
    d: "M261 431c-4,0 -9,1 -13,0 -5,-1 -6,-2 -9,-6l-3 1 -1 -1 -1 7c5,2 9,1 14,1 6,0 9,1 13,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil148",
    d: "M344 403l-1 4c0,0 1,2 0,0 -1,-2 0,-1 0,-1 -1,9 2,9 -5,18 -4,4 -3,1 -5,6l3 -1c4,-2 6,-6 8,-10 2,-4 4,-14 0,-16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil149",
    d: "M197 1024c-5,0 -12,3 -17,5l-2 0c-1,2 -2,0 -6,3 7,-1 4,1 13,-2 3,-1 5,-2 7,-3 3,-1 3,-1 5,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil150",
    d: "M191 129l0 -1 2 -3c-15,5 -7,4 -17,-2l-3 -1c2,4 2,6 7,7 6,1 7,2 11,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil151",
    d: "M222 181c-2,-2 -2,5 -2,-1 -5,12 -1,2 -3,15 4,-3 2,-3 4,-5 0,0 0,0 0,0 4,-5 3,2 3,-6 1,1 1,1 1,1l1 1c-3,-4 -1,3 -4,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil152",
    d: "M157 744l-3 -1 -1 3c1,2 0,0 1,2 1,0 2,2 3,2 2,2 3,2 6,2l0 -1c-1,-6 -3,-1 -6,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil153",
    d: "M229 220l2 0 3 -3c1,-2 0,-1 1,-3 -1,0 -1,0 -2,0 -1,0 -2,1 -3,1 -5,2 -5,4 -1,5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil154",
    d: "M166 315c0,0 0,1 1,1l-2 6c5,-2 9,-3 6,-7l-5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil155",
    d: "M88 374l-3 2 -2 -4 0 10c5,-2 5,-3 5,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil156",
    d: "M314 431c-1,2 -1,3 -3,5l-3 -1c0,2 -2,2 -1,7l2 -3c3,1 1,1 4,-1l1 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil157",
    d: "M169 121l-1 -2c-3,1 -3,1 -3,4 3,3 -1,2 3,3 1,-2 2,-3 1,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil158",
    d: "M115 817c-3,-1 -1,-1 -5,-1 -3,3 -2,5 1,7 0,-3 1,-4 4,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil159",
    d: "M291 874c-2,-2 -3,-2 -6,-1 1,5 0,2 3,3l3 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil160",
    d: "M251 1232l-2 -3 -2 1c-1,2 0,-2 0,1 0,2 0,2 0,3 4,0 2,0 4,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil161",
    d: "M330 408c1,-4 1,-1 -2,-2l-1 0 0 1 -1 4 3 -1 1 -2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil162",
    points: "334,388 332,385 329,389 329,389 331,389 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil163",
    points: "164,696 159,699 161,699 161,701 163,700 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil164",
    d: "M337 391c-2,-3 -1,-2 -3,-3l-3 1c4,3 3,3 6,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil165",
    d: "M188 697c-5,-3 0,-2 -6,-2l6 4 0 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil166",
    d: "M333 907c-4,-1 -1,-1 -2,1l1 2c3,-1 2,-1 1,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil167",
    d: "M85 294c-6,-3 -4,0 -4,0l3 2c-1,-2 2,-1 -1,-2l2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil168",
    d: "M139 545c2,3 0,2 2,3 2,2 -1,0 3,1 -3,-3 -1,-2 -5,-4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_739394144"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M328 1568l-2 -1c-2,2 -1,0 -1,3l4 3c-2,-3 -1,-1 -1,-5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "113,1785 109,1786 112,1787 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M271 1549c-3,3 -2,-1 -2,4 3,2 1,1 6,1 -2,-3 -2,-2 -4,-5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "208,1639 205,1639 206,1641 209,1642 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M280 1706l-3 -5c-3,3 -1,4 -1,9 3,-4 0,-4 4,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M65 1309c-3,4 -2,6 -6,4l1 4c5,0 4,-3 5,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "M303 1660c-4,2 -4,3 -8,2l0 2 2 2c1,0 3,-2 4,-2 4,-3 1,-1 2,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M314 1645l0 -1c-4,1 -2,0 -3,0 -7,-2 4,-1 -2,-1l-2 2c2,5 1,0 4,5 2,-2 2,-3 3,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil6",
    d: "M110 1694c-4,-2 -2,-3 -4,-8 0,6 -2,6 0,10l4 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil6",
    d: "M167 1771c0,5 1,3 -1,6l3 2 0 -6 -2 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil7",
    d: "M282 1666l-24 1c3,5 6,2 11,2 5,-1 9,0 13,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil9",
    d: "M244 1638l0 -3 -3 -2c-2,-1 -2,-1 -4,-2 -1,3 0,2 -3,2l2 5 0 2 3 -1 5 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil10",
    d: "M292 1393l0 -5 -4 2c-1,1 -1,0 -2,2l-1 9 4 0 3 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil10",
    d: "M261 1293c-1,0 -2,0 -2,1 0,0 0,1 0,1l1 2c5,1 3,0 7,2 -1,-5 -1,-6 -6,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil11",
    d: "M285 1558l-2 0c-3,1 -2,-1 -3,2l4 0c-1,4 -1,1 0,4l7 1 6 0 -9 -7c-1,1 0,0 -3,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil11",
    d: "M303 1546l-1 -3c-5,0 -7,-1 -9,2l-3 4 7 2c0,-5 1,-6 7,-4l-1 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil12",
    d: "M173 1689l0 4c0,0 -2,1 -2,1l-7 7c1,5 -1,0 -4,7 13,-7 7,-6 15,-14 2,-1 1,0 2,-1 -3,-4 -1,-2 -4,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil13",
    d: "M212 1411c-6,1 -7,1 -12,-1l-3 -8 -1 -1 -1 1 1 5c1,3 5,6 6,7 5,1 7,0 10,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil14",
    d: "M181 1381c-6,-15 0,-7 3,-16 -2,-3 0,-1 -4,-2l0 0c-1,2 -12,13 -3,19l1 -2 3 1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil14",
    points: "322,1796 320,1797 317,1794 317,1801 319,1802 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil15",
    d: "M230 1544l-3 0c-6,0 -10,-3 -15,-1l0 5 0 -1c2,6 -1,5 -3,12l2 -1c2,-2 1,-2 3,-5 6,-10 10,-5 16,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil15",
    d: "M232 1543c3,-3 3,-2 6,-3l4 -2c-9,1 -13,-4 -12,6l2 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil15",
    d: "M260 1607c-4,-3 -3,-3 -7,-2l0 3 0 0c1,2 0,1 2,2 3,-1 3,-1 6,1l1 -1 -2 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil15",
    d: "M235 1555l-4 2c-2,6 0,4 -8,7l0 2c4,0 5,0 7,-4 2,-2 4,-5 5,-7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil15",
    points: "213,1571 210,1570 210,1575 211,1575 214,1576 217,1574 213,1573 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil15",
    d: "M260 1565l-4 1c0,0 -3,3 4,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil16",
    d: "M212 1582c-3,-1 -3,0 2,-3 5,-3 3,1 5,-4l0 -1 -2 0 -3 2 -3 -1 2 3c-4,1 -8,4 -11,6 -2,3 -3,3 -6,4l0 1c1,3 -1,2 3,2l3 -1c2,-2 9,-7 10,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil16",
    d: "M319 1601l0 -3c-2,2 -1,2 -2,3 -4,5 -7,2 -12,9l5 0c4,-3 5,-4 9,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil17",
    d: "M256 1291c-4,-2 -3,-2 -7,-1l2 3 6 2 -1 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil18",
    d: "M280 1560c1,-3 0,-1 3,-2 -2,-2 1,-1 -3,-2 -3,-1 -2,0 -3,0l-1 -9 6 0c-1,-2 -4,-5 -7,-6l-3 3c1,5 1,2 -1,5 2,3 2,2 4,5l0 5 0 2 5 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil19",
    d: "M69 1472l-4 -2 2 4c-10,0 1,2 -7,2l-8 0c1,-3 2,-7 2,-11l-3 -1 -2 10c3,3 1,2 6,4 3,1 6,2 8,3 1,-1 4,0 5,-1 0,0 0,0 1,0 0,0 0,0 0,0l2 -1c-2,-2 -6,-1 -8,-2l1 -1c3,-2 3,0 5,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil19",
    d: "M70 1443l1 0 -6 1c-1,1 -1,3 -2,5 -1,4 -1,5 -2,8l4 -1c1,4 -1,2 6,1 -1,5 -2,3 0,6 4,2 7,3 10,-2 -1,0 -1,0 -1,-1 -1,-1 -3,-1 -3,-1 -2,0 1,3 -3,1 -2,-2 -5,-6 -3,-9 0,5 1,3 -1,7 -4,-2 -2,0 -3,-3l-1 -4c0,-4 1,1 -1,-5l5 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil19",
    d: "M76 1568l0 0c1,1 5,3 6,3 6,1 3,-2 3,-3 -2,-1 1,-1 -1,-1l-2 1c-1,0 -2,-6 -7,-5 0,3 0,3 1,5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil20",
    d: "M191 1326c-1,-2 1,0 -1,-2 -6,-1 -7,0 -13,1 -3,3 -2,2 -4,5l-1 5 1 1 3 1 -2 -4c5,-8 9,-8 17,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil20",
    d: "M212 1394c-4,-1 -5,-1 -9,-1 -5,5 -4,1 -7,8l1 1c5,-5 8,-9 15,-6 4,4 2,6 2,11l0 -1c3,-4 2,-9 -2,-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil21",
    d: "M331 1561c0,-7 -2,-6 -5,-8l-2 -2c-3,-2 0,-1 -3,-2l0 0c-1,5 0,1 -2,3l-4 -4c1,5 0,1 2,5 2,3 2,2 2,6l-3 2 1 3c5,-2 2,-4 6,-9 1,11 6,7 8,6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil21",
    d: "M319 1535l-5 -1c-1,1 -1,-2 -1,2l5 1c2,6 2,7 7,10l4 4 2 -8c-5,-2 -1,-2 -8,-4 -1,0 -2,0 -4,-1l0 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil21",
    d: "M329 1624l-3 1 1 -3c-2,2 -4,6 -8,7l-1 2 0 3 10 -7 1 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil21",
    d: "M327 1632l1 3c4,-1 4,-1 1,-5 -4,0 -1,-1 -2,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil22",
    d: "M211 1343l0 -2c0,0 0,-1 0,-1l1 -2c2,-3 3,-2 7,-3 -1,5 3,5 -8,8zm9 0c2,-2 3,-2 4,-7l-1 -3c-4,0 -8,-1 -10,1 -5,2 -4,1 -6,5 0,4 0,4 4,4 2,4 5,2 9,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil22",
    d: "M190 1385l-1 -3 -8 -1 -3 -1 -1 2c1,0 -1,0 2,2 1,1 1,1 3,1 3,1 5,1 8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil23",
    d: "M171 1694c0,0 2,-1 2,-1l0 -4c-3,-3 -7,-3 -10,-1l1 5 0 0 1 3c5,-1 5,-3 6,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil23",
    d: "M102 1765l2 4 -2 3c2,4 4,6 7,9 0,-4 -1,-6 -2,-9 0,-1 -1,-3 -1,-4 -3,-4 -2,-1 -4,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil24",
    d: "M207 1729c-5,-1 -9,-2 -13,-5 3,6 3,4 0,9l12 1 9 0c-2,-3 -1,-1 -4,-4 -3,-1 -2,-1 -4,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil24",
    d: "M160 1708c3,-7 5,-2 4,-7l0 -4 -5 3c1,2 2,0 0,3 -2,2 -2,2 -3,2l0 -3 -3 1c2,5 2,2 1,7l6 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil25",
    d: "M172 1465l-4 2c-1,4 1,4 3,5l1 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil27",
    d: "M170 1729c-5,-3 -2,-3 -4,-7 0,0 8,0 11,0 -7,-6 -11,-1 -19,-1 2,4 3,2 4,1 0,3 0,2 -2,1 -3,3 -2,-1 -1,4 1,2 5,3 8,4 4,2 2,1 5,4 3,2 0,1 4,2 4,0 1,1 3,-1l-1 -2c-1,0 -1,0 -1,0 -3,-3 -4,0 -7,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil28",
    d: "M307 1656c-1,-4 1,-5 1,-7l3 1c-3,-5 -2,0 -4,-5l2 -2c6,0 -5,-1 2,1 1,0 -1,1 3,0 3,-1 1,-3 2,-7 0,0 -2,0 -3,0 -6,2 1,1 -6,5 -1,0 -2,1 -4,1l1 1c0,1 0,1 0,1 0,0 2,1 -1,1 -2,0 1,0 -4,-3 1,8 -1,3 0,7 2,2 3,2 5,5l2 1c-1,3 -1,2 -3,4l2 0 2 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil28",
    d: "M318 1631l1 -2 1 -10 -3 1c2,1 2,1 1,5l-9 2 -1 2 -1 4 -2 1c2,3 -3,2 4,2 4,-3 3,-1 6,-3 4,-2 3,-5 3,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil28",
    d: "M234 1646l1 -6 -3 2 -3 -1 0 2c2,1 1,-2 1,2l2 1c0,0 2,0 2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil29",
    d: "M265 1608c1,-4 -1,0 2,-2 3,-3 0,3 3,-3 -3,-2 -1,-1 -5,-3l-1 2c-8,-1 -4,-3 -4,-10 -4,0 -6,3 -7,2l1 -3c-4,1 -2,0 -4,2 0,7 2,1 2,7 6,2 1,-1 5,3 2,3 1,0 3,4l2 3 3 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil29",
    d: "M242 1548l0 -1 1 -4c-2,-3 -2,-2 -5,-3 -3,1 -3,0 -6,3 1,4 -1,2 3,4l-1 3c4,0 4,0 8,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil30",
    d: "M222 1570c-2,0 -4,0 -7,-1l-2 2 0 2 4 1 2 0 3 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil30",
    d: "M252 1600l1 5c4,-1 3,-1 7,2 -2,-4 -1,-1 -3,-4 -4,-4 1,-1 -5,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil30",
    d: "M244 1539l-2 -1 -4 2c3,1 3,0 5,3l1 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil31",
    d: "M106 1422c1,-6 -2,-9 1,-12l0 -2c-1,3 0,1 -2,3 -1,-3 0,-6 -2,-9 -4,4 -1,8 -3,13l-2 3c0,0 -1,0 -1,0 0,0 0,0 0,0l-2 1c0,0 0,0 0,0 0,1 -1,1 -1,1 0,1 0,1 -1,1 3,3 5,3 7,2 2,5 -2,0 1,5 5,0 5,-4 5,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil31",
    d: "M333 1863c1,2 2,4 3,6 2,4 2,1 3,6l3 3c1,0 1,1 1,1 1,0 1,0 1,1 0,-8 -2,-7 -2,-12 -1,-4 0,-2 2,-5 0,0 1,0 1,0 0,0 0,-1 0,-1 0,0 0,-1 0,-1 -10,2 -6,3 -10,-2 -1,1 -1,0 -1,2 -1,2 -1,1 -1,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil32",
    d: "M268 1430c-1,0 -2,1 -2,2 -2,2 -1,1 -2,2 -2,6 0,1 1,3l6 -6c-2,-2 0,-1 -3,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil33",
    d: "M355 1368c-1,0 -3,-2 -5,-2l-5 0c-5,1 -2,6 -2,7l2 -2c0,1 0,1 0,1l0 3c0,0 0,1 -1,3 7,-2 9,-3 11,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil34",
    d: "M167 1771l-6 -10 -4 -1c0,4 1,0 4,7l2 5c-3,-1 -5,-2 -7,-3 -4,-3 -1,-1 -6,-4 -4,-3 -6,-6 -9,-9 -4,0 -2,-1 -3,2l1 1c4,2 2,1 5,5 3,3 17,11 22,13 2,-3 1,-1 1,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil34",
    d: "M11 1739l0 4 5 0c2,-2 2,-1 2,-4 -4,-2 -2,-2 -7,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil35",
    d: "M218 1563l1 -1c-4,-4 0,0 -2,-4 -1,-2 -1,-2 -2,-4 0,0 1,0 1,-1l4 -4c4,3 0,0 5,1 5,2 7,1 9,0l1 -3c-4,-2 -2,0 -3,-4l-2 1c-6,4 -10,-1 -16,9 -2,3 -1,3 -3,5 2,6 -1,7 -1,12l3 1 2 -1c0,-8 -2,-1 -1,-9l4 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil35",
    d: "M275 1662l-1 -3 -1 0 0 -2c-2,-5 -1,-4 -4,-5 -6,-1 -2,-3 -10,-4 0,3 1,3 4,5 4,3 -1,2 7,2l2 6c-1,1 -2,-1 -4,1l5 2 2 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil35",
    d: "M238 1626l-1 -3c-7,0 -4,-1 -7,4l-3 0c-2,0 -2,0 -3,1 4,3 5,0 10,-1 -1,5 -1,3 0,6 3,0 2,1 3,-2l1 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil35",
    d: "M235 1640l1 0 0 -2c-5,-1 -2,0 -5,-3 0,6 1,3 -2,6l0 0 3 1 3 -2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil35",
    points: "308,1629 309,1627 306,1623 304,1631 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil36",
    d: "M193 1603c-3,-1 0,0 -2,-2l1 -7c-1,-7 -3,-4 0,-7 1,-5 3,-4 0,-8 0,0 1,0 1,0 1,0 0,0 1,-1 -2,-3 -2,0 -1,-4l-4 3 0 -5c-3,3 -3,7 -3,12 1,5 3,7 3,10 2,6 -1,16 6,21 2,-6 1,-8 -2,-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil36",
    d: "M156 1746c-4,6 0,-2 -4,3 2,4 1,5 5,11l4 1 -5 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil37",
    d: "M61 1544l8 -7 1 -6c-5,0 -2,-1 -6,-10 -4,2 -4,3 -7,5l-2 2 7 -1c4,5 4,9 0,12 -5,-5 -1,-7 -6,-10 -2,4 -1,1 -3,1 2,5 4,4 5,8 1,3 0,5 0,8 1,-1 2,-2 2,-1 0,0 1,-1 1,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil37",
    d: "M312 1331l-2 -2c-4,5 5,1 -1,1 -2,0 -2,-2 -4,2 11,5 3,4 8,4 6,2 5,-2 6,-6l-7 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil37",
    d: "M118 1532c-4,0 -3,-1 -6,2 2,4 6,4 10,5l0 -2c5,0 4,1 6,-2 -2,-1 -3,-1 -5,-1 -2,-1 -1,-2 -4,1l-1 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil38",
    d: "M303 1555l4 -2c-1,6 -1,1 1,6l1 0c2,-1 0,-2 1,0 2,2 -3,3 3,1l1 -1c0,-4 -2,-4 -6,-6 -3,-2 -5,-4 -8,-6 1,4 2,6 3,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil39",
    d: "M315 1548l0 -1c-7,2 -4,0 -6,-1 -1,0 -4,-1 -6,0l1 1c-6,-2 -7,-1 -7,4l-7 -2 -2 3c2,3 2,1 7,2 2,0 5,1 8,1 -1,-2 -2,-4 -3,-8 3,2 5,4 8,6 4,2 6,2 6,6 1,-2 1,-3 2,-3l0 5 3 -2c0,-4 0,-3 -2,-6 -2,-4 -1,0 -2,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil39",
    d: "M102 1656c-4,-1 -4,-2 -6,-3 -4,0 -4,1 -4,4l2 4 4 0c0,0 0,0 1,-1l1 -1c1,-1 1,-2 2,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil40",
    d: "M325 1570c0,-3 -1,-1 1,-3l2 1c4,-1 3,0 4,-4 1,-2 3,-5 3,-7 1,-6 0,-13 -3,-16 0,4 1,6 0,11 0,1 0,3 0,4l-1 5c-2,1 -7,5 -8,-6 -4,5 -1,7 -6,9 -2,4 -2,6 -8,7 0,0 2,1 2,1 2,1 1,-2 2,1 0,0 1,0 1,1 1,-5 1,-6 5,-8l6 4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil41",
    d: "M331 1380c-5,-4 0,0 -3,0 -4,-1 3,2 -3,0 0,-3 1,-4 3,-7l1 3c1,-5 2,-4 2,-8l1 -4c-4,2 -9,7 -12,10 -4,4 -9,6 -10,10 4,3 19,-2 21,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil41",
    d: "M343 1447l-3 -2 0 -15c-7,-1 -5,-1 -8,5 -1,3 -2,6 -3,10 3,0 2,-2 3,3 5,0 5,1 11,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil41",
    d: "M155 1557c0,-4 -2,-10 -5,-12 -4,2 3,1 -2,0 -2,0 0,0 -2,0 0,0 -1,0 -1,0 -3,2 -2,1 -3,2 4,6 5,4 2,5 1,3 2,3 4,6 2,3 0,2 3,2 2,-2 -1,-2 4,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil42",
    d: "M190 1324l0 -3 6 -3 1 -4c-5,1 -7,3 -11,5 -5,2 -6,3 -9,6 6,-1 7,-2 13,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil42",
    d: "M165 1392l-2 -3 -3 1c5,6 11,15 18,18 -3,-7 -8,-4 -13,-16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil43",
    d: "M133 1636l7 -1c0,6 1,9 0,15 -1,6 -1,8 -2,14l0 1 2 3 2 -2 1 3c3,-7 5,-15 3,-23 -2,-13 -5,-9 -13,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil43",
    d: "M102 1765c-3,-9 -18,-14 -27,-16 3,4 9,4 15,9l-1 6c4,3 10,5 13,8l2 -3 -2 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil43",
    d: "M128 1648c3,3 2,1 2,6l5 1c2,-3 4,-14 4,-18 -4,1 -9,2 -12,5 0,1 -2,3 -3,4l2 1c0,0 2,1 2,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil43",
    d: "M159 1700l-3 2 0 3c1,0 1,0 3,-2 2,-3 1,-1 0,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil44",
    d: "M232 1569l0 -9c5,1 8,3 11,3 7,0 5,-3 4,-9l-11 1 -1 0c-1,2 -3,5 -5,7 -2,4 -3,4 -7,4l-1 4 -3 4 0 1c5,-2 10,-2 13,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil45",
    d: "M234 1397c-4,2 -1,2 -3,3l-3 1c2,3 2,6 3,8 4,-2 1,1 3,-3 3,4 -1,0 2,2 2,1 2,1 4,1 1,0 1,0 1,0 0,0 3,0 3,0l3 -2c0,0 0,0 0,0l-2 -8c-1,-3 0,-1 -2,-3 0,0 -3,-3 -3,-3 -7,3 0,1 -6,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil46",
    d: "M282 1612l1 -1 1 -9 3 4 3 0 -1 -1c-1,-4 -7,-7 -11,-8 2,3 2,1 0,4 -8,2 -9,-2 -11,-4l-2 3c4,2 2,1 5,3 -3,6 0,0 -3,3 -3,2 -1,-2 -2,2l4 0c4,8 3,5 13,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil46",
    d: "M285 1558c1,0 1,-3 1,-3 1,-3 0,-1 2,-3l2 -3 3 -4c-5,0 -6,0 -11,2l-6 0 1 9c1,0 0,-1 3,0 4,1 1,0 3,2l2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil46",
    d: "M223 1564l1 -4c-5,1 -3,1 -5,2l-1 1 2 1c3,2 -1,1 3,2l0 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil47",
    d: "M282 1666l13 -2 0 -2 -1 -1 -7 -1c4,-3 4,-1 5,-4 -5,1 -4,2 -8,-2 0,1 0,1 0,1 0,0 1,5 -6,6 -3,0 -1,-1 -3,1l-2 2 -5 -2 -1 1c-4,5 0,2 -11,1 -4,0 -10,-1 -13,0 3,3 10,4 15,3l24 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil47",
    d: "M133 1636c-9,3 -14,10 -16,20l6 -5c1,-3 0,-3 5,-3 0,0 -2,-1 -2,-1l-2 -1c1,-1 3,-3 3,-4 3,-3 8,-4 12,-5 0,4 -2,15 -4,18l2 3 -2 2c1,3 0,2 3,4 1,-6 1,-8 2,-14 1,-6 0,-9 0,-15l-7 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil47",
    d: "M202 1554c-3,-6 -4,-5 0,-11 2,-2 1,-1 3,-5l-3 3c-4,-2 0,0 -2,-3 -5,6 -5,13 -4,20 3,-1 5,-2 6,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil47",
    d: "M126 1729c2,9 1,17 9,23 -2,-8 -6,-15 -7,-22l-2 -1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil47",
    points: "143,1669 142,1666 140,1668 138,1665 137,1670 139,1672 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil48",
    d: "M202 1584c-1,-1 -2,-1 1,-5 -1,0 -2,-1 -2,-1 5,-5 6,0 3,-3l5 -4c-1,7 -1,2 1,4l0 -5c0,-5 3,-6 1,-12l-2 1c-3,0 -5,1 -7,2 -2,1 -2,1 -4,2 -3,2 1,1 -3,2l3 3c0,0 3,-3 7,0 -2,3 -1,2 -4,5 -7,7 -5,12 -5,15 3,-1 4,-1 6,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil49",
    d: "M189 1359c5,-8 2,-9 1,-11l-1 2c-1,2 -1,1 -1,3 -3,7 -4,8 -7,8l-1 2c4,1 2,-1 4,2 -3,9 -9,1 -3,16l8 1c0,-9 0,-4 -1,-6 -3,-2 -2,1 -2,-5 1,4 1,2 2,2 3,-4 3,-4 -1,-5 3,-2 7,-1 3,-5 -2,-2 -1,0 -2,-2l1 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil50",
    d: "M255 1563l5 -1 0 -4c-10,0 -4,-3 -13,-4 1,6 3,9 -4,9 -3,0 -6,-2 -11,-3l0 9c4,-1 7,-2 11,-3 4,-1 8,-2 12,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil50",
    d: "M97 1774c0,1 0,4 0,4l1 4 7 1c-1,-8 -1,-8 -8,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil51",
    d: "M233 1337l-1 1c-3,-2 -1,1 -3,-4 -1,2 -2,1 -2,1 1,5 1,5 0,7 -1,0 -1,0 -1,-1l-1 -2c-1,-3 2,1 -1,-3 -1,5 -2,5 -4,7 1,4 3,4 7,5l4 -2c3,5 3,1 3,8 3,2 -3,2 4,2 0,-10 -4,-9 -5,-19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil52",
    d: "M325 1795c3,-1 3,-1 4,-2l-6 -2c1,-3 0,-6 -2,-9 1,0 4,1 5,1l3 1c0,1 1,1 1,1 0,-4 -1,-4 -3,-4l2 -4c0,-4 2,-1 -2,-3 -3,2 -2,0 -3,3l-10 -4c-3,2 -1,-1 -1,2l6 4 -10 2c2,6 2,3 4,7 3,2 3,4 4,6l3 3 2 -1c4,-3 2,-2 3,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil52",
    d: "M150 1541l-2 -6c0,0 -1,0 -1,-1l-8 2c0,0 2,-2 2,-2 0,-1 -1,-1 -1,-1 -2,-6 3,0 -2,-2 -5,4 1,1 -3,7 -2,3 0,-3 -2,2 3,2 4,1 6,-1 0,4 -2,2 4,3 7,2 2,0 7,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil53",
    d: "M79 1545l3 -11c2,-5 2,1 5,-11 -6,2 -6,1 -9,5l-3 7c-1,0 -2,4 -2,4 -3,6 -1,3 -5,5l1 -7 -8 7 7 1c2,3 3,8 7,9l3 -7c2,-3 -1,1 1,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil53",
    d: "M176 1471l-2 -1c4,-5 11,-6 19,-10l3 -1c1,0 2,-1 2,-1l11 -4c4,-2 3,-1 6,-4 -7,2 -15,6 -22,8 -5,2 -16,5 -21,7l-1 7c2,1 3,0 5,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil53",
    d: "M326 1754c1,2 -1,1 2,2 3,-3 3,-1 2,-6 0,0 0,-1 0,-1l-2 -3c-2,-3 -6,-4 -6,-4 -1,-1 -1,0 -1,-1 -1,4 -2,5 -3,9 6,1 6,3 8,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil53",
    d: "M47 1475l-3 0c1,3 -1,1 2,3 2,-1 2,3 1,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil54",
    d: "M338 1615l-2 -6 3 -1 -2 -3c-3,1 -2,1 -6,-1l-2 0 -3 1c1,6 4,9 2,15 3,1 3,-2 2,2 6,-3 0,0 4,2 3,-5 -1,-1 3,-7 1,-1 -1,3 1,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil55",
    d: "M86 1661c0,-6 -3,-18 7,-18 2,2 -1,3 4,5l2 1c2,2 3,3 3,7 3,2 4,7 4,10 4,-15 -17,-35 -17,-35 -7,-1 -8,10 -8,15 1,4 3,12 5,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil55",
    d: "M153 1718c6,3 14,0 20,0 9,1 11,3 18,6 4,2 2,1 3,0 4,3 8,4 13,5 -4,-7 -14,-12 -23,-13 -7,-1 -9,0 -15,1 -4,1 -12,1 -16,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil55",
    d: "M205 1538c2,-1 3,-4 8,-7 4,-2 7,-4 11,-5 1,-1 0,0 1,-1 4,-3 0,1 3,-3 -12,3 -19,8 -28,16 2,3 -2,1 2,3l3 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil55",
    d: "M336 1644l-3 0 -3 2c-5,5 -7,2 -11,8 6,-2 13,-4 17,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil55",
    d: "M171 1694c-1,-1 -1,1 -6,2l-1 -3 0 4 0 4 7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil56",
    d: "M306 1607c-5,-2 -14,0 -13,-3 5,-2 4,2 9,-2l-1 -4c4,-1 4,0 6,-2 -2,0 -11,1 -12,1 -4,0 -6,-2 -10,-3l-1 -3c-4,-1 -4,-2 -8,0 2,4 1,-3 3,4l-2 1 1 1c4,1 10,4 11,8 3,3 1,5 0,8 4,0 9,-1 12,-3 3,-2 2,-1 5,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil56",
    d: "M249 1614c-3,-2 -3,1 -10,0 -7,-2 0,1 -12,-2 -2,6 2,2 -4,6 11,2 15,2 26,3l0 -1 -5 0c1,-4 1,-2 3,-4 0,0 1,-1 2,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil56",
    d: "M178 1723l-7 -1c1,3 2,1 -1,3l0 4c3,1 5,3 9,3 2,0 2,-1 3,-1l-1 -4c-4,-2 -3,-1 -3,-1 0,0 -4,1 -4,0l4 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil57",
    d: "M202 1318l0 11 -6 3c2,-6 -1,-5 -1,-9 0,-5 4,-4 7,-5zm11 16l-1 -2c-3,-1 -2,1 -3,-2 -3,5 0,3 -5,4 0,-2 -1,-5 3,-8 1,-1 0,0 3,-1 -1,-5 -2,0 2,-5 -6,-4 6,-1 -2,-1l-2 1c0,-4 1,-1 -1,-2 -7,2 -2,1 -3,-1 1,-1 1,-2 3,-2 5,-4 1,0 3,-3 1,-3 -3,-1 -6,-1 -3,0 -6,1 -7,3l-1 4 -6 3 0 3c2,2 0,0 1,2l3 2c0,0 0,0 0,0 1,3 1,2 0,6l8 -1c3,5 -1,2 5,6 2,-4 1,-3 6,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil57",
    d: "M226 1317l0 -2c0,-4 0,-3 -2,-5 -2,-1 -2,-1 -3,-2l-1 -3 -3 1c-4,-1 -3,-1 -6,1 -2,4 -1,1 0,4l3 -1c1,0 3,4 6,1 0,2 -1,0 0,2 0,1 1,2 2,3 -4,0 -1,0 -4,-3l-2 5c1,0 3,0 4,0 1,0 0,0 2,0 1,0 3,-1 4,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M331 1765l0 -4 -4 4c-3,2 0,1 -3,2 3,-5 6,-3 -2,-12l-4 1 -1 13c-4,-2 2,-2 0,-1l-1 2c0,0 0,0 0,1 0,0 -1,0 -1,1l-3 -7 -6 5c-4,-3 -2,-1 -6,-5 2,4 8,9 13,10 0,-3 -2,0 1,-2l10 4c1,-4 1,-2 4,-6 3,-3 2,-2 3,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M356 1832c-4,-1 -1,1 -5,-2l-18 -15c-3,-3 0,-2 -4,-3l-3 4c1,3 2,5 6,8 2,1 2,1 4,2 13,6 9,13 18,11 3,-1 0,1 2,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M92 1471c-2,-12 -3,-8 -8,-16 -6,-10 -2,-13 -8,-16l-2 0 -3 4 -1 0c4,1 2,0 5,5 1,2 1,3 3,6 2,4 3,9 5,13 3,2 2,2 3,6 6,-1 1,-1 6,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M75 1523l2 -7 0 -4 3 -1 -2 -2c-2,-3 -2,-1 -6,-2l-9 7 -1 4 8 -3c-2,3 -4,-1 -4,5 0,1 0,4 1,5 1,4 1,2 2,4 4,-2 6,-5 1,-6 1,0 2,1 5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M312 1750c0,-2 0,-3 1,-8 5,2 -1,-1 3,3l5 -9 -5 1c0,1 -1,0 -1,0 -2,-6 1,0 -5,-3 0,0 0,-1 -1,-1l-5 -4c0,5 -1,5 -1,9 0,5 1,6 1,7 1,1 1,1 1,1 2,2 0,0 2,2l2 3c3,3 1,0 3,4l0 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M309 1350c0,4 2,2 0,5 -5,1 -2,-2 -4,-4 0,4 -3,2 -6,1 3,10 -5,3 -1,11 4,6 4,-2 8,3 0,0 1,0 1,0 7,-8 5,-3 6,-8l-1 -4c0,0 0,-1 0,-1 -1,-2 1,-1 -3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M349 1855c-5,-3 -4,-6 -9,-10 -5,-5 -3,-2 -7,-9 -2,-3 -2,-4 -5,-5 -2,4 2,9 3,13 3,0 3,0 4,3 3,1 9,12 13,15 0,-2 1,-5 1,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M97 1440l-6 -20 -3 3 0 4c2,7 5,15 5,22l2 7c6,-3 3,-10 2,-16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M295 1721c-1,-2 1,-1 -2,-2l1 -1 -1 -2c-1,1 -3,2 -5,1 -2,0 -1,0 -3,-1 -5,-2 1,-2 -7,-5 1,11 5,4 2,15 4,1 0,0 4,3l1 -2c0,-4 0,0 -1,-2 -1,-5 -2,3 -1,-5l12 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil58",
    d: "M309 1441l-6 -1c1,5 0,1 2,4l3 0 1 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil59",
    d: "M169 1373l1 -3c-2,-2 -3,-5 -5,-7 1,3 7,3 9,4 1,-6 0,-5 -4,-8l-5 -4c-7,5 -1,3 -3,12 -2,4 -2,11 0,13l1 -3c3,-1 0,-1 4,0 2,-2 2,3 2,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil60",
    d: "M83 1467c-2,-4 -3,-9 -5,-13 -2,-3 -2,-4 -3,-6 -3,-5 -1,-4 -5,-5l-5 3c2,6 1,1 1,5l1 4c1,3 -1,1 3,3 2,-4 1,-2 1,-7 -2,3 1,7 3,9 4,2 1,-1 3,-1 0,0 2,0 3,1 0,1 0,1 1,1 -3,5 -6,4 -10,2 -2,-3 -1,-1 0,-6 -7,1 -5,3 -6,-1l-4 1 -1 2c2,2 5,4 7,6 3,3 5,2 6,5 3,-2 5,-2 9,0l1 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil60",
    d: "M359 1812l-5 -1 -5 1c0,4 1,5 1,7 -1,4 -6,1 0,9l1 1c0,0 0,1 0,1 4,3 1,1 5,2l6 -4 -3 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil60",
    d: "M363 1796c-4,-4 -3,-2 -9,-2 -2,6 -1,-1 -6,6l-1 1c-2,3 1,-1 -2,3 5,1 7,4 14,5 5,-2 3,-1 6,-4l-2 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil60",
    d: "M335 1847c-1,-3 -1,-3 -4,-3l-2 0c-3,-5 0,-4 -6,-7 0,7 1,12 5,16l4 -3c0,-8 0,0 -3,-5 7,0 -1,-1 6,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil61",
    d: "M212 1547l0 1c-2,-1 -5,1 -1,-8 -7,7 -5,4 -7,10 -5,-5 0,0 -2,-7 -4,6 -3,5 0,11 4,-2 8,-3 10,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil61",
    d: "M309 1592l-3 1 1 3c-2,2 -2,1 -6,2l1 4 10 -3c-1,-6 0,-3 -3,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil61",
    d: "M189 1739c-1,-2 -2,-2 -5,-2 0,3 -1,2 -4,4l1 2c1,-2 -3,-3 2,-1 2,3 1,1 0,3 3,2 1,2 5,2l-1 -7 2 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil62",
    d: "M326 1816l3 -4c4,1 1,0 4,3 2,-2 1,-2 4,-2l-1 -4c0,0 0,-1 0,-1l5 0c-2,0 -6,0 -8,-2 -4,-2 -3,0 -2,-4 3,-2 10,1 14,2 3,-4 0,0 2,-3l1 -1c5,-7 4,0 6,-6l-27 2c-1,10 -2,12 -4,22l3 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil64",
    d: "M60 1754c4,7 5,11 12,13 10,3 3,1 9,4 1,-4 -1,-2 3,-3 6,-1 -3,2 2,0 -2,-9 -5,-9 -6,-10 -2,-2 0,-2 -2,-3 -6,-6 -5,-1 -7,0l-6 -5c-1,-1 -1,-1 -1,-1 -2,0 -3,0 -4,0l0 5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil64",
    d: "M122 1690l3 -1c-3,-2 -2,-1 -3,-6l-5 2c0,6 2,1 -1,6 5,1 1,1 6,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil65",
    d: "M222 1395c3,8 1,1 4,5l-1 -1c0,0 0,0 -1,-1 0,8 1,1 -3,6 0,0 0,0 0,0 -2,2 0,2 -4,5 2,-13 -2,-3 3,-15 0,6 0,-1 2,1zm22 17l0 -3c0,0 -3,0 -3,0 0,0 0,0 -1,0 -2,0 -2,0 -4,-1 -3,-2 1,2 -2,-2 -2,4 1,1 -3,3 -1,-2 -1,-5 -3,-8l3 -1c2,-1 -1,-1 3,-3 -5,2 -5,2 -8,-1l-1 -1 -3 0c0,-2 0,-4 -3,-5 -2,-1 -5,1 -8,1l1 3c4,3 5,8 2,12 2,2 4,4 7,3 3,-1 2,-2 4,-4l3 1 -1 4c-3,1 -2,-1 -4,2 3,4 -1,0 1,1 3,1 17,-1 20,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil65",
    d: "M212 1332c0,-4 -1,-1 1,-4 0,-1 6,-4 8,-3l-2 -3c0,0 0,-1 0,-1 3,0 2,0 4,-1l3 -3c-1,0 -3,1 -4,1 -2,0 -1,0 -2,0 -1,0 -3,0 -4,0l1 3c-2,-1 -1,-2 -3,1 -3,2 1,2 -4,3 -3,1 -2,0 -3,1 -4,3 -3,6 -3,8 5,-1 2,1 5,-4 1,3 0,1 3,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil66",
    d: "M216 1318l2 -5c3,3 0,3 4,3 -1,-1 -2,-2 -2,-3 -1,-2 0,0 0,-2 -3,3 -5,-1 -6,-1l0 4c-6,-1 -1,-1 -4,1 -2,0 -3,2 -3,3 2,1 1,-2 1,2l2 -1c8,0 -4,-3 2,1 -4,5 -3,0 -2,5 5,-1 1,-1 4,-3 2,-3 1,-2 3,-1l-1 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil67",
    d: "M163 1323l-2 -1c2,-6 2,0 3,-7 -7,3 -34,21 -36,29 7,3 12,-3 18,-8 4,-2 16,-10 17,-13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil67",
    d: "M231 1370c6,-1 6,0 7,-5l-3 1 -8 1 -6 2c-3,3 -14,8 -19,8 0,-4 3,-14 1,-17l-3 3 1 1 -1 2c-1,7 -3,9 0,15 6,0 11,-3 16,-5 6,-3 9,-4 15,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil68",
    d: "M267 1663l-3 1c-4,-6 1,-3 -5,-4 -3,0 -1,1 -6,-1l0 -3c-2,-2 0,-2 -6,-2 -8,0 -6,1 -16,-2 -7,-2 -6,0 -7,1 5,3 4,-1 6,5l-7 -1c4,4 15,8 20,7 3,-1 9,0 13,0 11,1 7,4 11,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil68",
    d: "M164 1693l-1 -5c-8,1 -18,4 -24,9l19 -6c3,1 3,1 6,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil69",
    d: "M162 1380c-2,-2 -2,-9 0,-13 2,-9 -4,-7 3,-12 3,-4 0,2 5,-1l-4 -4c1,-5 4,-5 2,-10 -4,-1 0,0 -3,-3 -12,22 -10,30 -5,53l3 -1c1,-5 0,-5 -1,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil69",
    d: "M232 1338c-2,-5 -2,-7 -3,-12 0,-6 -3,-7 -3,-11l0 2 -3 3c-2,1 -1,1 -4,1 0,0 0,1 0,1l2 3c-2,-1 -8,2 -8,3 -2,3 -1,0 -1,4l1 2c2,-2 6,-1 10,-1l1 3c3,4 0,0 1,3l1 2c0,1 0,1 1,1 1,-2 1,-2 0,-7 0,0 1,1 2,-1 2,5 0,2 3,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil70",
    d: "M190 1385c-3,1 -5,1 -8,0 -2,0 -2,0 -3,-1 -3,-2 -1,-2 -2,-2 -9,-6 2,-17 3,-19l-3 -4c-3,3 0,5 -3,8 -2,-1 -8,-1 -9,-4 2,2 3,5 5,7l-1 3 4 3c-3,2 2,3 -7,2 0,0 1,0 1,0 5,2 2,2 6,6 -3,1 -3,4 -5,8 1,4 0,-1 4,3 7,0 3,-4 10,-2 2,0 7,2 9,2 -1,-5 -3,-6 -1,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil70",
    d: "M227 1367c-2,-4 -1,-1 -2,-5 3,-2 2,-2 6,-1l-1 -1c-2,-2 0,0 -1,-2l0 -1c0,1 -1,1 -1,1 0,0 -1,0 -1,0 -3,1 -1,1 -4,2 -3,-4 -2,-7 -10,-11 -1,0 0,-2 -4,-1 -3,1 -1,1 -3,5l-4 -4c2,7 -1,4 -1,4l4 3c9,14 10,8 16,13l6 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil70",
    d: "M189 1359l3 1c1,-5 5,-1 3,-8 -1,-5 0,-6 3,-10l-3 0c-11,1 2,5 -4,0l0 1c-1,5 1,2 -3,5 -7,4 -3,4 -5,8 -2,5 -2,-2 -2,5 3,0 4,-1 7,-8 0,-2 0,-1 1,-3l1 -2c1,2 4,3 -1,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil71",
    d: "M332 1541c-1,-5 -18,-18 -24,-17 -8,0 -17,-3 -22,-2 4,3 17,5 18,5 1,0 2,-1 3,-1 5,6 9,1 12,9l0 3c2,1 3,1 4,1 7,2 3,2 8,4l-2 8 -4 -4c-5,-3 -5,-4 -7,-10l-5 -1c1,3 3,4 4,7 2,4 1,4 4,6l0 0c3,1 0,0 3,2l2 2c3,2 5,1 5,8l1 -5c0,-1 0,-3 0,-4 1,-5 0,-7 0,-11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil71",
    d: "M254 1626c8,-5 18,3 22,-7l-27 2c-11,-1 -15,-1 -26,-3l-12 -2 4 5c4,2 3,0 9,2l-2 2 4 0 1 2 3 0c3,-5 0,-4 7,-4l1 3c4,0 5,-1 8,-1 4,2 3,3 8,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil72",
    d: "M246 1412l-2 0c-3,0 -17,2 -20,1 -2,-1 2,3 -1,-1 2,-3 1,-1 4,-2l1 -4 -3 -1c-2,2 -1,3 -4,4 -3,1 -5,-1 -7,-3l0 1 -2 4c-3,3 -5,4 -10,3 -3,3 -12,-2 -16,-3 -2,-2 -4,-2 -7,-3 2,6 18,11 25,12 7,0 24,-3 32,-5 2,0 4,-1 6,-1 0,0 2,-1 2,-1 3,-1 1,0 2,-1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil72",
    points: "173,1330 168,1333 169,1335 172,1335 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil73",
    d: "M242 1538l2 1 7 -1c3,-2 0,-2 6,-2l-1 -4c2,1 5,0 7,-2 -3,-4 0,0 -2,-1 -7,-4 -4,-3 -9,-3 2,4 3,3 1,8 -6,1 -4,0 -9,2 -10,3 -7,0 -8,-1 6,-3 10,1 13,-6l-8 0 12 -5c-4,0 -4,-1 -10,1 -6,2 -3,1 -6,4l-1 -1c-3,-2 -3,-2 -7,0 1,0 4,0 4,0 -4,5 -5,-2 -6,6 2,-1 2,-1 3,-2 2,0 5,-1 6,-1 0,0 -1,0 -1,0l-5 5c0,0 0,0 0,0 -3,2 -3,0 -7,3 3,3 5,0 4,5l3 0c-1,-10 3,-5 12,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil73",
    d: "M196 1589l0 -1c0,-3 -2,-8 5,-15 3,-3 2,-2 4,-5 -4,-3 -7,0 -7,0l-3 -3c3,-4 2,-2 1,-6 -4,3 -7,7 -7,13l0 5 4 -3c-1,4 -1,1 1,4 -1,1 0,1 -1,1 0,0 -1,0 -1,0 3,4 1,3 0,8 -3,3 -1,0 0,7 2,-4 1,-3 4,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil73",
    d: "M253 1608l0 0c-4,-2 -6,-2 -9,-5 -5,-4 2,-3 -7,-4 -1,15 6,0 4,9l-2 0c-7,0 0,-2 -11,-5 -7,0 -3,2 -9,-1 2,6 4,3 11,5 2,4 -1,3 3,5 2,0 10,2 11,0 0,-2 0,-1 3,-2 1,-1 5,-1 6,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil73",
    d: "M211 1575l-1 0c-2,-2 -2,3 -1,-4l-5 4c3,3 2,-2 -3,3 0,0 1,1 2,1 -3,4 -2,4 -1,5 3,-2 7,-5 11,-6l-2 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil74",
    d: "M277 1651c4,-3 8,-4 14,-4 -3,-4 -2,-2 -2,-7 -4,2 -24,6 -28,5 -4,3 -7,2 -13,2 -5,0 -9,1 -14,-1 0,0 -2,0 -2,0l-2 -1 -7 1c2,3 -1,0 3,3 2,1 3,1 4,1 17,5 22,-1 28,2 0,-2 -1,-4 1,-4 8,1 4,3 10,4 4,-4 2,-4 7,-4l1 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil74",
    d: "M333 1644c2,-5 1,-2 5,-6 7,-9 4,-9 5,-18 0,0 -1,-1 0,1 1,2 0,0 0,0l1 -4c-1,-4 -2,-6 -5,-9l-3 1 2 6c1,5 4,12 0,17 -3,5 4,-2 -1,1 -2,1 -1,0 -2,2 -2,5 1,4 -4,7 -3,1 -1,-1 -4,3 2,2 -3,3 3,1l3 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil74",
    d: "M199 1591c-4,0 -2,1 -3,-2 -3,2 -2,1 -4,5l-1 7c2,2 -1,1 2,2 0,-6 2,-10 6,-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil75",
    d: "M212 1548l0 -5c5,-2 9,1 15,1 1,-5 -1,-2 -4,-5 4,-3 4,-1 7,-3 0,0 0,0 0,0l5 -5c0,0 1,0 1,0 -1,0 -4,1 -6,1 -1,1 -1,1 -3,2 1,-8 2,-1 6,-6 0,0 -3,0 -4,0 -5,0 -7,2 -11,4 4,-5 2,-2 6,-6 -4,1 -7,3 -11,5 -5,3 -6,6 -8,7 -2,4 -1,3 -3,5 2,7 -3,2 2,7 2,-6 0,-3 7,-10 -4,9 -1,7 1,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil75",
    d: "M286 1613l-4 -1c-10,1 -9,4 -13,-4l-4 0 -3 2 -1 1c-3,-2 -3,-2 -6,-1l-5 4c0,0 0,0 -1,0 -1,1 -2,2 -2,2 -2,2 -2,0 -3,4l5 0c7,0 13,-1 20,-1 13,-1 9,-3 17,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil75",
    d: "M327 1622l0 -2 -1 -9c-3,0 1,-1 -1,0 -5,3 2,0 -2,1 -1,-3 0,1 0,-2l0 -3c-8,2 -11,0 -12,9l6 4 3 -1 -1 10c4,-1 6,-5 8,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil75",
    d: "M262 1633c-1,-1 -3,-2 -4,-2 -6,-1 -1,0 -5,1 -3,1 -8,0 -12,1l3 2 0 3 4 -1c1,0 1,1 1,1 3,4 3,5 6,7l3 -2c6,-3 7,-1 7,-7 -6,-1 -5,1 -8,-1 3,3 4,1 5,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil76",
    d: "M321 1549c-3,-2 -2,-2 -4,-6 -1,-3 -3,-4 -4,-7 0,-4 0,-1 1,-2l5 1c-3,-8 -7,-3 -12,-9 -1,0 -2,1 -3,1 -1,0 -14,-2 -18,-5 5,-1 14,2 22,2 -3,-3 -9,-4 -14,-4 -9,3 -12,-2 -19,0l-2 1c2,3 3,3 3,3 0,0 1,0 1,0 6,3 20,3 32,10 0,0 0,1 0,1l-3 2c3,2 2,1 3,1 4,2 7,6 5,5l1 4 0 1 4 4c2,-2 1,2 2,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil76",
    d: "M222 1625l2 -2c-6,-2 -5,0 -9,-2l-4 -5c-3,-1 -4,-1 -7,-1 -1,-1 -3,-2 -4,-2l-4 0 0 2c3,4 2,2 8,4 13,4 14,4 19,9l-1 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil77",
    d: "M235 1555l1 0c3,-3 4,-3 6,-7 -4,2 -4,2 -8,2 -2,1 -4,2 -9,0 -5,-1 -1,2 -5,-1l-4 4c0,1 -1,1 -1,1 1,2 1,2 2,4 2,4 -2,0 2,4 2,-1 0,-1 5,-2l-1 4c8,-3 6,-1 8,-7l4 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil77",
    d: "M222 1570l1 -4c-4,-1 0,0 -3,-2l-2 -1 -4 -2c-1,8 1,1 1,9l-2 1 2 -2c3,1 5,1 7,1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil77",
    points: "290,1606 287,1606 284,1602 283,1611 289,1609 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil78",
    d: "M229 1357c-2,-1 -1,0 -3,-1 -2,-1 -1,-1 -2,-1l-3 -7c5,2 4,2 8,2l-2 -2c-4,-1 -6,-1 -7,-5 -4,2 -7,4 -9,0 -4,0 -4,0 -4,-4 -6,-4 -2,-1 -5,-6l-8 1c1,-4 1,-3 0,-6 0,0 0,0 0,0 0,5 0,6 -1,11l-2 3c6,5 -7,1 4,0l3 0c-3,4 -4,5 -3,10 10,0 4,0 7,-3l4 4c2,-4 0,-4 3,-5 4,-1 3,1 4,1 8,4 7,7 10,11 3,-1 1,-1 4,-2 0,0 1,0 1,0 0,0 1,0 1,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil78",
    d: "M202 1318c-3,1 -7,0 -7,5 0,4 3,3 1,9l6 -3 0 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil78",
    d: "M214 1310l-3 1c-1,-3 -2,0 0,-4 -3,1 -5,1 -7,4 3,0 7,-2 6,1 -2,3 2,-1 -3,3 -2,0 -2,1 -3,2 1,2 -4,3 3,1 0,-1 1,-3 3,-3 3,-2 -2,-2 4,-1l0 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil79",
    d: "M71 1298c-4,-3 -4,-3 -3,-8 4,-1 4,0 6,-2l-1 -3c-3,-2 1,-1 -1,1 0,1 1,3 -3,0 -7,-6 2,-6 -3,-8l-3 -2c-3,2 -3,7 -9,4 0,1 1,0 0,2 0,0 -1,1 -1,1l-2 3 -6 7c1,2 -1,4 5,-1l3 2c3,1 2,0 3,2 -2,2 0,0 -4,1l1 2c4,1 2,0 3,2 2,-1 3,-3 6,-2 5,1 1,0 2,2 2,3 -2,1 2,2l1 -5 4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil79",
    d: "M355 1777c-1,-2 -1,-2 1,-4l-8 1c-10,2 -1,5 -13,5l-3 -6c4,-6 6,-6 7,-14l5 1c2,3 1,2 4,4 0,0 2,2 2,2 3,1 1,1 3,0 -8,-9 -8,-7 -12,-18l-6 0c-3,5 1,4 2,9l-6 8c-1,4 0,3 -3,6 -3,4 -3,2 -4,6 1,-3 0,-1 3,-3 4,2 2,-1 2,3l2 -1c1,3 0,2 4,4l-1 4c2,1 5,1 7,1 5,-1 5,-6 14,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil79",
    d: "M63 1514l9 -7 0 -3c-3,0 -2,0 -4,-2 0,0 0,1 0,1 0,0 -1,1 -1,1 -3,7 -3,3 -9,7 -5,5 5,5 -6,4 -2,0 -3,-2 -1,0l-1 -7c-3,-2 0,-4 -3,-1 0,7 2,8 0,18l4 3c4,-2 4,-1 4,-6 -4,-1 4,2 -2,0 -2,0 0,2 -1,0 -1,-4 2,-3 11,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil79",
    d: "M43 1492c-5,0 -2,0 -4,1 1,3 -1,1 3,3 8,-1 7,1 11,3 5,1 2,0 8,-1 5,0 5,3 9,-2 -2,-3 -1,-2 -6,-3 3,-2 3,0 2,-2 -6,0 -15,6 -23,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil80",
    d: "M348 1862c-4,-3 -10,-14 -13,-15 -7,-3 1,-2 -6,-2 3,5 3,-3 3,5l-4 3c1,4 1,2 2,5 1,1 1,2 2,3 1,2 0,1 1,2 0,-1 0,0 1,-2 0,-2 0,-1 1,-2 4,5 0,4 10,2 0,0 0,1 0,1 0,0 0,1 0,1 0,0 -1,0 -1,0 -2,3 -3,1 -2,5 0,5 2,4 2,12 0,-1 0,-1 -1,-1 0,0 0,-1 -1,-1l-3 -3 -2 0c3,5 10,17 17,16 0,-4 -3,-9 -5,-13 -2,-9 -2,-8 -1,-16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil80",
    d: "M333 1836c4,7 2,4 7,9 5,4 4,7 9,10 8,-7 -2,-12 -3,-13 0,0 -1,0 -1,0l1 -3c0,0 0,0 0,0l-1 -4c-2,1 -1,1 -3,1 -6,3 -2,0 -9,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil80",
    d: "M88 1427c-5,-1 -6,3 -6,8 2,1 -1,0 2,1 1,0 2,0 2,0 -4,11 3,0 0,9 9,0 -2,1 7,4 0,-7 -3,-15 -5,-22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil81",
    d: "M246 1359l-5 -15c-4,-2 -2,-1 -4,-2 -2,-2 -2,-2 -4,-5 1,10 5,9 5,19l-2 0c0,0 0,0 0,0l-3 0c1,2 -1,1 2,2 0,0 1,0 1,0 0,0 0,0 0,0 1,0 4,-2 4,2l2 -5c3,3 2,5 4,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil81",
    d: "M223 1304l-5 -1c-1,1 -1,2 -1,3l3 -1 1 3c1,1 1,1 3,2 0,-6 -1,-1 2,-5l-3 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil82",
    d: "M304 1655c-2,-3 -3,-3 -5,-5 -1,-4 1,1 0,-7 5,3 2,3 4,3 3,0 1,-1 1,-1 0,0 0,0 0,-1l-1 -1c2,0 3,-1 4,-1 7,-4 0,-3 6,-5 1,0 3,0 3,0l1 0 1 -3 0 -3c0,-3 1,0 -3,2 -3,2 -2,0 -6,3 -5,2 -5,6 -13,5l-2 -5c7,-4 -2,4 13,-3l1 -4 -4 2 2 -8 3 4 9 -2c1,-4 1,-4 -1,-5 -7,4 -4,0 -11,2 -5,6 3,2 -7,8l0 3c-6,0 -11,0 -10,7 0,5 -1,3 2,7 1,1 2,6 3,9l2 3c2,-3 1,-2 2,-6 3,3 1,3 6,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil82",
    d: "M268 1662c2,-2 3,0 4,-1l-2 -6c-8,0 -3,1 -7,-2 -3,-2 -4,-2 -4,-5 -2,0 -1,2 -1,4l1 2c-3,1 -4,1 -6,2l0 3c5,2 3,1 6,1 6,1 1,-2 5,4l3 -1 1 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil82",
    d: "M236 1638l-2 -5c-1,-3 -1,-1 0,-6 -5,1 -6,4 -10,1 1,-1 1,-1 3,-1l-1 -2 -4 0 1 3 3 5 -4 0 0 2 5 0c-5,3 1,0 -2,4 2,1 2,1 4,2 3,-3 2,0 2,-6 3,3 0,2 5,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil82",
    d: "M277 1651l-1 -3c-5,0 -3,0 -7,4 3,1 2,0 4,5l0 2c1,-5 1,-4 4,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil83",
    d: "M169 1373c0,7 0,2 -2,4 -4,-1 -1,-1 -4,0l-1 3c1,4 2,4 1,9l2 3 3 0c2,-4 2,-7 5,-8 -4,-4 -1,-4 -6,-6 0,0 -1,0 -1,0 9,1 4,0 7,-2l-4 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil84",
    d: "M360 1585c-8,-5 -1,-2 -10,-5 0,0 -1,-1 -1,-1l-3 0c0,0 0,0 0,0 -1,0 -1,0 -1,0 0,0 -1,0 -1,0l-13 3c-6,1 -1,3 -6,1 2,-4 2,0 8,-3 -1,-1 2,-3 -9,-5 2,13 1,8 6,12 3,3 -4,3 9,4 0,0 0,0 1,0 4,1 2,0 4,2 7,3 16,2 16,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil85",
    d: "M258 1395c0,-6 -4,-14 -5,-20l-7 -16c-2,1 -1,-1 -4,-4l-2 5c0,-4 -3,-2 -4,-2 0,0 0,0 0,0 0,0 -1,0 -1,0 -3,-1 -1,0 -2,-2l-4 2c1,2 -1,0 1,2 4,0 6,2 5,6l3 -1c0,3 2,-3 0,6 6,4 7,-3 9,10l1 3c-1,1 -2,-1 -3,3l5 4c1,0 0,-4 1,0 0,1 1,1 1,1 1,5 0,7 5,8 1,-1 1,-1 1,-3 1,0 0,-2 0,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil85",
    d: "M196 1407l-5 1c1,-4 2,-3 0,-5l4 -1 1 -1c3,-7 2,-3 7,-8l-7 0c-3,3 -1,1 -2,4 -3,4 1,1 -3,3 0,0 0,0 0,0l-2 -4 -1 3 -4 0c5,4 -1,2 6,6 0,0 -1,0 -1,0 0,-1 -6,1 -3,6 4,1 13,6 16,3 -1,-1 -5,-4 -6,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil85",
    d: "M263 1410l-2 -10c-1,1 -4,2 -4,2 -2,1 -2,0 -4,2 -3,1 -2,5 -3,8l13 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil86",
    d: "M265 1600l2 -3c2,2 3,6 11,4 2,-3 2,-1 0,-4l-1 -1 -5 0c-1,-5 -3,-5 -4,-10 -1,-7 -2,-5 -4,-11 -6,-3 -4,-8 -10,-2l0 0c-1,7 1,11 0,18l-1 3c1,1 3,-2 7,-2 0,7 -4,9 4,10l1 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil87",
    d: "M260 1565c-7,4 -4,1 -4,1l4 -1zm-25 9c7,-8 40,-7 52,-7l6 2c-2,-4 0,-2 -2,-4l-7 -1c-1,-3 -1,0 0,-4l-4 0 -5 1 0 3c-4,0 -3,1 -6,-2l-14 1c-4,1 -8,2 -12,3 -4,1 -7,2 -11,3 -3,4 -8,4 -13,6 -2,5 0,1 -5,4 -5,3 -5,2 -2,3 4,-2 7,-3 11,-5 5,-3 5,-3 12,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil87",
    d: "M314 1574c0,-1 -1,-1 -1,-1 -1,-3 0,0 -2,-1 0,0 -2,-1 -2,-1l-5 -2c-4,-2 -7,-3 -11,-1l6 3c4,1 7,1 8,4l1 0c4,0 5,2 6,-1l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil88",
    d: "M338 1615c-2,5 0,1 -1,2 -4,6 0,2 -3,7 -4,-2 2,-5 -4,-2l-1 2 -1 3 -10 7 -1 3c3,-4 4,-3 7,-7 1,1 2,1 3,2 1,-3 -2,-2 2,-2 3,4 3,4 -1,5l5 3c-1,4 1,2 -2,4 5,-3 2,-2 4,-7 1,-2 0,-1 2,-2 5,-3 -2,4 1,-1 4,-5 1,-12 0,-17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil88",
    d: "M96 1714c-3,1 -1,1 -2,-1 3,-6 0,1 -1,-5 -4,1 -18,8 -20,11 0,0 1,0 1,0l4 0 2 4c5,-1 13,-5 16,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil88",
    d: "M81 1771c-6,-3 1,-1 -9,-4 -7,-2 -8,-6 -12,-13l-2 -3c-1,3 -1,-1 0,3 1,7 10,18 16,20 3,-2 1,0 4,-2 3,-1 1,1 3,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil88",
    d: "M184 1737c1,-1 1,-3 0,-5l2 -2c-4,-2 1,-2 -4,-5l-4 -2 -4 3c0,1 4,0 4,0 0,0 -1,-1 3,1l1 4c-1,0 -1,1 -3,1 -4,0 -6,-2 -9,-3 3,5 4,2 7,5 0,0 0,0 1,0l1 2c-2,2 1,1 -3,1l4 4c3,-2 4,-1 4,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil89",
    d: "M174 1272c-5,-5 -60,-13 -58,0 4,3 10,1 15,1 6,-1 12,-1 17,0 11,1 19,4 29,8l0 -5c-5,1 -3,2 -6,-2 1,-2 -1,0 3,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil89",
    d: "M356 1450l-6 0c-1,0 -1,0 -1,0 0,0 0,1 0,1 -3,5 -1,0 -4,5l-1 2c5,-1 12,-2 16,-5 -2,-3 0,-2 -4,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil89",
    d: "M322 1324c3,-4 -1,1 3,-2 0,-5 1,1 -3,-5 -1,-1 0,-1 -1,-1 -3,-3 -1,-2 -4,-1 0,4 0,2 3,5 0,0 -2,0 -2,0 -4,1 -1,-2 -3,2 4,2 2,2 7,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M72 1504l2 -1c-3,-5 -1,-1 -1,-6 0,0 -1,-3 -1,-3l-13 -7c-4,3 -10,4 -16,5 8,5 17,-1 23,-1 1,2 1,0 -2,2 5,1 4,0 6,3 -4,5 -4,2 -9,2 -6,1 -3,2 -8,1l-3 1c1,6 1,2 0,8l1 7c-2,-2 -1,0 1,0 11,1 1,1 6,-4 6,-4 6,0 9,-7 0,0 1,-1 1,-1 0,0 0,-1 0,-1 2,2 1,2 4,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M328 1756c-3,-1 -1,0 -2,-2 -2,-1 -2,-3 -8,-4 1,-4 2,-5 3,-9 0,1 0,0 1,1 0,0 4,1 6,4l2 3c0,0 0,1 0,1 1,5 1,3 -2,6zm3 9l6 -8c-1,-5 -5,-4 -2,-9 -2,-5 -2,-3 -6,-5 -4,-2 -3,-3 -6,-5 -2,1 0,1 -2,-1 -4,-1 -3,-1 -3,-2 0,3 0,0 -3,2 0,0 1,1 1,0l5 -1 -5 9c-4,-4 2,-1 -3,-3 -1,5 -1,6 -1,8l5 -1 1 7 4 -1c8,9 5,7 2,12 3,-1 0,0 3,-2l4 -4 0 4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M348 1774c0,0 0,-1 0,-1l2 -2c-1,0 -1,0 -1,-1 -1,-1 -2,0 -3,-4 -1,-5 1,-1 -2,-6l-5 -1c-1,8 -3,8 -7,14l3 6c12,0 3,-3 13,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M359 1809c-7,-1 -9,-4 -14,-5 -4,-1 -11,-4 -14,-2 -1,4 -2,2 2,4 2,2 6,2 8,2l13 3 5 1 0 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M349 1788c0,-4 -1,-1 1,-4l1 -1c4,-4 2,0 4,-6 -9,2 -9,7 -14,8 -2,0 -5,0 -7,-1l1 -4c-4,-2 -3,-1 -4,-4l-2 1 -2 4c2,0 3,0 3,4 4,1 1,0 4,4 5,-1 9,-1 15,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M73 1470c-1,-3 -3,-2 -6,-5 -2,-2 -5,-4 -7,-6l-2 3c3,3 7,4 7,8l4 2 5 5c1,1 3,3 3,3 1,1 0,0 3,1 4,-6 -4,-7 -7,-11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M132 1555l0 -7c-2,-2 0,-1 -3,-1 -4,5 -8,7 -6,12l7 0 2 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M79 1294l-2 1c-5,4 -3,-2 -6,3 1,2 0,1 6,4 3,2 3,2 7,2 1,-6 0,-7 -5,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M75 1554c-4,-1 -5,-6 -7,-9l-7 -1 2 3 2 -2c0,6 0,4 1,5l5 8c0,1 0,2 0,2 3,-1 2,-2 4,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil90",
    d: "M85 1490l5 2c2,-3 2,-2 2,-5 -3,-1 -5,1 -7,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil91",
    d: "M106 1422c0,2 0,6 -5,6 -3,-5 1,0 -1,-5 -2,1 -4,1 -7,-2 1,0 1,0 1,-1 0,0 1,0 1,-1 0,0 0,0 0,0l2 -1c0,0 0,0 0,0 0,0 1,0 1,0l2 -3c2,-5 -1,-9 3,-13 2,3 1,6 2,9 2,-2 1,0 2,-3 -2,-6 -3,-14 -7,-17 -5,6 -1,20 -9,28l-4 -4 1 8 3 -3 6 20c3,7 2,0 5,11l2 -1c3,-4 3,-23 2,-28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil91",
    d: "M65 1470c0,-4 -4,-5 -7,-8l-7 2 3 1c0,4 -1,8 -2,11l8 0c8,0 -3,-2 7,-2l-2 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil92",
    d: "M198 1598c1,5 0,1 2,3l2 1c1,0 0,1 7,1l-2 -7c-3,-1 -6,0 -9,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil93",
    d: "M183 1290c-3,-4 -7,-4 -12,-2l0 -4c-2,6 0,2 -3,4 -4,-2 -2,1 -4,-4l-1 4 -9 -1 3 -4c8,2 0,1 4,2l1 -4c-10,0 -20,3 -30,4 -5,1 -23,3 -20,11 4,1 29,-4 34,-5 13,-2 24,-2 37,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil93",
    d: "M65 1309l1 -6c-4,-1 0,1 -2,-2 -1,-2 3,-1 -2,-2 -3,-1 -4,1 -6,2l3 12c4,2 3,0 6,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil93",
    d: "M327 1342c-1,-1 -2,-2 -3,-3l0 6 0 6c4,0 7,-1 10,-3l-3 -5c0,-2 3,-1 0,-3l-4 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil94",
    d: "M269 1562c2,-2 0,1 0,-2 0,-5 -2,3 0,-1l6 0 0 -5c-5,0 -3,1 -6,-1 0,-5 -1,-1 2,-4 2,-3 2,0 1,-5 -2,-3 -4,-1 -8,-1 -6,1 -4,-2 -8,2l8 0c2,4 0,5 0,5 1,2 2,1 3,7 -5,2 -3,4 -7,5l-5 1 14 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil94",
    d: "M317 1564l-1 -3 0 -5c-1,0 -1,1 -2,3l-1 1c-1,3 0,5 -3,6 0,0 -1,0 -1,0l-5 -2c-1,3 -1,2 0,5l5 2c6,-1 6,-3 8,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil95",
    d: "M203 1426c-4,-1 -2,-1 -3,-2 2,-3 -1,0 3,-3 -10,1 -17,1 -27,0 -9,0 -24,-4 -22,7l6 1 -1 -6 10 0c3,1 3,1 3,1 -3,5 0,-2 -6,4 7,0 34,1 37,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil95",
    d: "M229 1278c-2,-3 -7,-6 -11,-6 1,4 2,12 5,15l1 -7 5 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil95",
    d: "M164 1441l-12 2c0,2 0,1 1,4 1,3 1,1 2,2 4,0 2,0 5,-1 -4,-2 -3,0 -3,-6l6 1 1 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil96",
    d: "M303 1660c2,-2 2,-1 3,-4l-2 -1c-5,1 -3,1 -6,-2 -1,4 0,3 -2,6l-2 -3 0 5 1 1c4,1 4,0 8,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil96",
    d: "M309 1636c-7,0 -2,1 -4,-2l2 -1c-15,7 -6,-1 -13,3l2 5c8,1 8,-3 13,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil96",
    d: "M289 1605l1 1 -1 3 -6 2 -1 1 4 1 3 0c1,-3 3,-5 0,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil96",
    d: "M222 1633c-4,1 -3,0 -3,4 3,2 2,1 6,2 3,-4 -3,-1 2,-4l-5 0 0 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil97",
    d: "M92 1581c6,-9 7,-48 -2,-57l0 5c-3,-1 -2,1 -3,-5 -3,-14 -4,-6 -7,-13l-3 1 0 4 3 2 -2 10c3,-4 3,-3 9,-5 -3,12 -3,6 -5,11l-3 11c6,0 2,-1 4,3l1 -4c1,-1 1,-1 1,-2 -1,0 0,-2 -1,1 0,7 0,2 1,4 5,-7 0,-5 4,-13 5,6 2,1 3,9 1,11 0,22 -3,31l0 4c0,2 0,4 0,6 2,-4 0,-1 3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil97",
    d: "M185 1446l0 -6 7 -1c-1,7 0,3 -5,7 6,-1 14,-1 19,-5l16 -9c0,0 0,0 0,0 6,-2 2,-2 4,0 -1,2 0,1 -1,4 5,-1 2,1 4,-2 -4,-1 -4,-3 1,-5 1,0 2,-1 3,-1 1,0 1,0 2,0 -1,3 0,1 -1,3l-3 3c7,-1 15,-5 20,-9 -6,2 -10,5 -16,6l2 -5c-11,1 -23,6 -34,8 -10,3 -24,4 -33,6 1,2 2,2 0,5 -2,2 0,0 -2,1 -2,1 0,-1 -2,2l19 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil97",
    d: "M156 1308l-1 -2 1 -4c-8,2 -37,8 -39,15 5,4 13,-1 19,-3 6,-2 15,-4 20,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil97",
    d: "M75 1535c-3,1 0,0 -5,1 2,-9 4,-6 5,-13 -3,1 -4,0 -5,0 5,1 3,4 -1,6 -1,-2 -1,0 -2,-4 -1,-1 -1,-4 -1,-5 0,-6 2,-2 4,-5l-8 3 1 -4c-9,5 -12,4 -11,8 1,2 -1,0 1,0 6,2 -2,-1 2,0 0,5 0,4 -4,6l2 2c2,0 1,3 3,-1l-1 -1 2 -2c3,-2 3,-3 7,-5 4,9 1,10 6,10l-1 6 -1 7c4,-2 2,1 5,-5 0,0 1,-4 2,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil97",
    d: "M73 1285c4,-2 9,-8 10,-12l-2 -3c-4,1 -12,6 -15,8 5,2 -4,2 3,8 4,3 3,1 3,0 2,-2 -2,-3 1,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil98",
    d: "M90 1524c0,-6 -5,-8 -6,-13l-3 -3c0,0 -2,-3 4,0l6 1 -1 -15 -3 4c-1,3 0,1 -2,3 -2,-1 -3,-1 -3,-3 0,-2 1,-3 1,-4l-1 -3 0 -2c-3,-1 -6,-3 -9,-4 -4,-2 -5,-2 -10,-4 -2,-1 -5,-2 -8,-3 -5,-2 -3,-1 -6,-4l-2 1c1,6 1,2 -1,3l0 2c4,0 9,4 13,7l13 7c0,0 1,3 1,3 0,5 -2,1 1,6 5,-1 2,-2 6,1l-2 5 2 2c3,7 4,-1 7,13 1,6 0,4 3,5l0 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil98",
    d: "M294 1343c3,-2 1,-2 0,-7 7,-1 3,1 6,-5 2,-4 2,-3 4,-3l3 -5 -1 -3c-2,1 -4,2 -5,2 0,0 0,0 0,1l-1 -4c-5,-3 4,0 -2,0 -2,0 0,-1 -2,-4 -3,2 -2,-1 -3,4 0,0 0,0 0,0 0,-1 1,-1 1,0 3,1 3,-2 2,7 -3,-1 -3,-1 -5,-3 1,6 1,4 0,10 -1,6 1,4 0,11l3 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil99",
    d: "M336 1468c4,-6 0,-2 5,-6 3,2 0,-1 3,4 2,0 1,0 2,-2l-2 -6 1 -2c-3,0 -6,0 -6,-5 1,-3 1,-1 2,-2 3,-3 0,4 2,-2l0 0c-6,2 -6,1 -11,1 -1,-5 0,-3 -3,-3l-2 1c-3,3 0,0 -2,4 -2,6 2,4 -5,4l3 0c-1,4 0,1 -2,4 3,5 -1,21 4,26 5,-3 4,-14 11,-16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil99",
    d: "M293 1374c0,3 0,3 2,6l2 0 4 -6 3 1c0,-3 1,-1 -1,-4 -1,-3 -1,-2 -2,0 1,-3 1,-3 0,-5 -3,1 -1,-1 -3,2 -1,0 -2,3 -2,4 -1,-5 -1,-3 -2,-3l-1 5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil100",
    d: "M273 1349c-1,6 4,12 4,18 5,4 3,10 6,14 5,1 2,2 4,-1 0,4 -2,3 0,9 4,-4 3,-1 2,-7 0,-4 1,-6 1,-8 -1,-11 -15,-40 -15,-45 -3,4 -4,2 -3,6l4 13c-6,3 0,-1 -3,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil100",
    d: "M193 1339c1,-5 1,-6 1,-11l-3 -2c-8,-1 -12,-1 -17,7l2 4c10,6 2,7 17,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil100",
    d: "M214 1407c0,-5 2,-7 -2,-11 -7,-3 -10,1 -15,6l3 8c5,2 6,2 12,1l2 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil100",
    d: "M267 1300l0 -1c-4,-2 -2,-1 -7,-2 1,5 0,7 1,11 0,1 0,1 0,1l1 3c1,2 -1,1 3,4 2,-4 1,-6 1,-10 -1,-3 -1,-2 -1,-4 1,-2 0,-1 2,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil101",
    d: "M107 1410c-3,3 0,6 -1,12 1,5 1,24 -2,28 -1,8 -8,19 -12,21 -5,1 0,1 -6,2 -1,-4 0,-4 -3,-6l-1 3c-4,-2 -6,-2 -9,0 3,4 11,5 7,11 -3,-1 -2,0 -3,-1 0,0 -2,-2 -3,-3l-5 -5c-2,4 -2,2 -5,4l-1 1c2,1 6,0 8,2l-2 1c0,0 0,0 0,0 -1,0 -1,0 -1,0 -1,1 -4,0 -5,1 5,2 6,2 10,4 3,1 6,3 9,4 4,-3 10,-14 12,-15 3,-4 3,-2 7,-7 12,-20 9,-33 6,-57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil101",
    d: "M89 1584c0,-2 0,-4 0,-6l0 -4c3,-9 4,-20 3,-31 -1,-8 2,-3 -3,-9 -4,8 1,6 -4,13 -1,-2 -1,3 -1,-4 1,-3 0,-1 1,-1 0,1 0,1 -1,2l-1 4c0,5 -9,12 -10,19l3 1c-1,-2 -1,-2 -1,-5 5,-1 6,5 7,5l2 -1c2,0 -1,0 1,1 0,1 3,4 -3,3 -1,0 -5,-2 -6,-3 2,6 3,2 8,12 3,4 -1,1 4,6l1 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil101",
    d: "M298 1722c2,2 2,3 2,4 0,1 0,1 -1,1l-12 0c0,2 1,2 -1,4l-2 -2c1,5 1,9 4,14l5 9c3,4 2,5 6,7 0,-4 0,-4 0,-7 -1,-5 -1,-4 -3,-5l3 -2c0,-5 0,-9 1,-13 0,-4 3,-9 -2,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil101",
    d: "M55 1528l1 1c5,3 1,5 6,10 4,-3 4,-7 0,-12l-7 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil102",
    d: "M314 1543c-11,-3 -17,-6 -29,-7 -12,0 -22,1 -34,2l-7 1 -1 4 -1 4 14 -2c4,-4 2,-1 8,-2 4,0 6,-2 8,1l3 -3c3,1 6,4 7,6 5,-2 6,-2 11,-2 2,-3 4,-2 9,-2l1 3c2,-1 5,0 6,0 2,1 -1,3 6,1l-1 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil102",
    d: "M304 1569c-1,-3 -1,-2 0,-5l5 2c0,0 1,0 1,0 3,-1 2,-3 3,-6 -6,2 -1,1 -3,-1 -1,-2 1,-1 -1,0l-1 0c-2,-5 -2,0 -1,-6l-4 2c-3,0 -6,-1 -8,-1 -5,-1 -5,1 -7,-2 -2,2 -1,0 -2,3 0,0 0,3 -1,3 3,0 2,1 3,0l9 7 -6 0c2,2 0,0 2,4l-6 -2c2,3 8,4 12,4l-6 -3c4,-2 7,-1 11,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil102",
    d: "M275 1561l0 -2 -6 0c-2,4 0,-4 0,1 0,3 2,0 0,2 3,3 2,2 6,2l0 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil103",
    d: "M289 1640c-1,-7 4,-7 10,-7l0 -3c-1,-4 -1,-3 -5,-4 -1,3 0,1 -1,2 -1,0 -1,0 -1,0l-8 4c-5,1 -4,-2 -11,-4 -4,3 -3,5 -11,5 -1,3 -2,5 -5,2 3,2 2,0 8,1 0,6 -1,4 -7,7l-3 2c-3,-2 -3,-3 -6,-7 0,0 0,-1 -1,-1l-4 1 -5 1c3,4 4,5 9,6 4,1 9,0 13,0 4,1 24,-3 28,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil104",
    d: "M42 1496c-4,-2 -2,0 -3,-3 2,-1 -1,-1 4,-1 6,-1 12,-2 16,-5 -4,-3 -9,-7 -13,-7 -5,5 -7,6 -14,11 2,4 5,7 8,10l2 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil104",
    d: "M364 1769c-3,2 -4,1 -8,0 3,4 3,1 7,4 -1,1 1,4 -8,4 -2,6 0,2 -4,6l-1 1c-2,3 -1,0 -1,4l14 1c0,-8 4,-10 7,-16 -3,-3 -3,-3 -6,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil104",
    d: "M312 1755c-2,-4 0,-1 -3,-4l-2 -3c-2,-2 0,0 -2,-2 0,4 1,7 1,10 0,4 -1,5 0,11 5,-3 6,-6 6,-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil104",
    d: "M155 1557c-5,1 -2,1 -4,3l2 3c4,-3 4,-3 2,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil104",
    d: "M350 1471l-3 5c3,2 0,2 5,2l-2 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil105",
    d: "M92 1581c-3,2 -1,-1 -3,3l-1 2c-5,-5 -1,-2 -4,-6 -5,-10 -6,-6 -8,-12l0 0 -3 -1c1,-7 10,-14 10,-19 -2,-4 2,-3 -4,-3 -2,3 1,-1 -1,2l-3 7c-2,4 -1,5 -4,6 0,0 0,-1 0,-2l-5 -8c-1,-1 -1,1 -1,-5l-2 2 -2 -3c0,0 -1,1 -1,1 0,-1 -1,0 -2,1 6,8 9,5 11,19 2,0 1,0 2,1 1,0 2,2 2,2 3,3 4,2 2,3 3,6 7,8 8,15l2 4 3 -2c3,-2 3,-4 4,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil105",
    d: "M327 1446c-5,-4 -12,-3 -18,-5l-1 3 -3 0c3,4 12,12 16,14 2,-3 1,0 2,-4l-3 0c7,0 3,2 5,-4 2,-4 -1,-1 2,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil106",
    d: "M191 1724c-7,-3 -9,-5 -18,-6 -6,0 -14,3 -20,0 -8,-4 -1,-5 1,-8 1,-5 1,-2 -1,-7l3 -1 3 -2 5 -3 0 -4 0 0c-3,-1 -3,-1 -6,-2l-19 6 -1 2 2 0 -2 2 8 -1c1,3 0,0 0,2l2 8 -2 -1c-4,-2 -1,-2 -1,-2 -3,1 -4,0 -4,1 -1,0 -1,0 -1,0l4 3c-1,2 3,2 -3,2 3,2 7,0 8,-1l-4 7 14 8c-1,-5 -2,-1 1,-4 2,1 2,2 2,-1 -1,1 -2,3 -4,-1 8,0 12,-5 19,1 -3,0 -11,0 -11,0 2,4 -1,4 4,7l0 -4c3,-2 2,0 1,-3l7 1 4 2c5,3 0,3 4,5l-2 2c1,2 1,4 0,5 3,0 4,0 5,2l11 1c-4,-3 -1,-1 -9,-1 0,-3 0,-1 1,-4 0,-2 0,0 1,-1 -6,-3 -2,3 -5,-4 -1,-4 2,-5 3,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil106",
    d: "M310 1610l-5 0c5,-7 8,-4 12,-9 1,-1 0,-1 2,-3l0 3 3 3 0 -4c-3,-2 1,-10 1,-14 0,-4 -1,-4 -3,-7 -3,-4 -1,-3 -6,-5 -1,3 -2,1 -6,1 4,6 5,-2 9,7 2,8 3,12 -3,18 -2,3 -6,5 -8,7 -3,2 -2,1 -5,3 -3,2 -8,3 -12,3l-3 0c-8,3 -4,5 -17,6 -7,0 -13,1 -20,1l0 1 27 -2c-4,10 -14,2 -22,7 7,0 10,0 17,-1l9 -1c0,0 0,0 0,0l3 -1c7,-2 22,-8 27,-13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil106",
    d: "M157 1760c-4,-6 -3,-7 -5,-11l-2 -1c-4,-4 -2,-4 -4,-8 -1,1 0,1 -3,2l-2 0c0,5 3,9 -1,11 -3,2 -2,0 -3,-1 -1,-1 -1,2 -1,-2l0 3 2 5c1,-3 -1,-2 3,-2 3,3 5,6 9,9 5,3 2,1 6,4 2,1 4,2 7,3l-2 -5c-3,-7 -4,-3 -4,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil106",
    d: "M92 1657c0,-3 0,-4 4,-4 2,1 2,2 6,3 0,-4 -1,-5 -3,-7l-2 -1c-5,-2 -2,-3 -4,-5 -10,0 -7,12 -7,18l3 3c0,-2 2,-5 3,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil106",
    d: "M206 1734l-12 -1c3,-5 3,-3 0,-9 -1,1 1,2 -3,0 -1,1 -4,2 -3,6 3,7 -1,1 5,4 -1,1 -1,-1 -1,1 -1,3 -1,1 -1,4 8,0 5,-2 9,1l7 0 -4 -3 3 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil106",
    d: "M102 1676l3 -6c0,-1 -1,0 -1,-1 -2,-5 1,1 -5,-1 -2,-2 -2,-2 -5,-3 0,3 4,11 8,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil106",
    d: "M181 1743c2,2 1,1 2,2 1,-2 2,0 0,-3 -5,-2 -1,-1 -2,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil107",
    d: "M329 1603l3 -4c2,-6 7,-6 12,-6 -2,-2 0,-1 -4,-2 -1,0 -1,0 -1,0 -13,-1 -6,-1 -9,-4 -5,-4 -4,1 -6,-12 11,2 8,4 9,5 -6,3 -6,-1 -8,3 5,2 0,0 6,-1l13 -3c0,0 1,0 1,0 0,0 0,0 1,0 0,0 0,0 0,0l3 0c0,0 1,1 1,1 9,3 2,0 10,5 -2,-9 -5,-11 -15,-9 -13,2 -10,-3 -16,-3l-4 -3 -6 -4c-4,2 -4,3 -5,8l0 0c5,2 3,1 6,5 2,3 3,3 3,7 0,4 -4,12 -1,14 3,2 3,3 7,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil108",
    d: "M196 1393c0,-8 6,-5 1,-11 -2,-3 -3,-4 -4,-7 0,-4 -1,2 0,-3l3 -7 4 1 1 -2c-6,0 -1,-1 -4,-1 -2,0 1,2 -3,0l0 -3c4,-3 1,-1 7,-1l-1 4 3 -3c2,3 -1,13 -1,17 5,0 16,-5 19,-8 -6,-5 -7,1 -16,-13l-4 -3c0,0 3,3 1,-4 -3,3 3,3 -7,3 2,7 -2,3 -3,8l-3 -1 -1 2c1,2 0,0 2,2 4,4 0,3 -3,5 4,1 4,1 1,5 -1,0 -1,2 -2,-2 0,6 -1,3 2,5 1,2 1,-3 1,6l1 3c-2,4 0,5 1,10 -2,0 -7,-2 -9,-2 -7,-2 -3,2 -10,2l1 3c6,-4 5,2 9,-4 -1,4 -1,3 2,5l4 0 1 -3 2 4c0,0 0,0 0,0 4,-2 0,1 3,-3 1,-3 -1,-1 2,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil108",
    d: "M180 1363l0 0 1 -2c0,-7 0,0 2,-5 2,-4 -2,-4 5,-8 4,-3 2,0 3,-5 -4,2 -5,1 -11,0 -5,-1 -5,-3 -7,-7l-1 -1 -3 0c1,3 0,3 -1,5 2,5 -1,5 -2,10l4 4c-5,3 -2,-3 -5,1l5 4c4,3 5,2 4,8 3,-3 0,-5 3,-8l3 4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil108",
    d: "M196 1407l-1 -5 -4 1c2,2 1,1 0,5l5 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil109",
    d: "M333 1863c-1,-1 0,0 -1,-2 -1,-1 -1,-2 -2,-3 -1,-3 -1,-1 -2,-5 -4,-4 -5,-9 -5,-16 6,3 3,2 6,7l2 0c-1,-4 -5,-9 -3,-13 3,1 3,2 5,5 7,0 3,3 9,0 2,0 1,0 3,-1l1 4c0,0 0,0 0,0l-1 3c0,0 1,0 1,0 1,1 11,6 3,13 0,2 -1,5 -1,7l5 2 -3 -6c1,-3 5,-6 5,-9 1,-2 -1,-8 -1,-12 -9,2 -5,-5 -18,-11 -2,-1 -2,-1 -4,-2 -4,-3 -5,-5 -6,-8l-3 2c-1,4 -2,8 -2,13 0,2 0,4 0,6 1,5 2,6 -1,8 2,6 12,26 17,30l2 0c-1,-5 -1,-2 -3,-6 -1,-2 -2,-4 -3,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil109",
    d: "M104 1450l-2 1c-3,-11 -2,-4 -5,-11 1,6 4,13 -2,16l-2 -7c-9,-3 2,-4 -7,-4 3,-9 -4,2 0,-9 0,0 -1,0 -2,0 -3,-1 0,0 -2,-1 0,-5 1,-9 6,-8l0 -4c-13,7 -7,4 -12,16 6,3 2,6 8,16 5,8 6,4 8,16 4,-2 11,-13 12,-21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil109",
    d: "M354 1811l-13 -3 -5 0c0,0 0,1 0,1l1 4c-3,0 -2,0 -4,2l18 15c0,0 0,-1 0,-1l-1 -1c-6,-8 -1,-5 0,-9 0,-2 -1,-3 -1,-7l5 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil110",
    d: "M273 1628c8,-3 16,-4 25,-6l-4 4c4,1 4,0 5,4 10,-6 2,-2 7,-8 7,-2 4,2 11,-2l-6 -4c1,-9 4,-7 12,-9l0 3c0,3 -1,-1 0,2 4,-1 -3,2 2,-1 2,-1 -2,0 1,0l1 9 1 0c2,-6 -1,-9 -2,-15l3 -1 0 -1c-4,0 -4,-1 -7,-3l0 4 -3 -3c-4,5 -5,6 -9,9 -5,5 -20,11 -27,13l-3 1c0,0 0,0 0,0l-9 1c-7,1 -10,1 -17,1 -5,2 -4,1 -8,-1 -3,0 -4,1 -8,1l-1 5c2,1 2,1 4,2 4,-1 9,0 12,-1 4,-1 -1,-2 5,-1 1,0 3,1 4,2 8,0 7,-2 11,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil110",
    d: "M198 1598c3,-2 6,-3 9,-2l2 7c-7,0 -6,-1 -7,-1l-2 -1c-2,-2 -1,2 -2,-3zm2 15c-2,-5 -2,-3 -3,-9 8,3 0,1 11,6 2,1 2,1 2,1 1,0 3,4 4,5 8,-2 6,-2 6,-4 -3,-3 -5,-2 -9,-2l-2 -4c10,-5 7,-3 8,-6 -3,-3 -4,-6 -6,0 -1,-4 0,-3 0,-7 -1,-8 1,-1 1,-6 -9,-2 -2,0 -10,3l-3 1c-4,2 -6,6 -6,12 3,4 4,6 2,12l0 0 1 0 0 -2 4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil111",
    d: "M255 1342l2 -9c0,0 -1,1 1,3 1,2 -1,0 2,2 8,5 -6,-1 2,1 2,-5 1,-5 1,-9 0,-6 -9,-29 -12,-36l-4 1 -1 -3c-1,4 0,4 -2,5l-2 -2c-1,-6 1,-3 -4,-4l2 18c-5,-4 -3,-2 -4,-8l-1 -7c0,0 0,0 0,1 0,0 0,0 -1,1 -3,10 3,19 4,26 -1,-3 -1,-1 1,-2 -1,-1 -1,-2 -2,-2 1,-1 1,-1 1,-1 4,-3 4,-6 4,-5 0,0 0,-1 0,-1l1 6c4,-4 1,-4 5,-1 -1,-7 -1,-3 1,-8 0,-1 1,-4 1,-4 0,0 0,0 0,-1l2 -2c3,10 4,16 4,27l0 0c0,3 -2,2 -3,9l-1 3c-8,1 -7,-1 -6,5 1,-3 -1,-5 4,-3 0,1 -1,3 -1,3l0 1c0,0 0,1 0,1 -1,2 -1,2 -1,5l1 -6c0,0 2,2 2,3l1 1c2,3 4,8 4,12 2,-5 0,-6 0,-6 -2,-4 -2,-10 -1,-14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil111",
    d: "M216 1302l2 1 5 1 0 -1c0,-7 4,2 0,-8 -6,-3 -6,-1 -7,0 -1,2 -3,5 0,7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil111",
    d: "M69 1565l-1 4 7 2c2,-1 1,0 -2,-3 0,0 -1,-2 -2,-2 -1,-1 0,-1 -2,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil112",
    d: "M277 1367c0,-6 -5,-12 -4,-18l-10 -19c0,4 1,4 -1,9 -8,-2 6,4 -2,-1 -3,-2 -1,0 -2,-2 -2,-2 -1,-3 -1,-3l-2 9c0,0 1,4 1,4l7 13c5,-2 -2,-1 3,-1 0,0 7,1 3,9 0,0 3,1 3,1 1,4 3,9 4,14 5,-8 0,-8 1,-15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil112",
    d: "M327 1325l-1 7c5,-2 3,-2 5,-6 0,5 -1,8 -2,11l3 0c0,0 1,0 1,0 4,1 -1,-2 2,1 0,0 0,0 0,0l2 2c0,-9 1,-2 4,-8l1 4c1,-3 0,-3 3,-5l-2 7c7,-2 2,-3 6,3 0,0 -3,1 -4,2 -3,3 1,3 1,3 6,-5 2,-2 5,-3 -1,-6 1,-6 1,-10 -4,0 -1,-1 -5,3 2,-5 2,-3 1,-8 -4,3 -1,6 -4,1 -3,-4 -2,-6 -3,-8l-3 8c-1,-3 1,-2 -5,-12l-1 6c-6,-1 -5,1 -5,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil112",
    d: "M90 1494l0 -2 -5 -2 -3 1 1 3c0,1 -1,2 -1,4 0,2 1,2 3,3 2,-2 1,0 2,-3l3 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil112",
    d: "M305 1726c0,-5 -2,-3 -1,-9l-10 1 -1 1c3,1 1,0 2,2l0 -1 6 1 2 6 2 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil113",
    d: "M206 1641l-1 -2 3 0c5,1 16,6 21,4l0 -2 0 0c-2,-1 -2,-1 -4,-2 -4,-1 -3,0 -6,-2 0,-4 -1,-3 3,-4l4 0 -3 -5c-5,-5 -6,-5 -19,-9 -6,-2 -5,0 -8,-4l-1 0c1,19 7,30 22,39 1,-4 1,0 5,-5 -6,-3 -14,-4 -16,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil113",
    d: "M319 1654c4,-6 6,-3 11,-8 -6,2 -1,1 -3,-1 3,-4 1,-2 4,-3 3,-2 1,0 2,-4l-5 -3 -1 -3c-1,-1 -2,-1 -3,-2 -3,4 -4,3 -7,7l-1 0c-1,4 1,6 -2,7l0 1 -1 7c-3,2 -1,2 -4,1l-2 3 -2 4 14 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil113",
    d: "M294 1661l0 -5c-1,-3 -2,-8 -3,-9 -6,0 -10,1 -14,4 -3,4 -3,3 -4,8l1 0 1 3c2,-2 0,-1 3,-1 7,-1 6,-6 6,-6 0,0 0,0 0,-1 4,4 3,3 8,2 -1,3 -1,1 -5,4l7 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil113",
    d: "M262 1517c-7,0 -29,2 -34,5 -3,4 1,0 -3,3 -1,1 0,0 -1,1 0,0 35,-6 38,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil114",
    d: "M239 1386c2,2 1,-2 2,4l1 -4c2,-5 -4,2 1,-1 0,0 0,0 0,0 0,1 1,0 1,0 -1,-3 -1,-3 -3,-5l6 1c-2,-13 -3,-6 -9,-10 2,-9 0,-3 0,-6 -1,5 -1,4 -7,5 1,3 1,-1 1,4l-4 0c-1,2 0,6 0,7 -5,-2 -3,-1 -5,-3 -3,8 3,8 -2,10l-1 -5c-4,4 1,2 -5,1 -2,0 -2,0 -5,4l1 3c3,0 6,-2 8,-1 3,1 3,3 3,5l3 0c-5,-12 7,-9 14,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil114",
    d: "M233 1356l3 0c0,0 0,0 0,0l2 0c-7,0 -1,0 -4,-2 0,-7 0,-3 -3,-8l-4 2 2 2c-4,0 -3,0 -8,-2l3 7c1,0 0,0 2,1 2,1 1,0 3,1l0 1 4 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil114",
    d: "M235 1366c1,-4 -1,-6 -5,-6l1 1c-4,-1 -3,-1 -6,1 1,4 0,1 2,5l8 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil115",
    d: "M97 1778c0,0 0,-3 0,-4 7,1 7,1 8,9l-7 -1 -1 -4zm16 7l-4 -4c-3,-3 -5,-5 -7,-9 -3,-3 -9,-5 -13,-8l1 -6c-6,-5 -12,-5 -15,-9l-13 -4c-4,1 -1,3 -6,0l-12 -7c-6,-4 1,-3 -8,-1 -1,4 -1,1 1,2 6,0 16,12 21,15 -1,-4 -1,0 0,-3l2 3 0 -5c1,0 2,0 4,0 0,0 0,0 1,1l6 5c2,-1 1,-6 7,0 2,1 0,1 2,3 1,1 4,1 6,10 -5,2 4,-1 -2,0 -4,1 -2,-1 -3,3 -2,2 0,0 -3,1 -3,2 -1,0 -4,2 5,7 26,12 35,12l4 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil115",
    d: "M137 1752c0,-8 -5,-12 -6,-22 4,0 6,2 10,3 4,2 5,3 5,7 2,4 0,4 4,8l2 1c4,-5 0,3 4,-3 -1,-9 -9,-15 -17,-18 -8,-3 -14,-8 -21,-13l2 -2c3,-6 4,1 4,-6 -3,1 -6,1 -9,1 0,0 -5,0 -5,0 -4,-1 -1,3 -3,-2 -3,2 -5,3 -6,8 11,-1 9,-3 16,5 3,3 8,6 9,10l2 1c1,7 5,14 7,22 -1,2 -1,1 1,1l0 -3c0,4 0,1 1,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil115",
    d: "M138 1701c-2,3 -5,6 -7,8l2 3 8 1c6,0 2,0 3,-2l-4 -3c0,0 0,0 1,0 0,-1 1,0 4,-1 0,0 -3,0 1,2l2 1 -2 -8c0,-2 1,1 0,-2l-8 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil115",
    d: "M135 1655l-5 -1c0,-5 1,-3 -2,-6 -5,0 -4,0 -5,3 3,5 -4,4 5,6 2,0 2,-1 5,1 2,1 1,0 2,2l2 -2 -2 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil116",
    d: "M247 1439l-7 3c0,-3 2,-4 3,-6 -4,2 -27,13 -28,14 -3,3 -2,2 -6,4l-11 4c0,0 -1,1 -2,1l-3 1c-8,4 -15,5 -19,10l2 1c12,-1 63,-23 71,-32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil116",
    d: "M63 1276c-2,-4 -5,-7 -7,-10 -3,-4 -3,-7 -7,-7 -3,6 1,20 2,27l2 -3c0,0 1,-1 1,-1 1,-2 0,-1 0,-2 6,3 6,-2 9,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil116",
    d: "M202 1284c-4,-5 -21,-11 -28,-12 -4,2 -2,0 -3,2 3,4 1,3 6,2l0 5 -1 0c5,3 3,5 10,3 4,0 7,1 10,3l2 -3c2,-1 1,0 4,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil116",
    d: "M53 1299l-1 -2c4,-1 2,1 4,-1 -1,-2 0,-1 -3,-2l-3 -2c-6,5 -4,3 -5,1 -6,4 -2,1 -5,6 -2,3 -4,2 -3,6 4,0 13,-4 16,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil116",
    d: "M79 1294l-5 -6c-2,2 -2,1 -6,2 -1,5 -1,5 3,8 3,-5 1,1 6,-3l2 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil116",
    d: "M160 1429l6 -1c6,-6 3,1 6,-4 0,0 0,0 -3,-1l-10 0 1 6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil118",
    d: "M211 1391l-1 -3c3,-4 3,-4 5,-4 6,1 1,3 5,-1l1 5c5,-2 -1,-2 2,-10 2,2 0,1 5,3 0,-1 -1,-5 0,-7l4 0c0,-5 0,-1 -1,-4 -6,2 -9,3 -15,6 -5,2 -10,5 -16,5 -3,-6 -1,-8 0,-15l-4 -1 -3 7c-1,5 0,-1 0,3 1,3 2,4 4,7 5,6 -1,3 -1,11l7 0c4,0 5,0 9,1l-1 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil118",
    d: "M250 1412c1,-3 0,-7 3,-8 2,-2 2,-1 4,-2 0,0 3,-1 4,-2 -1,-3 -1,-3 -3,-5 0,0 1,2 0,2 0,2 0,2 -1,3 -5,-1 -4,-3 -5,-8 0,0 -1,0 -1,-1 -1,-4 0,0 -1,0l-5 -4c1,-4 2,-2 3,-3l-1 -3 -6 -1c2,2 2,2 3,5 0,0 -1,1 -1,0 0,0 0,0 0,0 -5,3 1,-4 -1,1l-1 4c-1,-6 0,-2 -2,-4 0,9 -4,10 -13,10 3,3 3,3 8,1 6,-3 -1,-1 6,-4 0,0 3,3 3,3 2,2 1,0 2,3l2 8c0,0 0,0 0,0l-3 2 0 3 2 0 4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil118",
    d: "M184 1399c-3,-2 -3,-1 -2,-5 -4,6 -3,0 -9,4l-1 -3c-4,-4 -3,1 -4,-3l-3 0c5,12 10,9 13,16 0,2 0,0 1,0 3,1 5,1 7,3 -3,-5 3,-7 3,-6 0,0 1,0 1,0 -7,-4 -1,-2 -6,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil118",
    d: "M200 1363l1 -4c-6,0 -3,-2 -7,1l0 3c4,2 1,0 3,0 3,0 -2,1 4,1l-1 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil119",
    d: "M285 1401l1 -9 -3 -11c-3,-4 -1,-10 -6,-14 -1,7 4,7 -1,15 -1,-5 -3,-10 -4,-14 -3,3 -3,4 1,12 1,4 7,1 3,13l2 -1c3,0 0,-2 2,1 2,2 0,3 -1,6 -1,5 3,6 -2,8l0 -9c0,0 -1,-3 -3,3l-2 -4c-2,1 0,3 -3,6 -2,-8 3,-5 0,-11 -2,-3 -2,-2 -4,-6l-1 -1c0,0 0,-1 0,-1 0,0 0,0 0,0l-2 -2c-1,-1 -1,-2 -2,-4l-1 6c-4,-5 0,-6 -6,-9 1,6 5,14 5,20 2,2 2,2 3,5l2 10 3 -1 3 7c1,-3 1,-3 -1,-6 0,-2 -2,2 0,-4 2,-6 0,-1 3,-4 0,3 -1,4 1,7 4,5 1,-5 3,2 0,0 1,0 1,0 -2,6 0,8 -2,13 -1,3 -2,6 -4,10 5,0 5,0 7,-6 1,-3 2,-6 3,-9 1,-5 2,-14 5,-18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil119",
    d: "M344 1378c1,-2 1,-3 1,-3l0 -3c0,0 0,0 0,-1l-2 2c0,-1 -3,-6 2,-7l5 0c2,0 4,2 5,2l7 -21 -5 2c6,-4 -3,3 -3,15 -3,-4 0,-2 -3,-5l-2 -4c0,1 -2,8 -6,5 0,-2 1,-7 0,-7l-2 0c-1,0 -1,0 -1,0l2 -3 -1 -6c-5,4 -2,2 -2,5 0,4 1,1 -1,6l-3 -2 -3 11 -1 4c2,1 2,-1 1,6 6,-5 -1,-6 5,-8l1 0c1,-2 0,-1 1,-2l2 5c-4,5 -3,0 -4,8 -1,-1 -1,1 -3,-4 0,4 1,2 -2,5 0,0 0,0 0,0l1 -2 -4 0 -1 -3c-2,3 -3,4 -3,7 6,2 -1,-1 3,0 3,0 -2,-4 3,0l13 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil119",
    d: "M202 1477l-3 -2 -3 5c-1,0 -1,0 -1,0 -1,-1 -2,-1 -5,0l2 -6c-4,1 -8,3 -12,5 -5,3 -6,3 -6,9 7,-1 24,-7 28,-11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil120",
    d: "M216 1302c-3,-2 -1,-5 0,-7 1,-1 1,-3 7,0 4,10 0,1 0,8 3,-4 1,-2 4,-4 -1,0 -1,-1 -1,-1 -1,0 -1,-1 -1,-1 0,0 -1,-1 -1,-1 4,-11 3,-3 5,-9 2,0 -2,1 6,2 2,1 0,1 3,1 2,0 0,-1 3,-1l1 6 2 2c2,-1 1,-1 2,-5l1 3 4 -1 0 -1 -2 -3 -20 -12 -5 2 -1 7 0 4c-7,0 -15,-4 -21,-7 -3,0 -2,-1 -4,0l-2 3c-3,-2 -6,-3 -10,-3 -7,2 -5,0 -10,-3l-14 0 -1 4c-4,-1 4,0 -4,-2l-3 4 9 1 1 -4c2,5 0,2 4,4 3,-2 1,2 3,-4l0 4c5,-2 9,-2 12,2l29 6c-4,2 -13,-2 -18,1l14 1c-2,3 -2,3 -5,5l0 -1c0,0 1,-1 0,0 0,0 -1,0 -2,4l15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil120",
    d: "M307 1307c-4,0 -2,-1 -3,4 -1,4 -1,1 0,4l3 -5 2 4c3,-3 1,-2 3,-3 5,-4 -1,4 1,-1 1,-2 2,-4 1,-5 1,1 0,0 -1,4l-4 -3c-3,0 2,-3 -2,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil121",
    d: "M295 1380c-2,-3 -2,-3 -2,-6 0,0 -11,-36 -12,-40 -2,-2 -3,-10 -6,-16 -4,-6 -4,-11 -6,-16l-2 -2c-2,1 -1,0 -2,2 0,2 0,1 1,4 0,4 1,6 -1,10 -4,-3 -2,-2 -3,-4l-1 -3c0,0 0,0 0,-1 -1,-4 0,-6 -1,-11l-1 -2c0,0 0,-1 0,-1 0,-1 1,-1 2,-1l-5 -2 1 4 -6 -2 0 1c3,7 12,30 12,36l10 19c3,-2 -3,2 3,-1l-4 -13c-1,-4 0,-2 3,-6 0,5 14,34 15,45 0,2 -1,4 -1,8 1,6 2,3 -2,7 -2,-6 0,-5 0,-9 -2,3 1,2 -4,1l3 11c1,-2 1,-1 2,-2l4 -2 0 5 3 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil122",
    d: "M253 1608l0 -3 -1 -5c0,-6 -2,0 -2,-7 2,-2 0,-1 4,-2 1,-7 -1,-11 0,-18 -13,5 0,10 -11,9 3,-5 4,-1 3,-6 -7,4 -2,3 -13,3 -1,2 -1,5 -5,6 -2,0 -4,-1 -8,-1 -2,4 2,0 -2,4 1,1 4,1 4,1l4 4c3,3 2,6 2,10 11,3 4,5 11,5l2 0c2,-9 -5,6 -4,-9 9,1 2,0 7,4 3,3 5,3 9,5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil122",
    d: "M256 1545l-14 2 0 1c-2,4 -3,4 -6,7l11 -1c9,1 3,4 13,4l0 4c4,-1 2,-3 7,-5 -1,-6 -2,-5 -3,-7 0,0 2,-1 0,-5l-8 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil123",
    d: "M294 1343l-3 1c1,-7 -1,-5 0,-11 1,-6 1,-4 0,-10 2,2 2,2 5,3 1,-9 1,-6 -2,-7 0,-1 -1,-1 -1,0 0,0 0,0 0,0 1,-5 0,-2 3,-4 2,3 0,4 2,4 6,0 -3,-3 2,0l1 4c0,-1 0,-1 0,-1 1,0 3,-1 5,-2l1 3 0 0 -1 -4c0,0 0,0 0,0l-2 -3 -2 5c-3,-15 2,-6 -1,-18l-3 0c0,0 0,0 0,0l-4 0c-6,-3 -6,-3 -6,5l-1 -6c-2,6 0,1 -7,2 -2,-6 2,0 0,-5 -3,2 2,0 -2,0 0,0 -1,0 -2,0 0,1 0,1 0,1 0,0 0,1 0,1l-1 5c0,-2 0,-1 0,-4 -1,-4 -1,0 -2,-6l-4 0 0 6c2,5 2,10 6,16 3,6 4,14 6,16 3,-4 -1,-3 2,-3 6,0 2,0 4,8 2,7 0,-6 1,2 0,0 -1,11 3,10l3 10c5,-6 0,-4 0,-8 0,-3 3,-5 0,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil124",
    d: "M249 1614c1,0 1,0 1,0l5 -4c-2,-1 -1,0 -2,-2 -1,1 -5,1 -6,2 -3,1 -3,0 -3,2 -1,2 -9,0 -11,0 -4,-2 -1,-1 -3,-5 -7,-2 -9,1 -11,-5 6,3 2,1 9,1 0,-4 1,-7 -2,-10l-4 -4c0,0 -3,0 -4,-1 4,-4 0,0 2,-4 4,0 6,1 8,1 4,-1 4,-4 5,-6 11,0 6,1 13,-3 1,5 0,1 -3,6 11,1 -2,-4 11,-9l0 0 -1 -4c-7,1 -11,5 -18,5 -7,0 -7,0 -12,3 -4,2 -7,3 -11,5 -1,1 -8,6 -10,8 8,-3 1,-5 10,-3 0,5 -2,-2 -1,6 0,4 -1,3 0,7 2,-6 3,-3 6,0 -1,3 2,1 -8,6l2 4c4,0 6,-1 9,2 0,2 2,2 -6,4 -1,-1 -3,-5 -4,-5 0,0 0,0 -2,-1 -11,-5 -3,-3 -11,-6 1,6 1,4 3,9 1,0 3,1 4,2 3,0 4,0 7,1l12 2c6,-4 2,0 4,-6 12,3 5,0 12,2 7,1 7,-2 10,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil124",
    d: "M146 1740c0,-4 -1,-5 -5,-7 -4,-1 -6,-3 -10,-3 1,10 6,14 6,22 1,1 0,3 3,1 4,-2 1,-6 1,-11l2 0c3,-1 2,-1 3,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil124",
    d: "M294 1626l4 -4c-9,2 -17,3 -25,6 7,2 6,5 11,4l8 -4c0,0 0,0 1,0 1,-1 0,1 1,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil125",
    d: "M294 1520c-7,-4 -23,-2 -32,-3 -3,3 -38,9 -38,9 -4,4 -2,1 -6,6 4,-2 6,-4 11,-4 4,-2 4,-2 7,0l1 1c3,-3 0,-2 6,-4 6,-2 6,-1 10,-1l-12 5 8 0c-3,7 -7,3 -13,6 1,1 -2,4 8,1 5,-2 3,-1 9,-2 2,-5 1,-4 -1,-8 5,0 2,-1 9,3 2,1 -1,-3 2,1 -2,2 -5,3 -7,2l1 4c-6,0 -3,0 -6,2 12,-1 22,-2 34,-2 12,1 18,4 29,7 2,1 -1,-3 -5,-5 -1,0 0,1 -3,-1l3 -2c0,0 0,-1 0,-1 -12,-7 -26,-7 -32,-10 0,0 -1,0 -1,0 0,0 -1,0 -3,-3l2 -1c7,-2 10,3 19,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil125",
    d: "M62 1745c-6,-7 -4,-5 -11,-9 6,-4 23,-7 29,-13l-2 -4 -4 0c0,0 -1,0 -1,0 -5,1 -23,7 -29,9 -11,4 -22,4 -33,7l0 4c5,-2 3,-2 7,0 0,3 0,2 -2,4l21 -4c-2,-1 -2,2 -1,-2 9,-2 2,-3 8,1l12 7c5,3 2,1 6,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil125",
    d: "M215 1734l-9 0 -3 3 4 3c4,0 7,0 9,-3l-1 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil126",
    d: "M364 1769l-11 -3c-2,1 0,1 -3,0 0,0 -2,-2 -2,-2 -3,-2 -2,-1 -4,-4 3,5 1,1 2,6 1,4 2,3 3,4 0,1 0,1 1,1l-2 2c0,0 0,1 0,1l8 -1c-2,2 -2,2 -1,4 9,0 7,-3 8,-4 -4,-3 -4,0 -7,-4 4,1 5,2 8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil126",
    d: "M53 1499c-4,-2 -3,-4 -11,-3l-2 5 7 6c3,-3 0,-1 3,1 1,-6 1,-2 0,-8l3 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil126",
    d: "M356 1450l-13 -3c-2,6 1,-1 -2,2 -1,1 -1,-1 -2,2 0,5 3,5 6,5 3,-5 1,0 4,-5 0,0 0,-1 0,-1 0,0 0,0 1,0l6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil127",
    d: "M309 1350c4,2 2,1 3,3 0,0 0,1 0,1l1 4c-1,5 1,0 -6,8 0,0 -1,0 -1,0 -4,-5 -4,3 -8,-3 -4,-8 4,-1 1,-11 3,1 6,3 6,-1 2,2 -1,5 4,4 2,-3 0,-1 0,-5zm11 7c0,-4 1,-15 2,-19 -4,1 -1,-1 -5,2 3,-7 -2,-1 8,-3 -2,-3 -2,-3 -6,-4 3,-4 2,-2 2,-8 -6,3 -4,0 -9,6l7 -1c-1,4 0,8 -6,6 -5,0 3,1 -8,-4 2,-4 2,-2 4,-2 6,0 -3,4 1,-1 -4,-5 4,0 -3,-3 4,-4 -1,-2 3,-1 2,0 1,1 1,2l0 -4c0,0 0,2 -4,0l0 0 -3 5c-2,0 -2,-1 -4,3 -3,6 1,4 -6,5 1,5 3,5 0,7 3,5 0,7 0,10 0,4 5,2 0,8l-3 -10c-4,1 -3,-10 -3,-10 -1,-8 1,5 -1,-2 -2,-8 2,-8 -4,-8 -3,0 1,-1 -2,3 1,4 12,40 12,40l1 -5c1,0 1,-2 2,3 0,-1 1,-4 2,-4 2,-3 0,-1 3,-2 1,2 1,2 0,5 1,-2 1,-3 2,0 2,3 1,1 1,4l-3 -1 -4 6c13,-4 17,-14 23,-23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil127",
    d: "M318 1756l-1 -7 -5 1 0 5c0,6 -1,9 -6,12 -1,-6 0,-7 0,-11 0,-3 -1,-6 -1,-10 0,0 0,0 -1,-1 0,-1 -1,-2 -1,-7 0,-4 1,-4 1,-9l5 4c1,0 1,1 1,1 6,3 3,-3 5,3 3,-2 3,1 3,-2 0,1 -1,1 3,2 2,2 0,2 2,1 0,-6 -3,-5 -8,-7 -3,-1 -6,-4 -10,-5l-2 1 -2 -6 -6 -1c2,2 -2,1 3,2 5,1 2,6 2,10 -1,4 -1,8 -1,13l-3 2c2,1 2,0 3,5 0,3 0,3 0,7 -4,-2 -3,-3 -6,-7l-5 -9c-3,-5 -3,-9 -4,-14 -4,-3 0,-2 -4,-3 3,-11 -1,-4 -2,-15 8,3 2,3 7,5 2,1 1,1 3,1 2,1 4,0 5,-1 -8,-3 -8,-3 -13,-10 -4,0 -1,0 -4,4 -1,13 10,49 24,55 4,4 2,2 6,5l6 -5 3 7c0,-1 1,-1 1,-1 0,-1 0,-1 0,-1l1 -2c2,-1 -4,-1 0,1l1 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil127",
    d: "M350 1471l-4 -7c-1,2 0,2 -2,2 -3,-5 0,-2 -3,-4 -5,4 -1,0 -5,6 2,4 7,6 11,8l3 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil128",
    d: "M101 1714c1,-5 3,-6 6,-8 4,-1 14,-12 15,-16 -5,2 -1,2 -6,1 3,-5 1,0 1,-6l5 -2c1,5 0,4 3,6l14 -17 -2 -2 1 -5 0 -1c-3,-2 -2,-1 -3,-4 -1,-2 0,-1 -2,-2 -3,-2 -3,-1 -5,-1 -9,-2 -2,-1 -5,-6l-6 5c-4,15 4,23 -7,38l-4 2c-2,-4 0,-4 0,-10l-1 -6 -8 -1c1,7 3,10 1,17 -1,6 -4,9 -5,12 1,6 4,-1 1,5 1,2 -1,2 2,1l5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil128",
    d: "M99 1668c6,2 3,-4 5,1 0,1 1,0 1,1l-3 6c-4,0 -8,-8 -8,-11 3,1 3,1 5,3zm7 -2c0,-3 -1,-8 -4,-10 -1,1 -1,2 -2,3l-1 1c-1,1 -1,1 -1,1l-4 0 -2 -4c-1,2 -3,5 -3,7 0,0 8,14 8,15l8 1 1 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil128",
    d: "M141 1713l-8 -1 -2 -3c2,-2 5,-5 7,-8l2 -2 -2 0 -14 8c0,7 -1,0 -4,6 11,-1 15,6 25,6l4 -7c-1,1 -5,3 -8,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil128",
    d: "M209 1559c2,-7 5,-6 3,-12 -2,4 -6,5 -10,7 -1,2 -3,3 -6,4l0 1c1,4 2,2 -1,6 4,-1 0,0 3,-2 2,-1 2,-1 4,-2 2,-1 4,-2 7,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil129",
    d: "M253 1337c1,-7 3,-6 3,-9l0 0c-5,-4 -2,-11 -10,-8 -4,2 2,1 -2,1 -3,0 -1,0 -3,-2 -1,4 0,3 -2,3l0 -2c-2,1 -2,-1 -1,2 -1,-7 -7,-16 -4,-26 1,-1 1,-1 1,-1 0,-1 0,-1 0,-1l1 7c1,6 -1,4 4,8l-2 -18c5,1 3,-2 4,4l-1 -6c-3,0 -1,1 -3,1 -3,0 -1,0 -3,-1 -8,-1 -4,-2 -6,-2 -2,6 -1,-2 -5,9 0,0 1,1 1,1 0,0 0,1 1,1 0,0 0,1 1,1 1,9 7,26 11,32 7,3 2,3 7,9 2,-4 1,-6 0,-10 4,2 2,6 6,10 2,-3 2,1 1,-6l1 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil129",
    d: "M199 1306l2 0c1,-4 2,-4 2,-4 1,-1 0,0 0,0l0 1c3,-2 3,-2 5,-5l-14 -1 -4 0 -3 6 3 0 -3 1 -1 4c4,-1 2,1 7,-1 5,-1 0,-2 6,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil129",
    d: "M211 1343c11,-3 7,-3 8,-8 -4,1 -5,0 -7,3l-1 2c0,0 0,1 0,1l0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil129",
    d: "M74 1503l-2 1 0 3c4,1 4,-1 6,2l2 -5c-4,-3 -1,-2 -6,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil130",
    d: "M308 1575l-1 0c-5,-1 -8,-4 -12,-1 0,3 1,3 5,6 -2,1 -4,4 -6,6 -3,-2 -2,-5 -4,-3 -6,6 7,5 9,5 1,0 5,1 5,1 4,1 4,2 5,3 3,4 2,1 3,7l-10 3c-5,4 -4,0 -9,2 -1,3 8,1 13,3 2,-2 6,-4 8,-7 6,-6 5,-10 3,-18 -4,-9 -5,-1 -9,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil130",
    d: "M284 1591c-1,-6 -1,-1 2,-7l-7 -4c0,0 1,-1 1,-3l-7 -2c-2,0 -6,0 -9,0 2,6 3,4 4,11 1,5 3,5 4,10l5 0 2 -1c-2,-7 -1,0 -3,-4 4,-2 4,-1 8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M307 1307c4,-4 -1,-1 2,-1l4 3c1,-4 2,-3 1,-4 1,1 0,3 -1,5 -2,5 4,-3 -1,1 -2,1 0,0 -3,3l-2 -4 -3 5c-1,-3 -1,0 0,-4 1,-5 -1,-4 3,-4zm15 17c-5,0 -3,0 -7,-2 2,-4 -1,-1 3,-2 0,0 2,0 2,0 -3,-3 -3,-1 -3,-5 3,-1 1,-2 4,1 1,0 0,0 1,1 4,6 3,0 3,5 -4,3 0,-2 -3,2zm40 23c4,-2 7,-6 7,-11 -3,-7 -33,-22 -41,-26 -12,-6 -8,-7 -24,-10 -10,-1 -21,-3 -31,-4 1,6 1,2 2,6 0,3 0,2 0,4l1 -5c0,0 0,-1 0,-1 0,0 0,0 0,-1 1,0 2,0 2,0 4,0 -1,2 2,0 2,5 -2,-1 0,5 7,-1 5,4 7,-2l1 6c0,-8 0,-8 6,-5l4 0c0,0 0,0 0,0l3 0c3,12 -2,3 1,18l2 -5 2 3c0,0 0,0 0,0l1 4c4,2 4,0 4,0l0 4c0,-1 1,-2 -1,-2 -4,-1 1,-3 -3,1 7,3 -1,-2 3,3l2 2c5,-6 3,-3 9,-6 0,6 1,4 -2,8 4,1 4,1 6,4 -10,2 -5,-4 -8,3 4,-3 1,-1 5,-2 3,2 3,3 2,7l0 -6c1,1 2,2 3,3 0,-6 -2,-8 -4,-10 -3,-4 -1,1 -2,-4 4,-3 -4,0 2,0 4,0 -2,3 2,0 -2,-4 -3,0 -3,-4l5 1c0,-1 -1,-3 5,-2l1 -6c6,10 4,9 5,12l3 -8c1,2 0,4 3,8 3,5 0,2 4,-1 1,5 1,3 -1,8 4,-4 1,-3 5,-3 0,4 -2,4 -1,10 -3,1 1,-2 -5,3 -3,3 1,4 -4,4l-2 3c0,0 0,0 1,0l2 0c1,0 0,5 0,7 4,3 6,-4 6,-5l2 4c3,3 0,1 3,5 0,-12 9,-19 3,-15l5 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M139 1536l8 -2c0,1 1,1 1,1l2 6c-5,1 0,3 -7,1 -6,-1 -4,1 -4,-3 -2,2 -3,3 -6,1 2,-5 0,1 2,-2 4,-6 -2,-3 3,-7 5,2 0,-4 2,2 0,0 1,0 1,1 0,0 -2,2 -2,2zm5 16c3,-1 2,1 -2,-5 1,-1 0,0 3,-2 0,0 1,0 1,0 2,0 0,0 2,0 5,1 -2,2 2,0 2,-4 10,-6 15,-9l2 -6c-1,0 -1,-1 -1,-1 -26,0 -17,2 -28,-10l-9 -7c-2,3 2,13 2,19l-13 1 1 3c3,-3 2,-2 4,-1 2,0 3,0 5,1 -2,3 -1,2 -6,2l0 2 8 4 -1 4c3,0 1,-1 3,1l0 7c5,-3 7,-4 12,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M202 1477c12,0 57,-29 64,-39 -7,3 -7,3 -12,8l0 -5c-6,3 -20,14 -30,18 -6,3 -29,13 -32,15l-2 6c3,-1 4,-1 5,0 0,0 0,0 1,0l3 -5 3 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M323 1818c2,-10 3,-12 4,-22l27 -2c6,0 5,-2 9,2 0,-6 0,-1 1,-3 2,-3 0,3 2,-2l-3 -2 -14 -1c-6,0 -10,0 -15,1 -3,-4 0,-3 -4,-4 0,0 -1,0 -1,-1l-3 -1c-1,0 -4,-1 -5,-1 2,3 3,6 2,9l6 2c-1,1 -1,1 -4,2 0,21 -9,25 -5,50 3,-2 2,-3 1,-8 0,-2 0,-4 0,-6 0,-5 1,-9 2,-13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M199 1306c-6,-1 -1,0 -6,1 -5,2 -3,0 -7,1l1 -4 -23 11c-1,7 -1,1 -3,7l2 1c6,0 12,-5 18,-8l18 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M187 1303l3 -6c-9,1 -26,2 -34,5l-1 4 1 2c5,-1 11,-3 15,-4 5,0 12,1 16,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M170 1440l-6 1 -1 2 -6 -1c0,6 -1,4 3,6l6 0c2,-3 0,-1 2,-2 2,-1 0,1 2,-1 2,-3 1,-3 0,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M75 1535l3 -7 2 -10 -3 -2 -2 7c-1,7 -3,4 -5,13 5,-1 2,0 5,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil131",
    d: "M225 1436c1,-3 0,-2 1,-4 -2,-2 2,-2 -4,0 0,0 0,0 0,0l-16 9 19 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil132",
    d: "M272 1368c0,0 -3,-1 -3,-1 4,-8 -3,-9 -3,-9 -5,0 2,-1 -3,1l-7 -13c0,0 -1,-4 -1,-4 -1,4 -1,10 1,14 0,0 2,1 0,6 0,-4 -2,-9 -4,-12l-1 -1c0,-1 -2,-3 -2,-3l-1 6c0,-3 0,-3 1,-5 0,0 0,-1 0,-1l0 -1c0,0 1,-2 1,-3 -5,-2 -3,0 -4,3 -1,-6 -2,-4 6,-5l1 -3 -1 -3c1,7 1,3 -1,6 -4,-4 -2,-8 -6,-10 1,4 2,6 0,10 -5,-6 0,-6 -7,-9l3 13 5 15 7 16c6,3 2,4 6,9l1 -6c1,2 1,3 2,4l2 2c0,0 0,0 0,0 0,0 0,1 0,1l1 1c2,4 2,3 4,6 3,6 -2,3 0,11 3,-3 1,-5 3,-6l2 4c2,-6 3,-3 3,-3l0 9c5,-2 1,-3 2,-8 1,-3 3,-4 1,-6 -2,-3 1,-1 -2,-1l-2 1c4,-12 -2,-9 -3,-13 -4,-8 -4,-9 -1,-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil132",
    d: "M266 1438l4 -4c2,-4 3,-7 4,-10 2,-5 0,-7 2,-13 0,0 -1,0 -1,0 -2,-7 1,3 -3,-2 -2,-3 -1,-4 -1,-7 -3,3 -1,-2 -3,4 -2,6 0,2 0,4 2,3 2,3 1,6l-3 -7 -3 1 -13 2 -4 0c-1,1 1,0 -2,1 0,0 -2,1 -2,1 -2,0 -4,1 -6,1 -8,2 -25,5 -32,5l-1 1c-4,3 -1,0 -3,3 1,1 -1,1 3,2l56 -10 -22 10 -2 5c6,-1 10,-4 16,-6l12 -5c0,7 -16,11 -20,16 -1,2 -3,3 -3,6l7 -3c8,-1 18,-14 23,-15l-2 6c3,0 1,-1 3,1l-6 6c-1,-2 -3,3 -1,-3l-10 7 0 5c5,-5 5,-5 12,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil132",
    d: "M335 1353l3 2c2,-5 1,-2 1,-6 0,-3 -3,-1 2,-5l1 6c5,0 1,-1 4,-4 0,0 -4,0 -1,-3 1,-1 4,-2 4,-2 -4,-6 1,-5 -6,-3l2 -7c-3,2 -2,2 -3,5l-1 -4c-3,6 -4,-1 -4,8l-2 -2c0,0 0,0 0,0 -3,-3 2,0 -2,-1 0,0 -1,0 -1,0l-3 0c1,-3 2,-6 2,-11 -2,4 0,4 -5,6l1 -7 -5 -1c0,4 1,0 3,4 -4,3 2,0 -2,0 -6,0 2,-3 -2,0 1,5 -1,0 2,4 2,2 4,4 4,10l4 -2c3,2 0,1 0,3l3 5c-3,2 -6,3 -10,3l0 -6c1,-4 1,-5 -2,-7 -1,4 -2,15 -2,19 6,-1 9,-4 15,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil132",
    d: "M239 1386c-7,0 -19,-3 -14,9l1 1c9,0 13,-1 13,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil132",
    d: "M331 1368c0,4 -1,3 -2,8l4 0 -1 2c0,0 0,0 0,0 3,-3 2,-1 2,-5 2,5 2,3 3,4 1,-8 0,-3 4,-8l-2 -5c-1,1 0,0 -1,2l-1 0c-6,2 1,3 -5,8 1,-7 1,-5 -1,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil132",
    d: "M185 1446l2 0c5,-4 4,0 5,-7l-7 1 0 6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil133",
    d: "M309 1592c-1,-1 -1,-2 -5,-3 0,0 -4,-1 -5,-1 -2,0 -15,1 -9,-5 2,-2 1,1 4,3 2,-2 4,-5 6,-6 -4,-3 -5,-3 -5,-6 4,-3 7,0 12,1 -1,-3 -4,-3 -8,-4 -4,0 -10,-1 -12,-4 -12,0 -45,-1 -52,7 7,0 11,-4 18,-5l1 4c6,-6 4,-1 10,2 3,0 7,0 9,0l7 2c0,2 -1,3 -1,3l7 4c-3,6 -3,1 -2,7l1 3c4,1 6,3 10,3 1,0 10,-1 12,-1l-1 -3 3 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil140",
    d: "M253 1656c2,-1 3,-1 6,-2l-1 -2c-6,-3 -11,3 -28,-2 -1,0 -2,0 -4,-1 -4,-3 -1,0 -3,-3l7 -1c0,-4 1,-1 -1,-2 -5,2 -16,-3 -21,-4l1 3 -3 -1c2,4 10,5 16,8 -4,5 -4,1 -5,5 1,2 3,3 6,3l7 1c-2,-6 -1,-2 -6,-5 1,-1 0,-3 7,-1 10,3 8,2 16,2 6,0 4,0 6,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil141",
    d: "M238 1331c-4,-6 -10,-23 -11,-32 -3,2 -1,0 -4,4l0 1 3 1c-3,4 -2,-1 -2,5 2,2 2,1 2,5 0,4 3,5 3,11 1,5 1,7 3,12l1 -1c2,3 2,3 4,5 2,1 0,0 4,2l-3 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil142",
    d: "M239 1320l0 2c2,0 1,1 2,-3 2,2 0,2 3,2 4,0 -2,1 2,-1 8,-3 5,4 10,8 0,-11 -1,-17 -4,-27l-2 2c0,1 0,1 0,1 0,0 -1,3 -1,4 -2,5 -2,1 -1,8 -4,-3 -1,-3 -5,1l-1 -6c0,0 0,1 0,1 0,-1 0,2 -4,5 0,0 0,0 -1,1 1,0 1,1 2,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil144",
    d: "M298 1722c-5,-1 -1,0 -3,-2l0 1 -12 -1c-1,8 0,0 1,5 1,2 1,-2 1,2l-1 2 2 2c2,-2 1,-2 1,-4l12 0c1,0 1,0 1,-1 0,-1 0,-2 -2,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil147",
    d: "M261 1645c-4,0 -9,1 -13,0 -5,-1 -6,-2 -9,-6l-3 1 -1 0 -1 6c5,2 9,1 14,1 6,0 9,1 13,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil148",
    d: "M344 1617l-1 4c0,0 1,2 0,0 -1,-2 0,-1 0,-1 -1,9 2,9 -5,18 -4,4 -3,1 -5,6l3 0c4,-3 6,-7 8,-11 2,-4 4,-14 0,-16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil150",
    d: "M191 1343l0 -1 2 -3c-15,5 -7,4 -17,-2l-3 -1c2,4 2,6 7,7 6,1 7,2 11,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil151",
    d: "M222 1395c-2,-2 -2,5 -2,-1 -5,12 -1,2 -3,15 4,-3 2,-3 4,-5 0,0 0,0 0,0 4,-5 3,2 3,-6 1,1 1,1 1,1l1 1c-3,-4 -1,3 -4,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil153",
    d: "M229 1434l2 0 3 -3c1,-2 0,0 1,-3 -1,0 -1,0 -2,0 -1,0 -2,1 -3,1 -5,2 -5,4 -1,5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil154",
    d: "M166 1529c0,0 0,1 1,1l-2 6c5,-2 9,-3 6,-7l-5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil155",
    d: "M88 1588l-3 2 -2 -4 0 10c5,-1 5,-3 5,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil156",
    d: "M314 1645c-1,2 -1,3 -3,5l-3 -1c0,2 -2,3 -1,7l2 -3c3,1 1,1 4,-1l1 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil157",
    d: "M169 1335l-1 -2c-3,1 -3,1 -3,4 3,3 -1,2 3,3 1,-2 2,-2 1,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil161",
    d: "M330 1622c1,-4 1,-1 -2,-2l-1 0 0 2 -1 3 3 -1 1 -2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil162",
    points: "334,1602 332,1599 329,1603 329,1604 331,1604 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil164",
    d: "M337 1605c-2,-3 -1,-2 -3,-3l-3 2c4,2 3,2 6,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil167",
    d: "M85 1508c-6,-3 -4,0 -4,0l3 3c-1,-3 2,-2 -1,-3l2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil168",
    d: "M139 1759c2,3 0,2 2,3 2,2 -1,0 3,2 -3,-4 -1,-3 -5,-5z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "fil169 str0",
    points: "9,12 372,12 372,1948 192,1771 9,1948 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBerisfordsHocusPocus);
export default __webpack_public_path__ + "static/media/berisfords-hocus-pocus.03fb8f6cee53672b5a94f85b789212ab.svg";
export { ForwardRef as ReactComponent };